/* eslint-disable no-undef */
/* eslint-disable no-constant-condition */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
/* eslint-disable react/no-unescaped-entities */
import { Fragment, useCallback, useEffect, useState } from 'react';
import React from 'react';
import { BrowserRouter as Router, Link, Route, Routes, useNavigate, useLocation } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';
import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Grid, Paper, Box, Typography, Button, FormControlLabel, Checkbox, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import './Accounts.scss';
import { REQUEST_ACTIONS, sendRequest, setCookie, getCookie } from '../../utils/Communicator';
import { useDispatch, useSelector } from 'react-redux';
import { getAdditionalCostForCalc, getShippingRequest, validateCompanyName, validateMyId, repackParcel, rescanParcel, getBuyMeRequestsByStatuses, addBuyMeRequest, consolidateParcels, listWarehouse, getTopNHotStore, copyToClipboard1, getCouponList, get_params, getShippingRequestList, downloadByUrl, downloadParcelImage, downloadScanImage, getRepackRequest, getETAStatus } from '../../reducers/requestHandler';
import { setSelectedShipping, setShipping_list, setIsShippingLoading } from '../../reducers/user-reducers/UserSlicer';
import { snackbarToggle } from '../../reducers/snackbarSlicer';
import Loader from '../../style-guide/Loader';
import { URL, autoCloseSnackbar, weightAndVal } from '../../constants/global-constants';
import { Dialog, Snackbar, MultilineField } from '../../style-guide';
import { TextField, SelectField } from '../../style-guide';
import SearchIcon from '@mui/icons-material/Search';
import PersonalDetails from '../Personal/PersonalDetails';
import SecondPayment from '../Personal/SecondPayment';

import CookieConsent from "react-cookie-consent";

import contactTitle from '../../images/title/contact-title.jpg'
import account_banner from '../../images/homepage/account_banner.png'
import flag_tr_small from '../../images/homepage/flag_tr_small.png'
import flag_po_small from '../../images/homepage/flag_po_small.png'
import flag_eu_small from '../../images/homepage/flag_eu_small.png'
import flag_us_small from '../../images/homepage/flag_us_small.png'
import prevArrow from '../../images/homepage/prev-arrow.png'
import nextArrow from '../../images/homepage/next-arrow.png'
import LocMarker from '../../images/homepage/pin.png';
import coupon_bg from '../../images/account/coupon_bg.png'
import woman_jumping from '../../images/account/woman_jumping.png'
import address from '../../images/account/address.png'
import address1 from '../../images/account/address1.png'
import trophy from '../../images/account/trophy.png'
import cashback from '../../images/account/cashback.png'
import correct from '../../images/account/correct.png'
import correct_dis from '../../images/account/correct_dis.png'
import copy from '../../images/account/copy.png'
import price_tag from '../../images/account/price_tag.png'
import packagePng from '../../images/account/package.png'
import info_24 from '../../images/account/info-24.png'
import info_26 from '../../images/account/info-26.png'
import package_recieved from '../../images/account/package_recieved.png'
import payment_pending from '../../images/account/payment_pending.png'
import shipment_started from '../../images/account/shipment_started.png'
import delivery_started from '../../images/account/delivery_started.png'
import target from '../../images/account/target.png'
import location from '../../images/account/location.png'
import media_markt from '../../images/account/media_markt.png'
import sephora from '../../images/account/sephora.png'
import { clearSessionData } from '../../reducers/user-reducers/UserSlicer';
import woman_bg from '../../images/account/woman_bg.png'
import woman_with_money from '../../images/account/woman_with_money.png'
import chrome_bg from '../../images/account/chrome_bg.png'
import amazon from '../../images/account/amazon.png'
import googleChromeIcon from '../../images/account/google-chrome-icon.png'
import { FaWindowClose, FaAngleUp, FaCamera } from "react-icons/fa";
import CloseIcon from '@mui/icons-material/Close';
import ActionButton from '../Common/ActionButton';
import DialogWithSideBar from '../../style-guide/Dialog/DialogWithSideBar';

import store_middle_button from '../../images/store/store_middle_buton_img.png'
import top_back from '../../images/top_back.png'
import MetaTags from 'react-meta-tags';

import {  FaCheck, FaWifi, FaAngleDown } from "react-icons/fa";
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import file from '../../images/file.png';
const currencies = [/*{ id: 1, name: "$ דולר", symbol: "$" },*/ { id: 2, name: "€ אירו", symbol: "€" }/*, { id: 3, name: "£ פאונד", symbol: "£" }, { id: 4, name: "₺ לירה טורקית", symbol: "₺" }*/];

export const Accounts = (props) => {
    const { isBuyMePayment, setIsPersonal, setActiveScreenInreg, setIsRegister, setIsLogin, setIsAddAddress, setIsProfile, setIsBuyMePayment } = props;
    const { userInfo, innerContent, shipping_list_count, shipping_list, isShippingLoading } = useSelector(state => state.user);
    const { snackbar } = useSelector(state => state.snackbar);
    const navigate = useNavigate();
    const onSnackbarHandleClose = () => dispatch(snackbarToggle(false));
    const { couponList, setCouponList } = props;
    // const  = {props}
    const isMobile = () => /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    const [storeList, setStoreList] = new useState([]);
    // const [couponList, setCouponList] = new useState([]);
    const [userName, setUserName] = new useState("");
    const [password, setPassword] = new useState("");
    const [session, setSession] = new useState(getCookie("SESSION_ID"));
    const [parcelImage, setParcelImage] = new useState("");
    const [isEnable, setEnabled] = new useState(true);
    const [isConsolicationCheckboxEnable, setConsolicationCheckboxEnabled] = new useState(false);
    const [isPackageLoaded, setPackageLoaded] = new useState(false);
    const [isHistory, setIsHistory] = new useState(isMobile());
    const [tabIndex, setTabIndex] = new useState(1);
    const dispatch = useDispatch();
    const failedCallback = useCallback(message => dispatch(snackbarToggle({ type: 'error', message })), [dispatch]);
    const [isLoaded, setIsLoaded] = useState(true);
    const [isDialog, setIsDialog] = useState(false);
    const [selectedStore, setSelectedStore] = new useState({});
    const [bSideWindow, setBSideWindow] = new useState(false);
    const [allWh, setAllWh] = new useState([]);
    const [serviceOptions, setServiceOptions] = new useState([{ id: 0, name: "" }, { id: 1, name: "אריזה מחדש" }, { id: 2, name: "סריקת חבילה" }]);
    const [serviceOption, setServiceOption] = new useState(0);
    const [serviceParcel, setServiceParcel] = new useState({});
    const [parcelSearch, setParcelSearch] = new useState("");
    const [search, setSearch] = new useState("");
    const [freeRepack, setFreeRepack] = new useState(false);
    const [freeRepack2, setFiveRepack] = new useState(1);
    const [repackFreeText, setRepackFreeText] = new useState("צמצום נפח חבילה לשקית שילוח– שירות זה כרוך בתשלום של 5$");
    const setFreeRepack1 = (data) => {
        setFreeRepack(data);
        setFiveRepack(!data);
    }
    const setFreeRepack2 = (data) => {
        setFiveRepack(data);
        //setFiveRepack(!data);
        switch (data) {
            case 1:
                setRepackFreeText("צמצום נפח חבילה לשקית שילוח– שירות זה כרוך בתשלום של 5$");
                break;
            case 2:
                setRepackFreeText("צמצום נפח חבילה לקופסת קרטון– שירות זה כרוך בתשלום של 5$");  
                break;
            case 3:
                setRepackFreeText("צמצום נפח חבילה המכילה אופנה לשקית שילוח – ללא עלות");
                break;
            case 4:
                setRepackFreeText("הוספת אריזת מגן (ניילון פצפצים וקרטון נוסף אם יש צורך) – בעלות של 8$");
                break;
            case 5:
                setRepackFreeText("אריזה מחדש לקרטון חיצוני קטן יותר שיש במחסן -5$");
                break;
            case 6:
                setRepackFreeText("נעליים: צמצום נפח ללא קופסת ");
                break;
            case 7:
                setRepackFreeText("הנעליים לשקית שילוח (ללא עלות)");
                break;
            case 8:
                setRepackFreeText("הוספת אריזת מגן (ניילון פצפצים וקרטון נוסף אם יש צורך) –בתשלום של 8$");
                break;
            default:
                break;
        }
        
    }
    const onHoldReasons = ["אריזה פגומה", "חבילה ריקה", "מוצר פגום", "אסור להטסה", "אסור לייבוא", "אביזרי נשק", "סוללת ליתיום", "אחר"];
    const consolidationRejections = ["מגבלת מידה", "מגבלת משקל", "איחוד שביר/רגיש", "לא אותה חשבונית", "אחר", "", "", "בטריה", "גדול מדי לשקית (או לא מתאים לשקית?)", "מוצר אסור להטסה", "בקשת לקוח"]
    const repackRejections = ["מגבלת מידה", "מגבלת משקל", "מוצר שביר/רגיש", "הגיעה בשקית שילוח", "חבילה מאוחדת", "לא אופנה", "אחר", "קרטון נוכחי מלא", "לא תואם לקרטון קטן", "בטריה-רק קרטון יצרן", "מוצר אסור להטסה", "בקשת לקוח"]
    const onSelectService = (val, serviceParcel) => {
        checkForServiceAndOnHold(serviceParcel, function (state) {
            if (!state) {
                window.location.href = "/accounts?vers=" + (new Date()).getTime();
                return;
            }
            setServiceParcel(serviceParcel);
            if (val == 1) {
                openRepackageDlg(serviceParcel)
            } else if (val == 2) {
                openRescanDlg(serviceParcel)
            }
        });
    }
    const [openOrderModal, setOpenOrderModal] = useState(false);
    const onHandleOpenModal = (add, ind) => {
        setOpenOrderModal(true);
    };
    const onHandleCancelModal = () => setOpenOrderModal(false);

    const [openOrderCCDialog, setOpenOrderCCDialog] = useState(false);
    const onHandleOpenCCDialog = (add, ind) => {
        setOpenOrderCCDialog(true);
    };
    const onHandleCancelCCDialog = () => setOpenOrderCCDialog(false);

    const getStatusById = (sh, id) => {
        for (var i = 0; i < sh?.params?.statusLog?.length; i++) {
            if (sh?.params?.statusLog[i].id == id) {
                return sh?.params?.statusLog[i].DATE;
            }
        }
        return false;
    }
    const getStatusByLogId = (sh) => {
        return !(getStatusById(sh, 5) || getStatusById(sh, 6) || getStatusById(sh, 7));
    }
    const [openDelayedDelivery, setOpenDelayedDelivery] = useState(false);
    const onHandleCloseDelayedDelivery = () => {
        setOpenDelayedDelivery(false);
    }

    const [openInfoModal, setOpenInfoModal] = useState(false);
    const [shipmentInfo, setShipmentInfo] = useState({});
    const onHandleOpenInfoModal = (data) => {
        setShipmentInfo(data)
        //console.log(data)
        setOpenInfoModal(true);
    };
    const onHandleCancelInfoModal = () => { setOpenInfoModal(false); setParcelImage(""); }


    const [openRepackCostAcceptModal, setOpenRepackCostAcceptModal] = useState(false);
    const [openRepackConfirm, setOpenRepackConfirm] = useState(false);
    const [selectedRepackGroup, setSelectedRepackGroup] = useState(false);
    const [repackData, setRepackData] = useState(0);
    const [repackParcels, setRepackParcels] = useState([]);
    const [repackParcelsGroup, setRepackParcelsGroup] = useState([]);
    const onHandleOpenRepackModal = () => {
        var t_Arr = [];
        var whs = [];
        for (var i = 0; i < shipping_list?.length; i++) {
            if ((shipping_list[i].shippingStatus == 2 || shipping_list[i].shippingStatus == 1) && (shipping_list[i].repackStatus == null || shipping_list[i].repackStatus == 0) && !shipping_list[i].status) {
                if (getCountOfCParcels(shipping_list[i]) > 1) {
                    t_Arr.push(shipping_list[i]);
                    whs.push(shipping_list[i].warehouseId);
                }
            }
        }
        whs = whs.filter((item, index) => whs.indexOf(item) === index);
        var getP = function (wid) {
            var parcels = [];
            for (var i = 0; i < t_Arr?.length; i++) {
                if (t_Arr[i].warehouseId == wid) {
                    var x = JSON.parse(JSON.stringify(t_Arr[i]))
                    x.selected = false;
                    parcels.push(x);
                }
            }
            return parcels
        }
        var parcelsGroups = []
        for (var i = 0; i < whs?.length; i++) {
            var parcels = getP(whs[i]);
            if (parcels?.length > 1) {
                parcelsGroups.push({
                    group: whs[i],
                    parcels: parcels,
                    selected: false,
                    selectedCheckbox: false,
                    freeText: ""
                });
            }
        }
        setRepackParcelsGroup(parcelsGroups);
        setRepackageDlg(true);
    }
    const onRepackCostAcceptModal = (data) => {
        setRepackageShipment(data);
        getRepackRequest(session, data.id + "", function (data) {
            if (data.message == "Not Active Session") {
                // login again
            }
            else if (data.message == "FAIL") {
                // fail message
            }
            else if (data.message == "SUCCESS" && data?.data) {
                setRepackData(data.data);
                setOpenRepackCostAcceptModal(true);
            }
            else {
                // generic error message
            }
        })
    }

    const onHandleOpenRepackConfirm = (data) => {
        setSelectedRepackGroup(data)
        setOpenRepackCostAcceptModal(true);
    };
    const isValidForRepack = (data) => {
        var bValid = false;
        var count = 0;
        for (var i = 0; i < data?.parcels?.length; i++) {
            if (data?.parcels[i].selected) {
                count++;
            }
        }
        //if (count > 1 && data.selectedCheckbox) {
        if (count > 0) {
            bValid = true;
        }
        return bValid
    }
    const getTotalRepackCost = (data) => {
        var total = 0;
        Object.keys(data).map(key => { total += Number(data[key]) })
        return total;
    }
    const onRepackCostAcceptModelClose = () => {
        setOpenRepackCostAcceptModal(false);
    }

    const getOldOld = (notes) => {
        var separateLines = notes.split(/\r?\n|\r|\n/g);
        if (separateLines?.length == 6) {
            var wt = separateLines[2].split(" ")[3];
            return `${wt} ק״ג`;
        }
        if (separateLines?.length == 5) {
            var wt = separateLines[1].split(" ")[3];
            return `${wt} ק״ג`;
        }
        return notes;
    }
    const getOldDimes = (notes) => {
        var separateLines = notes.split(/\r?\n|\r|\n/g);
        if (separateLines?.length == 6) {
            var len = separateLines[3].split(" ")[3];
            var wid = separateLines[4].split(" ")[3];
            var hei = separateLines[5].split(" ")[3];
            return `${hei}x${len}x${wid}`;
        }
        if (separateLines?.length == 5) {
            var len = separateLines[2].split(" ")[3];
            var wid = separateLines[3].split(" ")[3];
            var hei = separateLines[4].split(" ")[3];
            return `${hei}x${len}x${wid}`;
        }
        if (separateLines?.length == 6)
            return <span style={{textAlign: "right"}}>{separateLines[0]}<br />{separateLines[1]}<br />{separateLines[2]}<br />{separateLines[3]}<br />{separateLines[4]}<br />{separateLines[5]}</span>;
        return notes;
    }

    const [repackCount, setRepackCount] = useState(0);
    const [repackIndex, setRepackIndex] = useState(0);
    const acceptRepackCost = () => {
        //dispatch(setIsShippingLoading(true));
        setRepackIndex(0);
        var count = 0;
        for (var i = 0; i < selectedRepackGroup.parcels?.length; i++) {
            if (selectedRepackGroup.parcels[i].selected) { count++ }
        }
        setRepackCount(count);
        var index = 0
        for (var i = 0; i < selectedRepackGroup.parcels?.length; i++) {
            if (selectedRepackGroup.parcels[i].selected) {
                repackParcel(session, selectedRepackGroup.parcels[i].id, selectedRepackGroup.freeText, freeRepack, function (data) {
                    index++
                    if (index == repackCount) {
                        setRepackageDlg(false);
                        setOpenRepackCostAcceptModal(false);
                        loadParcels();
                    }
                })
                
            }
        }
    }
    const [openConsolidateConfirm, setOpenConsolidateConfirm] = useState(false);
    const [selectedConsGroup, setSelectedConsGroup] = useState(false);
    const isValidForConsolidation= (data) => {
        var bValid = false;
        var count = 0;
        for (var i = 0; i < data?.parcels?.length; i++) {
            if (data?.parcels[i].selected) {
                count++;
            }
        }
        //if (count > 1 && data.selectedCheckbox) {
        if (count > 1) {
            if (count < 11) {
                bValid = true;
            }
        }
        return bValid
    }
    const onHandleOpenConsolidateConfirm = (data) => {
        setSelectedConsGroup(data)
        setOpenConsolidateConfirm(true);
    };
    const onHandleCancelConsolidateConfirm = () => setOpenConsolidateConfirm(false);
    const getCountOfCParcels = (data) => {
        var count = 0;
        for (var i = 0; i < shipping_list?.length; i++) {
            if (shipping_list[i].warehouseId == data.warehouseId) {
                count++
            }
        }
        return count;
    }
    const [expanded, setExpanded] = useState('');
    const handleChange = (panel) => (isExpanded) => {
        if (expanded === panel) {
            setExpanded(false);
        }
        else {
            setExpanded(isExpanded ? panel : false);
        }

    };

    function formatDate(date) {
        let p = new Intl.DateTimeFormat('en-GB', {
            year: '2-digit',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            // second: '2-digit',
            hour12: false,
            timeZone: 'UTC',
            // timeZoneName: "longOffset",
        }).format(date)
        return p;
    }
    function formatDateManifest(date) {
        let p = new Intl.DateTimeFormat('en-GB', {
            year: '2-digit',
            month: '2-digit',
            day: '2-digit',
            timeZone: 'UTC',
            // timeZoneName: "longOffset",
        }).format(date)
        return p;
    }
    const [expContent, setExpContent] = useState(false);
    const [consolidationParcelsGroup, setConsolidationParcelsGroup] = useState(false);
    const [openConsolidateModal, setOpenConsolidateModal] = useState(false);  
    const checkParcelForConsolidation = (sh) => {
        if ((sh.shippingStatus == 2 || sh.shippingStatus == 1) && sh.consolidationStatus != 3 && !sh.status) {
            if (!getLengthCondition1(sh)) {
                return true;
            }
        }
        return false;
    }
    const onHandleOpenConsolidateModal = (data) => {
        setFreeRepack1(true);
        var t_Arr = [];
        var rejection_Arr = [];
        var whs = [];
        for (var i = 0; i < shipping_list?.length; i++) {
            if (checkParcelForConsolidation(shipping_list[i])) {
                var cont = true;
                if (userInfo.user?.setting?.rejections?.includes(shipping_list[i].hawb)) {
                    cont = false;
                }
                if (getCountOfCParcels(shipping_list[i]) > 1 && cont) {
                //if (getCountOfCParcels(shipping_list[i]) > 1) {
                    t_Arr.push(shipping_list[i]);
                    whs.push(shipping_list[i].warehouseId);
                }
            }
        }
        whs = whs.filter((item, index) => whs.indexOf(item) === index);
        var getP = function (wid) {
            var parcels = [];
            for (var i = 0; i < t_Arr?.length; i++) {// && t_Arr[i].consolidationStatus != 101
                if (t_Arr[i].warehouseId == wid && t_Arr[i].status != 201 && t_Arr[i].status != 203 && t_Arr[i].rescanStatus != 101 && t_Arr[i].repackStatus != 101 && t_Arr[i].consolidationStatus != 1  && (!t_Arr[i].trackListOfConsolidation?.length)) {
                    var x = JSON.parse(JSON.stringify(t_Arr[i]))
                    x.selected = false;
                    parcels.push(x);
                }
            }
            return parcels
        }
        var parcelsGroups = []
        for (var i = 0; i < whs?.length; i++) {
            var parcels = getP(whs[i]);
            if (parcels?.length>1) {
                parcelsGroups.push({
                    group: whs[i],
                    parcels: parcels,
                    selected: false,
                    selectedCheckbox: true,
                    freeText: ""
                });
            }
        }
        setConsolidationParcelsGroup(parcelsGroups);
        setOpenConsolidateModal(true);
    };
    const onHandleCancelConsolidateModal = () => setOpenConsolidateModal(false);

    const [showExtraServices, setShowExtraServices1] = useState(-1);
    const setShowExtraServices = (event, data) => {
        event.stopPropagation();
        setShowExtraServices1(data);
    }
    const setShowExtraServicesHide = (data) => {
        setShowExtraServices1(data);
    }

    const [openBuyMeModal, setOpenBuyMeModal] = useState(false);
    const [numberOfUnitId, setnumberOfUnitId] = useState(1);
    const [selectedCur, setSelectedCur] = useState(2);
    const [repackService, setRepackService] = useState(1);
    const [numberOfUnits, setNumberOfUnits] = useState([{id:1,name:"1"},{id:2,name:"2"},{id:3,name:"3"},{id:4,name:"4"},{id:5,name:"5"},{id:6,name:"6"},{id:7,name:"7"},{id:8,name:"8"},{id:9,name:"9"},{id:10,name:"10"},{id:11,name:"11"},{id:12,name:"12"},{id:13,name:"13"},{id:14,name:"14"},{id:15,name:"15"}]);
    const [buyMeShops, setBuyMeShops] = useState([]);
    const [selectedBuyMeShopId, setSelectedBuyMeShopId] = useState({});
    const [buyMeInfo, setBuyMeInfo] = useState({});
    const onHandleOpenBuyMeModal = (data) => {
        setOpenBuyMeModal(true);
    };
    const onHandleCancelBuyMeModal = () => setOpenBuyMeModal(false);

    const [buyMeRequestsItems, setBuyMeRequestsItems] = useState([]);
    const getBuyMeRequestsItems = function () {
        var statuses = [1, 2, 3]
        dispatch(setIsShippingLoading(true))
        getBuyMeRequestsByStatuses(userInfo.session, { statuses: statuses }, function (resp) {
            //console.log(resp)
            setBuyMeRequestsItems(resp?.data)
            dispatch(setIsShippingLoading(false))
        })
    }
    const setNewShippingList = (data) => {
        var index = 0;
        var new_shipping_list = [];
        for (var i = 0; i < shipping_list_count; i++) {
            if (shipping_list[i].id == data.id) {
                new_shipping_list.push(JSON.parse(JASON.stringify(data)));
            }
            else {
                new_shipping_list.push(JSON.parse(JASON.stringify(shipping_list[i])));
            }
        }
        dispatch(setShipping_list(nnew_shipping_list));
    }
    const getChargeableWeight1 = function () {

        if (!shipmentInfo?.params?.userPaymentData?.weight || !shipmentInfo?.params?.userPaymentData?.length || !shipmentInfo?.params?.userPaymentData?.width || !shipmentInfo?.params?.userPaymentData?.height) {
            return ""
        }
        return Number(shipmentInfo?.params?.userPaymentData?.length) * Number(shipmentInfo?.params?.userPaymentData?.width) * Number(shipmentInfo?.params?.userPaymentData?.height) / 5000
    }
    const getChargeableWeight = function () {

        if (!shipmentInfo?.params?.userPaymentData?.weight || !shipmentInfo?.params?.userPaymentData?.length || !shipmentInfo?.params?.userPaymentData?.width || !shipmentInfo?.params?.userPaymentData?.height) {
            return ""
        }
        var twt = 0;
        var chWt = Number(shipmentInfo?.params?.userPaymentData?.length) * Number(shipmentInfo?.params?.userPaymentData?.width) * Number(shipmentInfo?.params?.userPaymentData?.height) / 5000

        if (Number(shipmentInfo?.params?.userPaymentData?.weight) > chWt) {
            twt = shipmentInfo?.params?.userPaymentData?.weight;
        } else {
            twt = chWt;
        }
        if (shipmentInfo?.params?.calculatedBasePrice) {
            if (Number(shipmentInfo?.params?.calculatedBasePrice))
                twt = Math.min(twt, Number(shipmentInfo?.params?.calculatedBasePrice));
        }
        return twt
    }

    const goTo = (e) => {
    }
    const getDateFormat = (e) => {
        var date = new Date(e);
        var dat = ((date.getDate() > 9) ? date.getDate() : ('0' + date.getDate()));
        var month = ((date.getMonth() > 8) ? (date.getMonth() + 1) : ('0' + (date.getMonth() + 1)));
        var date_formated = dat + '/' + month + '/' + date.getFullYear();
        return date_formated
    }

    const getStatusDescId = (sh) => {
        if (sh.shippingStatus == 5) {
            if (!sh.params.wsIntigration) {
                return "בדרך לארץ";
            }
        }
        var id = getStatusId(sh);
        var curLable = false;
        if (id) {
            switch (Number(id)) {
                case 4:
                    curLable = "בדרך לארץ"; // "בתהליך מכס"
                    break;
                case 5:
                    curLable = "נמסר להפצה"
                    break;
                case 6:
                    curLable = "נמסר להפצה"
                    break;
                case 7:
                    curLable = "משלוח נמסר";
                    break;
                default:
                    curLable = false;
            }
        }
        return curLable
    }
    const getStatusId = (sh) => {
        for (var i = 0; i < sh?.params?.statusLog?.length; i++) {
            if (sh?.params?.statusLog[i].DATE) {
                return sh?.params?.statusLog[i].id
            }
        }
        return false;
    }
    const getStatus2Id = (sh) => {
        for (var i = 0; i < sh?.params?.statusLog?.length; i++) {
            if (sh?.params?.statusLog[i].id==2) {
                return sh?.params?.statusLog[i]
            }
        }
        return null;
    }
    const getCSOnHoldSatus = (sh) => {
        if (getStatusId(sh) == 7) {
            return "משלוח נמסר";
        }
        else if (getStatusId(sh) == 6) {
            return "נמסר להפצה";
        }
        else if (getStatusId(sh) == 3) {
            return "בדרך לארץ";
        }
        else if (getStatusId(sh) == 2) {
            return "המשלוח בטיפול";
        }
        else if (getStatusId(sh) == 1) {
            return "תשלום";
        }
    }

    const repackCompleted = (sh) => {
        if (sh.repackStatus == 104 && (sh.params?.repackCost || sh.params?.repackCosts)) {
            var total = 0;
            try {
                if (Number.isFinite(Number(sh.params?.repackCost))) {
                    if (Number(sh.params?.repackCost) > 0)
                        return true;
                    return false;
                }
            } catch (error) {
                console.log(error)
            }
            try {
                Object.keys(sh.params.repackCosts)?.map(key => { total += ((key != undefined && key != "undefined") ? Number(sh.params.repackCosts[key]) : 0) })
            } catch (error) {
                console.log(error)
            }
            try {
                Object.keys(sh.params.repackCost)?.map(key => { total += ((key != undefined && key != "undefined") ? Number(sh.params.repackCost[key]) : 0) })
            } catch (error) {
                console.log(error)
            }
            if (total > 0) {
                return true;
            }
        }
        return false;
    }

    const rescanCompleted = (sh) => {
        if (sh.rescanStatus == 104) {
            var total = 0;
            if (sh.params?.rescanCost.length) {
                return true;
            }
            else if (Number.isFinite(sh.params?.rescanCost)) {
                if (Number(sh.params?.rescanCost) > 0)
                    return true;
                return false;
            }
            if (sh.params.rescanCost)
            /*{
                var keys = Object.keys(sh.params.rescanCost);
                for (var i = 0; i < keys.length; i++) {
                    if (sh.params.rescanCost[keys[i] + ""])
                }
            }*/
                Object.keys(sh.params.rescanCost)?.map(key => { total += ((key != undefined && key != "undefined") ? Number(sh.params.rescanCost[key+""]) : 0) })
            if (total > 0) {
                return true;
            }
        }
        return false;
    }


    const keyPressed = (e) => {
        if (e.keyCode === 13) {
            //
        }
    }
    const loadParcels = (name) => {
        //console.log("loadParcels");
        dispatch(setIsShippingLoading(true));
        var statuses = [1, 2, 3, 4, 5, 6, 601, 41, 104, 100, 201, 202, 203, 301, 302, 303, 304]
        getShippingRequestList(getCookie("SESSION_ID"), statuses, function (response) {
            if (response?.misc?.CODE === 1) {
                response.data.sort(function (a, b) {
                    return new Date(b.date) - new Date(a.date);
                });
                var fil = response.data.filter(f => f.parentId === 0 || f.parentId === f.id); 
                //dispatch(setShipping_list(response.data))
                dispatch(setShipping_list(fil))
                dispatch(setIsShippingLoading(false))
                

            } else {
                setIsLogin(true)
                navigate("/home")
                setCookie("SESSION_ID", "", 30);
                dispatch(clearSessionData({
                    user: {
                        firstName: ""
                    }
                }))

            }
        })
    }
    const checkForServiceAndOnHold = (sh, callback) => {
        dispatch(setIsShippingLoading(true));
        getShippingRequest(getCookie("SESSION_ID"), sh.hawb, function (data) {
            data.params = JSON.parse(data.paramsNew);
            if ((data.repackStatus == 0 || data.repackStatus == 104 || data.repackStatus == 105 || data.repackStatus == null) &&
                (data.rescanStatus == 0 || data.rescanStatus == null || data.rescanStatus == 104 || data.rescanStatus == 105) &&
                ((!data.consolidationStatus || data.consolidationStatus == 3 || data.consolidationStatus == 105) &&
                    (data.shippingStatus <= 2 || data.shippingStatus == 104 || data.shippingStatus == 202)) && data.shippingStatus != 201
                && data.shippingStatus != 203) {
                dispatch(setIsShippingLoading(false));
                dispatch(setSelectedShipping(data));
                callback(true)
            }
            else {
                dispatch(setIsShippingLoading(false));
                callback(false)
            }
        })
    }
    const getTransportValue = (twt, weightAndVal, totalVol) => {
        var minWeight = 0;
        var maxWeight = 0;
        var minVal = 0;
        try {
            minWeight = maxWeight = weightAndVal[0].wt
            weightAndVal.forEach((weightVal) => {
                var x = weightVal.wt;
                if (x > maxWeight) {
                    maxWeight = x;
                }
                if (x < minWeight) {
                    minWeight = x;
                }
            })
        } catch (e) {
            minWeight = 0.25;
            maxWeight = 26.9;
        }
        twt = Number(twt) <= minWeight ? minWeight : (Number(twt) > maxWeight ? maxWeight : Number(twt));
        //twt = Number(Number(twt).toFixed(1))
        var transportVal = 0;
        for (var j = 0; j < weightAndVal?.length; j++) {
            var weightVal = weightAndVal[j];
            if (weightVal.wt >= twt) {
                transportVal = weightVal.val;
                break;
            }
            if (!weightVal.wt && twt == minWeight) {
                transportVal = weightVal.val;
                break;
            }
        }
        return Number(transportVal);
    }
    const getIndividualCost = (parcels, wh) => {
        var totalWt = 0;
        var totalL = 0;
        var totalH = 0;
        var totalW = 0;
        var totalVol = 0;
        var totalCost = 0;
        var ids = [];
        var wVal = handleWarHWts(wh, wh.params?.wtNval?.length);
        for (var i = 0; i < parcels?.length; i++) {
            if (parcels[i].selected) {
                totalWt = Number(parcels[i].params?.userPaymentData?.weight);
                totalL = Number(parcels[i].params?.userPaymentData?.length);
                totalH = Number(parcels[i].params?.userPaymentData?.height);
                totalW = Number(parcels[i].params?.userPaymentData?.width);
                totalVol = Number(parcels[i].params?.userPaymentData?.length) * Number(parcels[i].params?.userPaymentData?.width) * Number(parcels[i].params?.userPaymentData?.height);

                var chWt = totalVol / 5000 > totalWt ? totalVol / 5000 : totalWt;
                totalCost += getTransportValue(chWt, wVal, totalVol);
            }
        }
        //var totalVol = totalL * totalH * totalW;
        var chWt = totalVol / 5000 > totalWt ? totalVol / 5000 : totalWt;
        return "$ " + totalCost;
    }
    const handleWarHWts = (w, len) => {

        var t = [];
        try {
            var tV = w?.params?.wtNval;
            for (var i = 0; i < len; i++) {
                if (tV[i][0] && tV[i][1]) {
                    t.push({
                        wt: Number(tV[i][0]),
                        val: Number(tV[i][1]),
                    })
                }
            }
        } catch (e) {
            console.log(e)
        }

        // setWtAndVals(t)
        return t;
    }
    const getCombinedCost = (parcels, wh) => {
        var volMult = wh.params?.cVolMult ? wh.params?.cVolMult : 1;
        var totalWt = 0;
        var totalL = 0;
        var totalH = 0;
        var totalW = 0;
        var totalVol = 0;
        var wVal = handleWarHWts(wh, wh.params?.wtNval?.length);
        for (var i = 0; i < parcels?.length; i++) {
            if (parcels[i].selected) {
                totalWt += Number(parcels[i].params?.userPaymentData?.weight);
                totalL += Number(parcels[i].params?.userPaymentData?.length);
                totalH += Number(parcels[i].params?.userPaymentData?.height);
                totalW += Number(parcels[i].params?.userPaymentData?.width);

                totalVol += volMult * Number(parcels[i].params?.userPaymentData?.length) * Number(parcels[i].params?.userPaymentData?.width) * Number(parcels[i].params?.userPaymentData?.height);
            }
        }
        var chWt = totalVol / 5000 > totalWt ? totalVol / 5000 : totalWt;
        if (wh.params.useBoxes) {
            var boxes = [];
            var bxs = wh.params.boxes.split(",")
            for (var i = 0; i < bxs?.length; i++) {
                var bs = bxs[i].split(":");
                boxes.push({ WT: Number(bs[4]), L: Number(bs[1]), W: Number(bs[2]), H: Number(bs[3]), V : Number(bs[1]) * Number(bs[2]) * Number(bs[3]) })
            }
            if (boxes?.length == 0) {
                var chWt = totalVol / 5000 > totalWt ? totalVol / 5000 : totalWt;
                return "$ " + getTransportValue(chWt, wVal, totalVol);
                //return "original wt: " + totalWt + ", L: " + totalL + ", W: " + totalW + ", H: " + totalH;
            }
            boxes.sort(function (a, b) {
                return a.V - b.V;
            });
            if (totalVol < boxes[0].V) {
                totalVol = boxes[0].V;
                totalL = boxes[0].L;
                totalW = boxes[0].W;
                totalH = boxes[0].H;
                chWt = totalVol / 5000 > totalWt + boxes[0].WT ? totalVol / 5000 : totalWt + boxes[0].WT;
            } else if (totalVol > boxes[boxes?.length - 1].V) {
                chWt = totalVol / 5000 > totalWt ? totalVol / 5000 : totalWt;
            } else {
                for (var i = 0; i < boxes?.length-1; i++) {
                    if (totalVol > boxes[i].V && totalVol < boxes[i + 1].V) {
                        totalVol = boxes[i + 1].V;
                        totalL = boxes[i + 1].L;
                        totalW = boxes[i + 1].W;
                        totalH = boxes[i + 1].H;
                        chWt = totalVol / 5000 > totalWt + boxes[i + 1].WT ? totalVol / 5000 : totalWt + boxes[i + 1].WT;
                        break;
                    }
                }
            }
            return "$ " + getTransportValue(chWt, wVal, totalVol);
            //return "wt: " + totalWt + ", vol: " + totalVol + ", chW: " + chWt;
        } else {
            return "$ " + getTransportValue(chWt, wVal, totalVol);
            //return "wt: " + totalWt + ", vol: " + totalVol + ", chW: " + chWt ;
        }
    }
    const dissableConsolidation = (parcel, wh) => {
        if (Number(parcel.params?.userPaymentData.weight) > Number(wh?.params?.cLimitWt) ||
            Number(parcel.params?.userPaymentData.length) > Number(wh?.params?.cLimitL) ||
            Number(parcel.params?.userPaymentData.height) > Number(wh?.params?.cLimitH) ||
            Number(parcel.params?.userPaymentData.width) > Number(wh?.params?.cLimitW))
            return "מגבלת גודל/משקל";
        if (!wh?.params?.useBoxes)
            return false;
        return false;
    }
    const getExt = (name) => {
        let ext = ".png";
        if (name) {
            var lastIndexOf = name.lastIndexOf(".");
            if (lastIndexOf == -1) {
                ext = ".png"; // empty extension
            }
            ext = name.substring(lastIndexOf);
        }
        return ext;
    }
    /*useEffect(() => {
        getBuyMeRequestsItems();
    }, [isBuyMePayment]);*/
    const [additionalCostForCalc, setAdditionalCostForCalc] = useState(null);

    const getLengthCondition1 = (sh) => {
        if (!sh.params.userPaymentData["length"] ||
            !sh.params.userPaymentData.height ||
            !sh.params.userPaymentData.width ||
            !sh.params.userPaymentData.weight)
            return false;
        var sizeSplit1 = 0;
        var sizeSplit2 = 0;
        var sizeSplit3 = 0;
        var sizeLimitWT = 20;
        var vals = [Number(sh.params.userPaymentData["length"])];
        vals.push(Number(sh.params.userPaymentData.width));
        vals.push(Number(sh.params.userPaymentData.height));
        var wt = Number(sh.params.userPaymentData.weight);
        var volMult = Number(sh.params?.userPaymentData?.packages);
        var totalVol = volMult * Number(sh.params?.userPaymentData?.length) * Number(sh.params?.userPaymentData?.width) * Number(sh.params?.userPaymentData?.height);
        var chWt = totalVol / 5000 > wt ? totalVol / 5000 : wt;
        vals.sort((a, b) => b - a);
        if (additionalCostForCalc?.costSizeLimitC && additionalCostForCalc?.costSizeLimitW) {
            sizeLimitWT = Number(additionalCostForCalc?.costSizeLimitW);
            var sizeLimit = additionalCostForCalc?.costSizeLimitC;
            var sizeSplit = sizeLimit.split("x");
            sizeSplit.sort((a, b) => b - a);

            sizeSplit1 = Number(sizeSplit[0]);
            sizeSplit2 = Number(sizeSplit[1]);
            sizeSplit3 = Number(sizeSplit[2]);

            return vals[0] > sizeSplit1 || vals[1] > sizeSplit2 || vals[2] > sizeSplit3 || chWt > sizeLimitWT;
        }
        // 0.393701
        return vals[0] > 65 || vals[1] > 45 || vals[2] > 40 || chWt > 20;
    }
    const showRepayment = (sh) => {
        dispatch(setSelectedShipping(sh));
        setShowPaymentNew(true);
        //showPersonal(sh);
    }
    const showPersonal = (sh) => {
        /*var wh = allWh?.find(w => w.id == sh_t.warehouseId);
        var wtNval = wh.params?.wtNval;
        var maxWt = Number(wtNval[wtNval.length - 1][0]);
        var wt = Number(sh.params.userPaymentData.weight);
        if (wt > maxWt) {
            dispatch(snackbarToggle({ type: 'success', message: "" }));
            return;
        }*/
        var sh_t = JSON.parse(JSON.stringify(sh))
        if (!sh_t.params.statusLog) {
            var sl = []
            for (var i = 9; i > 0; i--) {
                var m = {};
                m.id = i;
                m.DATE = null;
                m.DESC = null;
                sl.push(m);
            }
            sh_t.params.statusLog = sl;
        }
        var temp_shipment_status_list = [];
        var statuses_new_create = {}
        var statuses_new_payment = {}
        var statuses_new_manifest = {}
        var statuses_new_customs = {}
        var statuses_new_delivery = {}
        var null_cust = null;
        var null_del = null;
        for (var i = 0; i < sh_t.params.statusLog?.length; i++) {
            if (sh_t.params.statusLog[i].id == 1) {
                statuses_new_create.id = 1;
                statuses_new_create.DATE = sh_t.countDate ? sh_t.countDate : sh_t.create_date;
                statuses_new_create.DESC = sh_t.params.statusLog[i].DATE ? "החבילה נקלטה במחסן וממתינה לתשלום" : null;
            }
            else if (sh_t.params.statusLog[i].id == 2) {
                statuses_new_payment.id = 2;
                statuses_new_payment.DATE = sh_t.params.statusLog[i].DATE ? sh_t.params.statusLog[i].DATE : null;
                if (statuses_new_payment.DATE) {
                    var wh = allWh?.find(w => w.id == sh_t.warehouseId);
                    if (wh) {
                        var dt_payment = Number(statuses_new_payment.DATE);
                        var priceText = wh.params?.PriceText;
                        dt_payment += Number(wh.params.etaDays ? wh.params.etaDays : 28) * 24 * 3600000;
                        statuses_new_payment.DESC = "התשלום בוצע בהצלחה, והחבילה הועברה לטיפול צוות המחסן לקראת הטיסה לארץ. צפי מסירה: " + priceText + " ימי עסקים (" + getDateFormat(dt_payment) + ")";
                    }
                } else
                    statuses_new_payment.DESC = null;
            }
            else if (sh_t.params.statusLog[i].id == 3) {
                statuses_new_manifest.id = 3;
                statuses_new_manifest.DATE = sh_t.params.statusLog[i].DATE ? sh_t.params.statusLog[i].DATE : null;
                statuses_new_manifest.DESC = sh_t.params.statusLog[i].DATE ? "החבילה הועברה לחברת התעופה, ובימים הקרובים תצא בדרכה לארץ" : null;
            }
            else if (sh_t.params.statusLog[i].id == 5 || sh_t.params.statusLog[i].id == 6) {
                if (sh_t.params.statusLog[i].DATE) {
                    statuses_new_customs.id = 6;
                    statuses_new_customs.DATE = sh_t.params.statusLog[i].DATE;
                    statuses_new_customs.DESC = "החבילה שלך שוחררה מהמכס והועברה לחברת ההפצה";
                }
            }
            else if (sh_t.params.statusLog[i].id == 7) {
                if (sh_t.params.statusLog[i].DATE) {
                    statuses_new_delivery.id = 7;
                    statuses_new_delivery.DATE = sh_t.params.statusLog[i].DATE;
                    statuses_new_delivery.DESC = "החבילה נמסרה! שמחנו לתת לך שירות :)";
                }
            }
        }
        if (sh.deliveredDate) {
            statuses_new_delivery.id = 7;
            statuses_new_delivery.DATE = sh.deliveredDate;
            statuses_new_delivery.DESC = "החבילה נמסרה! שמחנו לתת לך שירות :)";

        }
        if (statuses_new_customs?.id || statuses_new_delivery?.id) {
            if (statuses_new_delivery?.DATE)
                temp_shipment_status_list.push(statuses_new_delivery)
            if (statuses_new_customs?.DATE)
                temp_shipment_status_list.push(statuses_new_customs)
            if (statuses_new_manifest?.DATE)
                temp_shipment_status_list.push(statuses_new_manifest)
            if (statuses_new_payment?.DATE)
                temp_shipment_status_list.push(statuses_new_payment)
            if (statuses_new_create?.DATE)
                temp_shipment_status_list.push(statuses_new_create)
            sh_t.params.statusLog = temp_shipment_status_list;
            dispatch(setSelectedShipping(sh_t));
            //setIsPersonal(true);
            setShowPersonal(true);
        } else {
            dispatch(setIsShippingLoading(true))
            getETAStatus(getCookie("SESSION_ID"), sh_t.params.manifestId, function (data) {
                var shipmentETAList = [];
                var statuses_new_arr = {}
                var landingDateTimeList = [];
                var tempShipmentETAList = [];
                var statuses_new_eta = {}
                if (data.message == "SUCCESS") {
                    shipmentETAList = data.data.etaLogs;
                }
                var cust_time = 0;
                if (statuses_new_customs.DATE)
                    cust_time = new Date(statuses_new_customs.DATE).getTime();
                for (var i = 0; i < shipmentETAList?.length; i++) {
                    if (shipmentETAList[i].updateTime) {
                        var updateTime = new Date(shipmentETAList[i].updateTime).getTime()
                        if (cust_time > updateTime || cust_time == 0) {
                            if (shipmentETAList[i].arrivalDateTime) {
                                sh_t.setETA = shipmentETAList[i].updateTime;
                                statuses_new_eta.id = 4;
                                statuses_new_eta.DATE = shipmentETAList[i].updateTime;
                                statuses_new_eta.DESC = "צפי נחיתה בארץ (לא סופי) " + getDateFormat(shipmentETAList[i].arrivalDateTime);
                            }
                            if (shipmentETAList[i].landingDateTime) {
                                sh_t.setLTA = shipmentETAList[i].updateTime;
                                statuses_new_arr.id = 5;
                                statuses_new_arr.DATE = shipmentETAList[i].updateTime;
                                statuses_new_arr.DESC = "החבילה נחתה בארץ ובימים הקרובים תשוחרר מהמכס ותועבר לחברת ההפצה ";
                            }
                        }
                    }
                }
                if (statuses_new_delivery?.DATE)
                    temp_shipment_status_list.push(statuses_new_delivery)
                if (statuses_new_customs?.DATE)
                    temp_shipment_status_list.push(statuses_new_customs)
                if (statuses_new_arr?.DATE)
                    temp_shipment_status_list.push(statuses_new_arr)
                if (statuses_new_eta?.DATE)
                    temp_shipment_status_list.push(statuses_new_eta)
                if (statuses_new_manifest?.DATE)
                    temp_shipment_status_list.push(statuses_new_manifest)
                if (statuses_new_payment?.DATE)
                    temp_shipment_status_list.push(statuses_new_payment)
                if (statuses_new_create?.DATE)
                    temp_shipment_status_list.push(statuses_new_create)
                sh_t.params.statusLog = temp_shipment_status_list;
                dispatch(setIsShippingLoading(false))
                dispatch(setSelectedShipping(sh_t));
                //setIsPersonal(true);
                setShowPersonal(true);
            })
        }
    }
    const showPersonal1 = (sh) => {
        var sh_t = JSON.parse(JSON.stringify(sh))
        if (!sh_t.params.statusLog) {
            var sl = []
            for (var i = 9; i > 0; i--) {
                var m = {};
                m.id = i;
                m.DATE = null;
                m.DESC = null;
                sl.push(m);
            }
            sh_t.params.statusLog = sl;
        }
        var temp_shipment_status_list = [];
        var statuses_new_create = {}
        var statuses_new_payment = {}
        var statuses_new_manifest = {}
        var statuses_new_customs = {}
        var statuses_new_delivery = {}
        var null_cust = null;
        var null_del = null;
        for (var i = 0; i < sh_t.params.statusLog?.length; i++) {
            if (sh_t.params.statusLog[i].id == 1) {
                statuses_new_create.id = 1;
                statuses_new_create.DATE = sh_t.params.statusLog[i].DATE ? sh_t.params.statusLog[i].DATE : null;
                statuses_new_create.DESC = sh_t.params.statusLog[i].DATE ? "החבילה נקלטה במחסן וממתינה לתשלום" : null;
            }
            else if (sh_t.params.statusLog[i].id == 2) {
                statuses_new_payment.id = 2;
                statuses_new_payment.DATE = sh_t.params.statusLog[i].DATE ? sh_t.params.statusLog[i].DATE : null;
                if (statuses_new_payment.DATE) {

                    var wh = allWh?.find(w => w.id == sh_t.warehouseId);
                    var dt_payment = Number(statuses_new_payment.DATE);
                    var priceText = wh.params?.PriceText;
                    if (statuses_new_payment.DATE < 1766152800000) {
                        dt_payment += (Number(wh.params.etaDays) * 24 * 3600000);
                        statuses_new_payment.DESC = "התשלום בוצע בהצלחה, והחבילה הועברה לטיפול צוות המחסן לקראת הטיסה לארץ. צפי מסירה: " + priceText +" ימי עסקים (" + getDateFormat(dt_payment) + ")"
                    } else {
                        dt_payment += (Number(wh.params.etaDays) * 24 * 3600000);
                        statuses_new_payment.DESC = "התשלום בוצע בהצלחה, והחבילה הועברה לטיפול צוות המחסן לקראת הטיסה לארץ. צפי מסירה: " + priceText +" ימי עסקים (" + getDateFormat(dt_payment) + ")"
                    }
                } else
                    statuses_new_payment.DESC = null;
            }
            else if (sh_t.params.statusLog[i].id == 3) {
                statuses_new_manifest.id = 3;
                statuses_new_manifest.DATE = sh_t.params.statusLog[i].DATE ? sh_t.params.statusLog[i].DATE : null;
                statuses_new_manifest.DESC = sh_t.params.statusLog[i].DATE ? "החבילה הועברה לחברת התעופה, ובימים הקרובים תצא בדרכה לארץ" : null;
            }
            else if (sh_t.params.statusLog[i].id == 5 || sh_t.params.statusLog[i].id == 6) {
                if (sh_t.params.statusLog[i].DATE) {
                    statuses_new_customs.id = 6;
                    statuses_new_customs.DATE = sh_t.params.statusLog[i].DATE;
                    statuses_new_customs.DESC = "החבילה שלך שוחררה מהמכס והועברה לחברת ההפצה";
                }
            }
            else if (sh_t.params.statusLog[i].id == 7) {
                if (sh_t.params.statusLog[i].DATE) {
                    statuses_new_delivery.id = 7;
                    statuses_new_delivery.DATE = sh_t.params.statusLog[i].DATE;
                    statuses_new_delivery.DESC = "החבילה נמסרה! שמחנו לתת לך שירות :)";
                }
            }
        }
        if (sh.deliveredDate) {
            statuses_new_delivery.id = 7;
            statuses_new_delivery.DATE = sh.deliveredDate;
            statuses_new_delivery.DESC = "החבילה נמסרה! שמחנו לתת לך שירות :)";

        }
        if (statuses_new_customs?.id || statuses_new_delivery?.id) {
            if (statuses_new_delivery?.DATE)
                temp_shipment_status_list.push(statuses_new_delivery)
            if (statuses_new_customs?.DATE)
                temp_shipment_status_list.push(statuses_new_customs)
            if (statuses_new_manifest?.DATE)
                temp_shipment_status_list.push(statuses_new_manifest)
            if (statuses_new_payment?.DATE)
                temp_shipment_status_list.push(statuses_new_payment)
            if (statuses_new_create?.DATE)
                temp_shipment_status_list.push(statuses_new_create)
            sh_t.params.statusLog = temp_shipment_status_list;
            dispatch(setSelectedShipping(sh_t));
            //setIsPersonal(true);
            setShowPersonal(true);
        } else {
            dispatch(setIsShippingLoading(true))
            getETAStatus(getCookie("SESSION_ID"), sh_t.params.manifestId, function (data) {
                var shipmentETAList = [];
                var statuses_new_eta = {}
                var statuses_new_arr = {}
                var landingDateTimeList = [];
                var tempShipmentETAList = [];
                if (data.message == "SUCCESS") {
                    shipmentETAList = data.data.etaLogs;
                }
                var cust_time = 0;
                if (statuses_new_customs.DATE)
                    cust_time = new Date(statuses_new_customs.DATE).getTime();
                for (var i = 0; i < shipmentETAList?.length; i++) {
                    if (shipmentETAList[i].updateTime) {
                        var updateTime = new Date(shipmentETAList[i].updateTime).getTime()
                        if (cust_time > updateTime || cust_time == 0) {
                            if (shipmentETAList[i].arrivalDateTime) {
                                sh_t.setETA = shipmentETAList[i].arrivalDateTime;
                                statuses_new_eta.id = 4;
                                statuses_new_eta.DATE = shipmentETAList[i].updateTime;
                                statuses_new_eta.DESC = "צפי נחיתה בארץ (לא סופי) " + getDateFormat(shipmentETAList[i].arrivalDateTime);
                            }
                            if (shipmentETAList[i].landingDateTime) {
                                sh_t.setLTA = shipmentETAList[i].updateTime;
                                statuses_new_arr.id = 5;
                                statuses_new_arr.DATE = shipmentETAList[i].updateTime;
                                statuses_new_arr.DESC = "החבילה נחתה בארץ ובימים הקרובים תשוחרר מהמכס ותועבר לחברת ההפצה ";
                            }
                        }
                    }
                }
                if (statuses_new_delivery?.DATE)
                    temp_shipment_status_list.push(statuses_new_delivery)
                if (statuses_new_customs?.DATE)
                    temp_shipment_status_list.push(statuses_new_customs)
                if (statuses_new_arr?.DATE)
                    temp_shipment_status_list.push(statuses_new_arr)
                if (statuses_new_eta?.DATE)
                    temp_shipment_status_list.push(statuses_new_eta)
                if (statuses_new_manifest?.DATE)
                    temp_shipment_status_list.push(statuses_new_manifest)
                if (statuses_new_payment?.DATE)
                    temp_shipment_status_list.push(statuses_new_payment)
                if (statuses_new_create?.DATE)
                    temp_shipment_status_list.push(statuses_new_create)
                sh_t.params.statusLog = temp_shipment_status_list;
                dispatch(setIsShippingLoading(false))
                dispatch(setSelectedShipping(sh_t));
                //setIsPersonal(true);
                setShowPersonal(true);
            })
        }
    }
    useEffect(() => {
        if (!userInfo.session) {
            return;
        }
        var shId = get_params("shId");
        if (shId || true) {
            //console.log("useEffect");
            dispatch(setIsShippingLoading(true))
            var statuses = [1, 2, 3, 4, 5, 6, 601, 41, 104, 100, 201, 202, 203, 301, 302, 303, 304]
            getShippingRequestList(getCookie("SESSION_ID"), statuses, function (response) {
                if (response?.misc?.CODE === 1) {
                    response.data.sort(function (a, b) {
                        return new Date(b.date) - new Date(a.date);
                    });
                    var fil = response.data.filter(f => f.parentId === 0 || f.parentId === f.id);
                    //dispatch(setShipping_list(response.data))
                    dispatch(setShipping_list(fil))
                    dispatch(setIsShippingLoading(false))
                    var sh = shId ? response.data.find(u => u.hawb === shId) : null;
                    if (sh) {
                        showPersonal(sh);
                        /*dispatch(setSelectedShipping(sh));
                        setIsPersonal(true);*/
                    }

                } else {
                    setIsLogin(true)
                    navigate("/home")
                    setCookie("SESSION_ID", "", 30);
                    dispatch(clearSessionData({
                        user: {
                            firstName: ""
                        }
                    }))

                }
                if (userInfo.user.isComm) {
                    if (!validateCompanyName(userInfo.user.setting.companyName) || !validateMyId(userInfo.user.setting.companyId)) {
                        setIsProfile(true)
                    }
                } else {
                    if (!validateMyId(userInfo.user.setting.profileId)) {
                        setIsProfile(true)
                    }
                }
            })

        }
        listWarehouse(function (data1) {
            let data = []
            let buyMeShops1 = []
            let l = 0;
            data1.data.map((dat, index) => {
                if (index == 0) {
                    l = 0
                }
                else if (index > 0 && dat.params?.banner) {
                    l += dat.params.banner?.length;
                }
                dat.params.index = l;
                if (dat.name != 'מערב אירופה' && dat.name != 'טורקיה') {
                    data.push(dat)
                }
                if (dat.name == 'מערב אירופה') {
                    buyMeShops1.push(dat)
                }


            })
            data1.data.map((dat, index) => {
                if (index == 0) {
                    l = 0
                }
                else if (index > 0 && dat.params?.banner) {
                    l += dat.params.banner?.length;
                }
                dat.params.index = l;
                if (dat.name === 'מערב אירופה') {
                    data.push(dat)
                }

            })
            data1.data.map((dat, index) => {
                if (index == 0) {
                    l = 0
                }
                else if (index > 0 && dat.params?.banner) {
                    l += dat.params.banner?.length;
                }
                dat.params.index = l;
                if (dat.name === 'טורקיה') {
                    data.push(dat)
                }


            })


            setAllWh(data)
            getAdditionalCostForCalc(function (data) {
                setAdditionalCostForCalc(data.data);
            });
            if (buyMeShops1?.length) {
                setSelectedBuyMeShopId(buyMeShops1[0].id)
            }
            setBuyMeShops(buyMeShops1)
        });
    }, [userInfo]);

    const getHistoryCount = (st) => {
        var count = 0;
        for (var i = 0; i < shipping_list?.length; i++) {
            if (shipping_list[i].shippingStatus == 6 || shipping_list[i].status) {
                count++
            }
        }
        return count;
    }
    const [isRepackageDlg, setRepackageDlg] = new useState(false);
    const [repackageShipment, setRepackageShipment] = new useState({});
    const openRepackageDlg = (sh) => {
        setRepackageShipment(sh);
        setRepackageDlg(true);
    }
    const closeRepackageDlg = () => {
        setRepackageShipment(null);
        setRepackageDlg(false);
    }
    const [isRescanDlg, setRescanDlg] = new useState(false);
    const [rescanShipment, setRescanShipment] = new useState({});
    const openRescanDlg = (sh) => {
        setRescanShipment(sh);
        setRescanDlg(true);
    }
    const closeRescanDlg = () => {
        setRescanShipment(null);
        setRescanDlg(false);
    }
    const isServiceNotAvailable = (sh) => {
        var status = true;
        if ((sh.shippingStatus <= 2 || sh.shippingStatus > 6) && (sh.repackStatus == null || sh.repackStatus == 0) && (sh.consolidationStatus == null || sh.consolidationStatus == 0 || sh.consolidationStatus == 3)) {
            status = false;
        }
        return status;
    }
    const getDescByShStatus = (sh) => {
        if (sh.status) {
            if (sh.shippingStatus == 6) {
                return "החבילה נמסרה";
            }
            else return "";
        }
        if (!sh.shippingStatus) {
            return "החבילה נקלטה";
        } else if (sh.shippingStatus == 1 || sh.shippingStatus == 100 || sh.shippingStatus == 201) {
            return sh.parentId != 0 ? `החבילה נקלטה` : `ההזמנה נקלטה`;
        } else if (sh.shippingStatus == 2 || sh.shippingStatus == 202) {
            return sh.parentId != 0 ? `ממתין לתשלום` : `החבילה  נקלטה`;
        } else if (sh.shippingStatus == 203) {
            return getCSOnHoldSatus(sh);
        }else if (sh.shippingStatus == 3) {
            return getStatusId(sh) == 2 ? 'החבילה בטיפול' : 'בדרך לארץ';
        } else if (sh.shippingStatus == 4 || sh.shippingStatus == 41) {
            return "בדרך לארץ";
        } else if (sh.shippingStatus == 5) {
            return getStatusDescId(sh) ? getStatusDescId(sh) : ((sh.params && sh.params.shippingStatus?.status_json) ? sh.params?.shippingStatus?.status_json?.STATUS_2 : 'בדרך לארץ');
        } else if (sh.shippingStatus == 104) {
            return (sh.params && sh.params.shippingStatus?.status_json) ? sh.params?.shippingStatus?.status_json?.STATUS_2 : 'החבילה בטיפול';
        } else if (sh.params && sh.shippingStatus != 104 && sh.shippingStatus != 201 && sh.shippingStatus != 100 && sh.shippingStatus != 41 && sh.shippingStatus != 1 && sh.shippingStatus != 6 && sh.shippingStatus != 2 && sh.shippingStatus != 3 && sh.shippingStatus != 4 && sh.shippingStatus != 5 && sh.shippingStatus != 301 && sh.shippingStatus != 302 && sh.shippingStatus != 303 && sh.shippingStatus != 304) {
            return (sh.params && sh.params.shippingStatus?.status_json) ? sh.params?.shippingStatus?.status_json?.STATUS_2 : 'הפצה';
        } else if (sh.shippingStatus == 6) {
            return "החבילה נמסרה";
        } else if (sh.shippingStatus == 301) {
            return getStatusId(sh) == 2 ? 'החבילה בטיפול' : 'בדרך לארץ';
        } else if (sh.shippingStatus == 302) {
            return "חשבונית לא תקינה";
        } else if (sh.shippingStatus == 303) {
            return getStatusId(sh) == 2 ? 'החבילה בטיפול' : 'בדרך לארץ';
        } else if (sh.shippingStatus == 304) {
            return getStatusId(sh) == 2 ? 'החבילה בטיפול' : 'בדרך לארץ';
        }
        switch (sh.shippingStatus) {
            case 1:
                return "החבילה נקלטה"
            case 104:
                return "החבילה נקלטה"
            case 201:
                return "החבילה נקלטה"
            case 203:
                return "החבילה נקלטה"
            case 2:
                return "ממתין לתשלום"
            case 202:
                return "ממתין לתשלום"
            case 3:
                return "בדרך לארץ"
            case 4:
                return "בדרך לארץ"
            case 41:
                return "בדרך לארץ"
            case 6:
                return "החבילה נמסרה"
            default:
                //return "הפצה"
                return "החבילה נקלטה";
        }
    }
    const copyToClipboard = (text) => {
        copyToClipboard1(text, function (data) {
            dispatch(snackbarToggle({ type: 'success', message: data }));
            window.setTimeout(function () { dispatch(snackbarToggle(false)); }, autoCloseSnackbar);

        })
    }

    const filter_check_get_parcel = (s) => {
        if (s.trim()) {
            for (var i = 0; i < shipping_list?.length; i++) {
                if (shipping_list[i].hawb === s.trim() || shipping_list[i].trackingNum.includes(s.trim())) {
                    setSearch(shipping_list[i].hawb);
                    if (shipping_list[i].shippingStatus != 6 && !shipping_list[i].status) {
                        setIsHistory(false)
                        setTabIndex(1)
                        if (isMobile()) {
                            setIsHistory(true)
                        }
                    } else {
                        setIsHistory(true)
                        setTabIndex(2)
                        if (isMobile()) {
                            setIsHistory(false  )
                        }
                    }
                    return "";
                }
            }
        }
        setSearch(s);
        return "";
    }

    const getNewStatus = (sh, text) => {
        if (sh.clientStatus != null) {
            switch (sh.clientStatus) {
                case 0:
                    return "החבילה נקלטה";
                case 1:
                    return "בטיפול";
                /*case 1:
                    return "בדרך לארץ";*/
                case 2:
                    return "בדרך לארץ";
                case 3:
                    return "בתהליך מכס";
                case 4:
                    return "הפצה";
                case 5:
                    return "הפצה";
                default:
                    return "החבילה נקלטה";
            }
        }
        return text;
    }

    const getNewHistoryStatus = (sh, text) => {
        if (sh.clientStatus != null) {
            switch (sh.clientStatus) {
                case 0:
                    return "החבילה נקלטה";
                case 1:
                    return "בטיפול";
                /*case 1:
                    return "בדרך לארץ";*/
                case 2:
                    return "בדרך לארץ";
                case 3:
                    return "בתהליך מכס";
                case 4:
                    return "הפצה";
                case 5:
                    return "החבילה נמסרה";
                default:
                    return "החבילה נקלטה";
            }
        }
        return text;
    }

    const filter_check = (s) => {
        if (search?.trim()) {
            if (s.hawb === search.trim() || s.trackingNum.includes(search.trim()))
                return true;
            return false;
        }
        return true;
    }
    const [varShowPersonal, setShowPersonal] = useState(false);
    const [varShowPaymentNew, setShowPaymentNew] = useState(false);
    return (
        <>
            <Paper sx={{ width: '100%', overflow: 'hidden' }} onClick={() => { setShowExtraServicesHide(-1); }}>
                {varShowPersonal && <PersonalDetails isPersonal={varShowPersonal} setIsPersonal={setShowPersonal} />}
                {varShowPaymentNew && <SecondPayment isPersonal={varShowPaymentNew} setIsPersonal={setShowPaymentNew} get_shipping_list_count={loadParcels} />}
            
                {openRepackCostAcceptModal && (
                    <Dialog maxWidth='sm' open={openRepackCostAcceptModal} title={`Accept Cost`} onHandleCancel={onRepackCostAcceptModelClose}>

                        <Grid flexDirection="column" container item justifyContent="center" sx={{ fontSize: "20px" }}>
                            <p>Do you want to accept repack service for selected parcels?</p>
                        </Grid>
                        <Button variant='contained' sx={{ m: 2, borderRadius: "25px", background: "#FF3452", padding: "3px", paddingLeft: "20px", paddingRight: "20px" }} onClick={() => {
                            acceptRepackCost();
                        }}>Accept</Button>
                        <Button variant='contained' sx={{ m: 2, borderRadius: "25px", background: "#FF3452", padding: "3px", paddingLeft: "20px", paddingRight: "20px" }} onClick={() => {
                            setRepackageDlg(false);
                            setOpenRepackCostAcceptModal(false);
                        }}>Decline</Button>

                    </Dialog>
                )}
                {isRepackageDlg && (
                    <Dialog maxWidth='md' direction={'rtl'} open={isRepackageDlg} title={ `אריזה מחדש של החבילה:`} onHandleCancel={closeRepackageDlg}>
                        <Grid container item justifyContent="flex-end">
                            <Typography className='dir-rtl' >
                                <b style={{margin: "10px"}}>שימו לב, נעשו מספר שינויים בתהליך הגשת הבקשה לאריזה מחדש:</b>
                                <ul style={{ listStyleType: "number", marginRight: "20px", marginBlockStart: "0", paddingInlineStart: "0", marginBlockEnd: "0" }}>
                                    <li>{`שרות זה מתאפשר לאחר קליטת החבילות במרכזים הלוגיסטיים שלנו, רק עבור חבילות `} {`שלא שולמו עדיין.`}</li>
                                    <li>{ `בסיום התהליך תשלח הודעת תשלום חדשה במייל עבור החבילה המצומצמת. `}</li>
                                    <li>{`במקרים בהם לא ניתן לבצע צמצום נפח, הבקשה תבוטל והסיבה לביטול תופיע ליד `} { `החבילה לגביה הוגשה הבקשה.`}</li>
                                    <li>{ `לא ניתן לבצע צימצום נפח עבור מוצרים שבירים/רגישים`}</li>
                                    <li>{ `לא יתבצע צמצום נפח לחבילה אשר לא מכילה מוצרי אופנה אך סומנה כמוצר אופנה.`}</li>
                                    <li>{`צמצום נפח עשוי להוזיל עלויות משלוח רק לחבילות אשר המשקל הנפחי שלהם גבוה `} { `מהמשקל הפיזי. אנא בידקו את פרטי החבילה שלכם לפני הגשת הבקשה.`}</li>
                                    <li>{`הוספת אריזת מגן עשויה להעלות את נפח המשלוח ולכן גם את את עלויות השילוח `} { `לארץ.`}</li>
                                    <li>{ `לאחר ביצוע צמצום נפח הביטוח יהיה תקף לאובדן בלבד ולא יכסה נזק`}</li>
                                    {/*<li>{ ``}</li>
                                    <li>{`שרות זה מתאפשר לאחר קליטת החבילות במרכזים הלוגיסטיים שלנו, רק עבור חבילות שלא שולמו עדיין.`}</li>
                                    <li>{`בסיום התהליך תשלח הודעה על צמצום הנפח.`}</li>
                                    <li>{`בשל מגבלות משקל וגודל המוצרים, ישנם מקרים בהם צוות המחסן לא יוכל לבצע צמצום נפח במקרה זה תבוטל הבקשה יל ידי הצוות המקצועי של המחסן.`}</li>
                                    <li>{ `לא ניתן לבצע צימצום נפח עבור מוצרים שבירים/רגישים`}</li>
                                    <li>{ `חבילה אשר לא מכילה מוצרי אופנה תחוייב אוטומטית עבור צמצום החבילה , גם אם סומנה כמוצר אופנה על ידי הלקוח`}</li>
                                    <li>{ `לאחר ביצוע הפעולה, הביטוח יהיה תקף לאובדן בלבד ולא יכסה נזק`}</li>*/}
                                </ul>
                            </Typography>
                        </Grid>
                        <Grid container direction={'rtl'} item flexDirection="row-reverse" justifyContent="centert" sx={{ padding: "10px", fontSize: "20px", textAlign: "right", marginTop: "20px", marginBottom: "20px" }}>
                            <Grid container direction={'rtl'} item flexDirection="row-reverse" alignItems="flex-start" justifyContent="flex-start" sx={{ fontSize: "20px", textAlign: "right" }} flexWrap="nowrap">
                                <input style={{ marginTop: "10px" }} onChange={() => setFreeRepack2(1)} type="radio" value="1" name="gender" defaultChecked /> <p style={{ margin: "0", marginRight: "10px" }}>{`צמצום נפח למינימום הכנסת המוצר לשקית שילוח -5$`}</p>
                            </Grid>
                            <Grid container direction={'rtl'} item flexDirection="row-reverse" alignItems="flex-start" justifyContent="flex-start" sx={{ fontSize: "20px", textAlign: "right" }} flexWrap="nowrap">
                                <input style={{ marginTop: "10px" }} onChange={() => setFreeRepack2(2)} type="radio" value="2" name="gender" /> <p style={{ margin: "0", marginRight: "10px" }}>{ `צמצום נפח למינימום, משלוח של קרטון היצרן בלבד- 5$`}</p>
                            </Grid>
                            <Grid container direction={'rtl'} item flexDirection="row-reverse" alignItems="flex-start" justifyContent="flex-start" sx={{ fontSize: "20px", textAlign: "right" }} flexWrap="nowrap">
                                <input style={{ marginTop: "10px" }} onChange={() => setFreeRepack2(5)} type="radio" value="2" name="gender" /> <p style={{ margin: "0", marginRight: "10px" }}>{`אריזה מחדש לקרטון חיצוני קטן יותר שיש במחסן -5$`}</p>
                            </Grid>
                            <Grid container direction={'rtl'} item flexDirection="row-reverse" alignItems="flex-start" justifyContent="flex-start" sx={{ fontSize: "20px", textAlign: "right" }} flexWrap="nowrap">
                                <input style={{ marginTop: "10px" }} onChange={() => setFreeRepack2(3)} type="radio" value="3" name="gender" /> <p style={{ margin: "0", marginRight: "10px" }}>{`צמצום נפח`} <b>{`מוצרי אופנה בלבד`}</b> {`לשקית שילוח – ללא עלות `}</p>
                            </Grid>
                            <Grid container direction={'rtl'} item flexDirection="row-reverse" alignItems="flex-start" justifyContent="flex-start" sx={{ fontSize: "20px", textAlign: "right" }} flexWrap="nowrap">
                                <input style={{ marginTop: "10px" }} onChange={() => setFreeRepack2(6)} type="radio" value="3" name="gender" /> <p style={{ margin: "0", marginRight: "10px" }}><span style={{ fontWeight: "bold" }}>{`נעליים:`}</span> {` צמצום נפח ללא קופסת  הנעליים לשקית שילוח (ללא עלות)`}</p>
                            </Grid>
                            <Grid container direction={'rtl'} item flexDirection="row-reverse" alignItems="flex-start" justifyContent="flex-start" sx={{ fontSize: "20px", textAlign: "right" }} flexWrap="nowrap">
                                <input style={{ marginTop: "10px" }} onChange={() => setFreeRepack2(7)} type="radio" value="3" name="gender" /> <p style={{ margin: "0", marginRight: "10px" }}><span style={{ fontWeight: "bold" }}>{`נעליים:`}</span> {` צמצום נפח עם קופסת הנעליים לשקית שילוח (ללא עלות)`}</p>
                            </Grid>
                            <Grid container direction={'rtl'} item flexDirection="row-reverse" alignItems="flex-start" justifyContent="flex-start" sx={{ fontSize: "20px", textAlign: "right" }} flexWrap="nowrap">
                                <input style={{ marginTop: "10px" }} onChange={() => setFreeRepack2(4)} type="radio" value="4" name="gender" /> <p style={{ margin: "0", marginRight: "10px" }}>{ `הוספת אריזת מגן (ניילון פצפצים וקרטון נוסף אם יש צורך) –בתשלום של 8$`}</p>
                            </Grid>
                        </Grid>
                        {/*<Grid container item justifyContent="flex-end" sx={{ fontSize: "20px", mb: 1, mt: 1, mr: 1 }} lg={12}>

                            <MultilineField
                                className='multilineWidth_70 text-field'
                                lg={8}
                                rows={2}
                                value={repackFreeText}
                                onChange={event => {
                                    setRepackFreeText(event.target.value);
                                }}
                                label= 'הערות לצוות המחסן (באנגלית בלבד)'
                                dir={'rtl'}
                            />
                        </Grid>*/}
                        <Grid container direction={'rtl'} item justifyContent="center" sx={{ fontSize: "20px", textAlign: "right" }}>
                            {"?"} { `האם לארוז לך את החבילה מחדש`}
                        </Grid>
                        <Grid container item justifyContent="center" sx={{ fontSize: "20px" }}>
                            <Button variant='contained' sx={{ m: 2, borderRadius: "25px", background: "#FF3452", padding: "3px", paddingLeft: "20px", paddingRight: "20px" }} onClick={() => {
                                closeRepackageDlg();
                            }}>{ `לא`}</Button>
                            <Button variant='contained' sx={{ m: 2, borderRadius: "25px", background: "#FF3452", padding: "3px", paddingLeft: "20px", paddingRight: "20px" }} onClick={() => {
                                //repackParcel(getCookie("SESSION_ID"), repackageShipment.id, freeRepack2, repackFreeText, function (data) {
                                repackParcel(getCookie("SESSION_ID"), repackageShipment.id, freeRepack2, freeRepack2, function (data) {
                                    if (data?.misc?.CODE == 1 && data?.data) {
                                        //setNewShippingList(data.data);
                                        loadParcels();
                                        closeRepackageDlg();
                                    } else {
                                        closeRepackageDlg();
                                    }
                                })
                            }}>{ ` כן`}</Button>
                        </Grid>

                    </Dialog>
                )}
                {isRescanDlg && (
                    <Dialog maxWidth='lg' direction={'rtl'} open={isRescanDlg} title={ `צילום תכולת חבילה`} onHandleCancel={closeRescanDlg}>

                        <Grid container direction={'rtl'} item justifyContent="flex-end" sx={{ padding:"10px", fontSize: "20px", textAlign: "right" }}>
                            <Typography className='dir-rtl' >
                                <ul style={{ listStyleType: "number", marginRight: "20px", marginBlockStart: "0", paddingInlineStart: "0", marginBlockEnd: "0" }}>
                                    <li>{`שרות זה מתאפשר לאחר קליטת החבילות במרכזים הלוגיסטיים שלנו, רק עבור חבילות שלא שולמו עדיין`}{"."}</li>
                                    <li>{`בסיום התהליך יצורף צילום התכולה לפרטי החבילה באזור האישי שלך באתר`}{"."}</li>
                                    <li>{`השירות כרוך בתשלום של 4$ `}{"."}</li>
                                </ul>
                            </Typography>
                        </Grid>
                        <Grid container direction={'rtl'} item justifyContent="center" sx={{ fontSize: "20px", textAlign: "right", marginTop:"30px" }}>
                            ? { `האם לצלם לך את תכולת החבילה`}
                        </Grid>
                        <Grid container item justifyContent="center" sx={{ fontSize: "20px" }}>
                            <Button variant='contained' sx={{ m: 2, borderRadius: "25px", background: "#FF3452", padding: "3px", paddingLeft: "20px", paddingRight: "20px" }} onClick={() => {
                                closeRescanDlg();
                            }}>{ `לא`}</Button>
                            <Button variant='contained' sx={{ m: 2, borderRadius: "25px", background: "#FF3452", padding: "3px", paddingLeft: "20px", paddingRight: "20px" }} onClick={() => {
                                rescanParcel(getCookie("SESSION_ID"), rescanShipment.id, "", function (data) {
                                    if (data?.misc?.CODE == 1 && data?.data) {
                                        //setNewShippingList(data.data);
                                        loadParcels();
                                        closeRescanDlg();
                                    } else {
                                        closeRescanDlg();
                                    }
                                })
                            }}>{ `כן`}</Button>
                        </Grid>

                    </Dialog>
                )}
                {openOrderCCDialog && (
                    <Dialog maxWidth='lg' direction={'rtl'} open={openOrderCCDialog} title={`פרטים`} onHandleCancel={onHandleCancelCCDialog}>

                        <Grid container item justifyContent="center" sx={{ fontSize: "20px" }}>
                            { `.צור קשר עם שרות לקוחות`}
                        </Grid>
                        <Grid container item justifyContent="center" sx={{ fontSize: "20px" }}>
                        <Button variant='contained' sx={{ m: 2, borderRadius: "25px", background: "#FF3452", padding: "3px" }} onClick={() => {
                            onHandleCancelCCDialog();
                            }}>OK</Button>
                        </Grid>

                    </Dialog>
                )}
                {openOrderModal && (
                    <Dialog maxWidth='sm' open={openOrderModal} title={`Add Profile`} onHandleCancel={onHandleCancelModal}>

                        <Grid container item justifyContent="center" sx={{ fontSize: "20px" }}>
                            נא לעדכן תעודת זהות של בעל החשבון
                        </Grid>
                        <Button variant='contained' sx={{ m: 2, borderRadius: "25px", background: "#FF3452", padding: "3px" }} onClick={() => {
                            setIsProfile(true)
                            onHandleCancelModal();
                        }}>OK</Button>

                    </Dialog>
                )}
                {openDelayedDelivery && (
                    <Dialog maxWidth='sm' open={openDelayedDelivery} title={`זמני מסירה`} onHandleCancel={onHandleCloseDelayedDelivery}>

                        <Grid container item justifyContent="center" sx={{ fontSize: "20px", direction: "rtl", paddingRight:"15px" }}>
                            {`לקוח יקר,`}<br /><br />
                            {`החבילה שלך הועברה לחברת התעופה לצורך הטסתה לארץ.`}<br />
                            {`עקב המלחמה, חברות תעופה מבטלות טיסות רבות ללא התראה מוקדמת, ולכן החבילה שלך עדיין לא עלתה על טיסה.`}<br />
                            {`אל חשש. אנו מטפלים במשלוח ונדאג להשלים את תהליך המכס עוד לפני הגעתה לארץ, כך שעם הגעתה ארצה, החבילה תשוחרר.`}<br />
                            {`אנו מתנצלים על אי הנוחות ומזכירים שאנו כאן כדי לענות על כל שאלה. `}<br />
                        </Grid>
                        <Grid item container justifyContent="flex-end" style={{marginTop:"20px;"} }>
                            <Button variant='contained' sx={{ m: 2, borderRadius: "25px", background: "#FF3452", padding: "3px" }} onClick={() => {
                                onHandleCloseDelayedDelivery();
                            }}>{ `המשך`}</Button>
                        </Grid>

                    </Dialog>
                )}

                {openInfoModal && (
                    <Dialog maxWidth='sm' direction={'rtl'} open={openInfoModal} title={`פרטי חבילה` + " : " + shipmentInfo.hawb} onHandleCancel={onHandleCancelInfoModal}>
                        <Grid container item justifyContent="flex-start">
                            <Grid container item justifyContent="flex-start" sx={{ fontSize: "20px",direction:"rtl" }} >

                                {shipmentInfo.params?.ext && <Grid container item justifyContent={"flex-start"} lg={12}>
                                    <Button variant='link' sx={{ fontSize:"22px",m: 2, textDecoration:"underline" ,borderRadius: "25px", padding: "3px" }} onClick={() => {
                                        //setIsProfile(true)
                                        if (parcelImage != "") {
                                            setParcelImage("");
                                        }
                                        else if (shipmentInfo.params?.ext == '.pdf') {
                                            downloadByUrl("/images/parcel/parcel_" + shipmentInfo.id + shipmentInfo.params?.ext, "parcelImage" + shipmentInfo.params?.ext)
                                        } else {
                                            //setIsLoaded(true);
                                            var url = "/shipping/downloadParcelImage/" + getCookie("SESSION_ID") + "/" + shipmentInfo.hawb;
                                            fetch(url)
                                                .then(response =>
                                                    response.blob()
                                                )
                                                .then(response => {
                                                    const blob = new Blob([response], { type: 'image/png' });
                                                    const downloadUrl = window.URL.createObjectURL(blob);
                                                    //setIsLoaded(false);
                                                    setParcelImage(downloadUrl);
                                                })
                                        }
                                    }} >תמונה</Button>
                                </Grid>}
                                {parcelImage!="" && <Grid container item lg={11} style={{ maxHeight: "250px", marginRight:"20px" }}><img src={parcelImage} height="100%" /></Grid>}
                            </Grid>
                            <Box container item flexWrap="nowrap" justifyContent="center" sx={{ fontSize: "20px", direction: "rtl", width: "100%" }} >
                                <Grid container item justifyContent={"flex-start"} style={{ width: "100%", float: "right", textAlign: "right" }}>
                                    <span style={{ marginRight: "10px" }}>{`מספר מעקב : `}</span>
                                    <span style={{ marginRight: "10px", marginLeft: "10px" }}>{shipmentInfo?.parentId != 0 ? shipmentInfo?.params?.trackingNum : shipmentInfo?.hawb}</span>
                                </Grid>
                                {/*<Grid container item justifyContent={"flex-start"} lg={8} sx={{ width: "100%", wordBreak: "break-all" }}>
                                    <p style={{ width: "100%", textAlign: "right", margin: "0 10px" }}>{shipmentInfo?.parentId != 0 ? shipmentInfo?.params?.trackingNum : shipmentInfo?.hawb}</p>
                                </Grid>*/}
                            </Box>
                            {/*<Grid container item justifyContent="center" sx={{ fontSize: "20px", direction: "rtl" }} >
                                <Grid container item justifyContent={"flex-start"} lg={4}>
                                    משקל לחיוב
                                </Grid>
                                <Grid container item justifyContent={"flex-start"} lg={8}>
                                    : {getChargeableWeight()} ק״ג
                                </Grid>
                            </Grid>*/}
                            <Box container item flexWrap="nowrap" justifyContent="center" sx={{ fontSize: "20px", direction: "rtl", width: "100%" }} >
                                <Grid container item justifyContent={"flex-start"} style={{ width: "100%", float: "right", textAlign: "right" }}>
                                    <span style={{ marginRight: "10px" }}>{`משקל פיזי `}</span>  <span style={{ marginRight: "10px", marginLeft: "10px" }}>{ `:`}</span> {Number(shipmentInfo?.params?.userPaymentData?.weight).toFixed(2)} ק״ג
                                </Grid>
                            </Box>
                            <Box container item flexWrap="nowrap" justifyContent="center" sx={{ fontSize: "20px", direction: "rtl", width: "100%" }} >
                                <Grid container item justifyContent={"flex-start"} style={{ width: "100%", float: "right", textAlign: "right" }}>
                                    <span style={{ marginRight: "10px" }}>{`משקל נפחי`}</span> <span style={{ marginRight: "10px", marginLeft: "10px" }}>{`:`}</span>  {Number(getChargeableWeight1()).toFixed(2)} ק״ג
                                </Grid>
                            </Box>
                            <Box flexWrap="nowrap" justifyContent="center" sx={{ fontSize: "20px", direction: "rtl", width: "100%" }} >
                                <Grid container item justifyContent={"flex-start"} style={{ width: "100%", float: "right", textAlign: "right" }}>
                                    <span style={{ marginRight: "10px" }}>{`משקל לחיוב`}</span>  <span style={{ marginRight: "10px", marginLeft: "10px" }}>{`:`}</span> {!isMobile() ? `הגבוה מבין השניים` : ` הגבוה מבין השניים `}
                                </Grid>
                            </Box>
                            <Box flexWrap="nowrap" justifyContent="center" sx={{ fontSize: "20px", direction: "rtl", width:"100%" }} >
                                <Grid container item justifyContent={"flex-start"} style={{ width: "100%", float: "right", textAlign: "right" }}>
                                    <span style={{ marginRight: "10px" }}>{`מידות בס״מ`}</span> <span style={{ marginRight: "10px", marginLeft: "10px" }}>{`:`}</span> <span style={{ direction: "rtl" }}>{`${shipmentInfo?.params?.userPaymentData?.height}x${shipmentInfo?.params?.userPaymentData?.length}x${shipmentInfo?.params?.userPaymentData?.width}`}</span> 
                                </Grid>
                            </Box>
                            {shipmentInfo?.params?.notes?.includes("Repack Service:") && <Box flexWrap="nowrap" justifyContent="center" sx={{ fontSize: "20px", direction: "rtl", width: "100%" }} >
                                <Grid container item justifyContent={"flex-start"} style={{ width: "100%", float: "right", textAlign: "right" }}>
                                    <span style={{ marginRight: "10px" }}>{`מידות מקוריות`}</span> <span style={{ marginRight: "10px", marginLeft: "10px" }}>{`:`}</span> <span style={{ direction: "rtl" }}>{`${getOldDimes(shipmentInfo?.params?.notes)}`}</span>
                                </Grid>
                            </Box>}
                            {shipmentInfo?.params?.notes?.includes("Repack Service:") && <Box flexWrap="nowrap" justifyContent="center" sx={{ fontSize: "20px", direction: "rtl", width: "100%" }} >
                                <Grid container item justifyContent={"flex-start"} style={{ width: "100%", float: "right", textAlign: "right" }}>
                                    <span style={{ marginRight: "10px" }}>{`משקל מקורי`}</span> <span style={{ marginRight: "10px", marginLeft: "10px" }}>{`:`}</span> <span style={{ direction: "rtl" }}>{`${getOldOld(shipmentInfo?.params?.notes)}`}</span>
                                </Grid>
                            </Box>}
                            {false && <Grid container item justifyContent="center" sx={{ fontSize: "20px", direction: "rtl" }} >
                                <Grid container item justifyContent={"flex-start"} lg={4} >
                                    {`קופון`} 
                                </Grid>
                                <Grid container item justifyContent={"flex-end"} lg={4} sx={{ fontSize: "20px", direction: "ltr" }}>
                                    
                                    ({shipmentInfo?.params?.couponText})

                                </Grid>
                                <Grid container item justifyContent={"flex-end"} lg={4} sx={{ fontSize: "20px", direction: "ltr" }}>
                                    
                                    {shipmentInfo?.params?.couponDeduction}

                                </Grid>
                            </Grid>}
                            {/*{shipmentInfo.params.repackCosts && <Grid item container justifyContent={"flex-end"} style={{ fontSize: "20px", direction: "rtl", textAlign:"right" }}>
                                <Grid item container lg={!isMobile() ? 4 : 12} > Repack Cost:</Grid>
                                <Grid item container lg={8}> $ {getTotalRepackCost(shipmentInfo.params.repackCosts)}</Grid>
                            </Grid>}*/}
                            {shipmentInfo.consolidationStatus == 3 &&
                                <Grid container item lg={12} xs={12} justifyContent="flex-end" alignContent="flex-end" sx={{ mt: 5, fontSize: "20px", direction: "rtl" }}>
                                    
                                    <Grid container item justifyContent={"flex-start"} lg={4} >
                                        {`איחוד חבילות `} 
                                    </Grid>
                                    <Grid container item justifyContent={"flex-start"} lg={8} sx={{ fontSize: "20px", direction: "rtl" }}>
                                        {shipmentInfo?.params?.notes?.split("pack:")[1]?.replaceAll("," , " ")}

                                    </Grid>
                                </Grid>
                            }

                            <Grid container item justifyContent="center" sx={{ fontSize: "20px",mt:3 }} >
                                <Button variant='contained' sx={{ m: 2, borderRadius: "25px", background: "#FF3452", padding: "3px" }} onClick={() => {
                                    //setIsProfile(true)
                                    setParcelImage("");
                                    onHandleCancelInfoModal();
                                    }} >OK</Button>
                            </Grid>
                        </Grid>
                    </Dialog>
                )}

                {openConsolidateConfirm && (
                    <Dialog maxWidth='sm' direction={'rtl'} open={openConsolidateConfirm} title={`איחוד חבילות`} onHandleCancel={onHandleCancelConsolidateConfirm}>
                        <Grid container item justifyContent="center">
                            
                            <Grid container item justifyContent="center" style={{ direction: "rtl", marginTop:"20px", fontSize:"1.25rem" }}>
                                { `האם להמשיך בתהליך האיחוד ?`}
                            </Grid>

                            <Grid container item justifyContent="space-around" sx={{ fontSize: "20px", mt: 1 }} >
                                <Button variant='contained' sx={{ m: 2, borderRadius: "25px", background: "#FF3452", padding: "3px" }} onClick={() => {

                                    var ids = [];
                                    for (var i = 0; i < selectedConsGroup.parcels?.length; i++) {
                                        if (selectedConsGroup.parcels[i].selected) {
                                            ids.push(selectedConsGroup.parcels[i].id)
                                        }
                                    }
                                    dispatch(setIsShippingLoading(true))
                                    onHandleCancelConsolidateConfirm()
                                    onHandleCancelConsolidateModal();
                                    consolidateParcels(getCookie("SESSION_ID"), ids, selectedConsGroup.freeText, function (data) {
                                        //console.log(data)
                                        //dispatch(setIsShippingLoading(false))
                                        onHandleCancelConsolidateConfirm()
                                        onHandleCancelConsolidateModal();
                                        if (data?.misc?.CODE == 1) {
                                            loadParcels()
                                            dispatch(snackbarToggle({ type: 'success', message: "בקשתך בטיפול ותענה בהקדם" }));
                                        } else {
                                            dispatch(setIsShippingLoading(false))
                                            dispatch(snackbarToggle({ type: 'error', message: "הערות ללקוח (255 תווים)" }));
                                        }
                                    })
                                }} >אישור</Button>
                                <Button variant='contained' sx={{ m: 2, borderRadius: "25px", background: "#FF3452", padding: "3px" }} onClick={() => {
                                    //setIsProfile(true)
                                    onHandleCancelConsolidateConfirm();
                                }} >ביטול</Button>
                            </Grid>
                        </Grid>
                    </Dialog>
                )}

                {openConsolidateModal && (
                    <Dialog maxWidth='md' direction={'rtl'} open={openConsolidateModal} title={ `איחוד חבילות`} onHandleCancel={onHandleCancelConsolidateModal}>
                        <Grid container item justifyContent="flex-end">
                            <Grid container item justifyContent="flex-end" sx={{ border: "1px solid black", mb: 4, borderRadius:"10px",padding:"5px" }}>
                               
                                <Grid container item justifyContent="flex-end">
                                <Typography className='dir-rtl' >
                                        <b style={{ margin: "10px" }}>{`שימו לב:`}</b>
                                        <ul style={{ listStyleType: "number", marginRight: "20px", marginBlockStart: "0", paddingInlineStart: "0", marginBlockEnd: "0" }}>
                                            <li>{`ניתן לשלוח לאיחוד רק חבילות שעדיין לא שולם עבורן המשלוח לארץ.`}</li>
                                            <li><span style={{ textDecoration: "underline" }}>{`לא ניתן לשלוח לאיחוד חבילה מאוחדת.`}</span></li>
                                            <li>{ `לא ניתן לפצל חבילות בחזרה לאחר איחודן פיזית.`}</li>
                                            <li>{ `בבחירת " איחוד החבילות בקרטון חדש, ללא הוצאה מקרטון חיצוני" הנפח הכולל עשוי לגדול וכך גם עלויות השילוח.`}</li>
                                            <li>{ `בסיום התהליך תשלח לך הודעת מייל על קליטת חבילה חדשה במחסן, המורכבת מכל החבילות שאוחדו.`}</li>
                                            <li>{ `לאחר האיחוד יש להצהיר למכס על סכום כל המוצרים שנמצאים בחבילה המאוחדת ולהעלות את כל החשבוניות.`}</li>
                                            <li>{ `לאחר ביצוע האיחוד, הביטוח יהיה תקף לאובדן בלבד ולא יכסה נזק.`}</li>
                                        </ul>
                                        <br />
                                        <b style={{ margin: "10px" }}>{ `מגבלות על האיחוד:`}</b>
                                        <ul style={{ listStyleType: "number", marginRight: "20px", marginBlockStart: "0", paddingInlineStart: "0", marginBlockEnd: "0" }}>
                                            <li>{ `לא ניתן לאחד חבילות המכילות מוצר שביר או רגיש, או שמשקלן הכולל לאחר האיחוד עולה על 15 ק"ג או על 60*40*40 ס"מ.`}</li>
                                            <li><span style={{ textDecoration: "underline" }}>{ `לא ניתן לאחד חבילה מאוחדת`}</span></li>
                                            <li>{ `ניתן לאחד עד 10 חבילות בתשלום, ועד 3 חבילות שפוצלו מאותה חשבונית ללא עלות.`}</li>
                                            <li>{ `אם ברצונך לשלוח לאיחוד גם חבילות שפוצלו על ידי הספק וגם כאלה שלא – יש לבחור איחוד בתשלום וליצור קשר עם שירות הלקוחות לאחר שהאיחוד יבוצע ולפני התשלום על המשלוח.`}</li>
                                            <li>{ `אם לא ניתן לבצע את האיחוד, הבקשה תבוטל והסיבה תופיע באזור האישי.`}</li>
                                        </ul>
                                        <br/>
                                        <b style={{ margin: "10px" }}>{ `איחוד חבילות שפוצלו ע"י המוכר (ללא עלות):`}</b>
                                        <ul style={{ listStyleType: "number", marginRight: "20px", marginBlockStart: "0", paddingInlineStart: "0", marginBlockEnd: "0" }}>
                                            <li>{ `ניתן לאחד עד 3 חבילות שפוצלו ע"י המוכר ויש להן חשבונית אחת, עם מס' הזמנה אחד ומוכר אחד (שאינו מרקטפלייס).`}</li>
                                            <li>{ `במידה והמוכר פיצל את החבילות ליותר מ-3 חבילות, אנא פנה לשירות הלקוחות עם החשבונית.`}</li>
                                            <li>{ `עבור חבילות שניקנו באותו מרקטפלייס (איביי, אמזון וכד') ממוכרים שונים – האיחוד יהיה כרוך בתשלום. חבילות מאותו מוכר (למשל Sold by Amazon) ניתן לאחד ללא תשלום.`}</li>
                                            {/*<li>{ ``}</li>*/}
                                        </ul>
                                    </Typography>
                                </Grid>
                            </Grid>
                            {consolidationParcelsGroup.map((cParcelGroup, groupIndex) => (<Grid key={cParcelGroup.group} container item justifyContent="center">
                                
                                <Grid container item justifyContent="center" sx={{ border: "1px solid black", borderRadius: "10px", mb:4}}>
                                    <Grid container item justifyContent="center" lg={11} >
                                        <Button variant='outlined' sx={{ mt: -2, borderRadius: "5px", borderColor: "#FF3452", color: "#FF3452", padding: "3px", background: "white !important" }} onClick={() => {

                                    
                                        }} >
                                            <b> {allWh?.find(u => u.id === cParcelGroup.group)?.name}</b> 
                                        </Button>
                                    </Grid>


                                    <Grid container item justifyContent="space-between" lg={11} flexWrap="nowrap" sx={{ mt: 2 }} style={{ borderBottom: `${isMobile() ? "1px solid darkgrey" : "none"}` }}>
                                        {<Grid container item justifyContent="flex-end" sm={isMobile() ? 1 : 4}><div className="full_width_container bold_text rtl_text smallx_text">{"הערות"}</div> </Grid>}
                                        {!isMobile() && <Grid container item justifyContent="flex-end" sm={2} style={{ marginRight: "5px", marginLeft: "5px" }}><div className="full_width_container bold_text rtl_text smallx_text">חנות</div> </Grid>}
                                        {!isMobile() && <Grid container item justifyContent="flex-end" sm={2} style={{ marginRight: "5px", marginLeft: "5px" }}><div className="full_width_container bold_text rtl_text smallx_text"> תכולת החבילה   </div></Grid>}
                                        {isMobile() && <Grid container item justifyContent="flex-end" sm={4} style={{ marginRight: "5px", marginLeft: "5px" }}><div className="full_width_container bold_text rtl_text smallx_text">{`מס׳ חבילה`}</div></Grid>}
                                        <Grid container item justifyContent="flex-end" sm={2} style={{ marginRight: "5px", marginLeft: "5px", maxWidth: "15%" }}><div className="full_width_container bold_text rtl_text smallx_text">{ `חנות`} </div>  </Grid>
                                        <Grid container item justifyContent="flex-end" sm={1.5} style={{ marginTop: "-9px", maxWidth: "14%" }}  ><div className="full_width_container bold_text rtl_text smallx_text"></div>  </Grid>
                                    </Grid>


                                    {cParcelGroup?.parcels?.map((parcel, index) => (<Grid container item justifyContent="space-between" lg={11} flexWrap="nowrap" style={{ borderBottom: `${isMobile() ? "1px solid darkgrey" : "none"}` }}>
                                        
                                        <Grid container item justifyContent="flex-end" sm={4} style={{textAlign:"right"}}>{dissableConsolidation(parcel, allWh?.find(u => u.id === cParcelGroup.group)) ? dissableConsolidation(parcel, allWh?.find(u => u.id === cParcelGroup.group)) : ""} </Grid>
                                        {!isMobile() && <Grid container item justifyContent="flex-end" sm={2} style={{ marginRight: "5px", marginLeft: "5px" }}>{parcel.hawb} </Grid>}
                                        {!isMobile() && <Grid container item justifyContent="flex-end" sm={2} style={{ marginRight: "5px", marginLeft: "5px" }}>{parcel.shippingDesc} </Grid>}
                                        {isMobile() && <Grid container item justifyContent="flex-end" sm={2} style={{ marginRight: "5px", marginLeft: "5px", textAlign:"right" }}>{parcel.hawb} <br/> {parcel.shippingDesc} </Grid>}
                                        <Grid container item justifyContent="flex-end" sm={2} style={{ marginRight: "5px", marginLeft: "5px", maxWidth: "15%" }} ><div style={{width:"100%",textAlign:"right"}}>{parcel.params?.sender?.senderName}, {parcel.params?.sender?.senderCountry}</div> </Grid>
                                        <Grid container item justifyContent="flex-end" sm={1.5} style={{ marginTop: "-9px", maxWidth: "14%" }} alignContent="flex-start">
                                            <Checkbox title={dissableConsolidation(parcel, allWh?.find(u => u.id === cParcelGroup.group))?"Parcel is not elegible for consolidation as dimensions are not in the limit.":"" } disabled={dissableConsolidation(parcel, allWh?.find(u => u.id === cParcelGroup.group))} checked={parcel.selected} onChange={event => {
                                                var tCGroup = JSON.parse(JSON.stringify([...consolidationParcelsGroup]))
                                                var parcels = JSON.parse(JSON.stringify([...tCGroup[groupIndex].parcels]))
                                                var numSelected = 0;
                                                for (var i = 0; i < parcels?.length; i++) {
                                                    if (parcels[i].selected) {
                                                        numSelected++;
                                                    }
                                                }
                                                if (!freeRepack && numSelected >= 3 && event.target.checked)
                                                    return
                                                if ((numSelected < 10 && event.target.checked) || !event.target.checked) {
                                                    for (var i = 0; i < parcels?.length; i++) {
                                                        if (index == i) {
                                                            parcels[i].selected = event.target.checked;
                                                        }
                                                    }
                                                    tCGroup[groupIndex].parcels = parcels
                                                    setConsolidationParcelsGroup(tCGroup)
                                                }
                                                //event.target.checked
                                            }} />
                                        </Grid>
                                    </Grid>))}
                                    <Grid container item justifyContent="flex-end" sx={{ fontSize: "20px", mb: 1, mt: 1 }} lg={11}>
                                        {cParcelGroup.freeText?.length > 254 && <Grid container item flexDirection="row-reverse" style={{ color: "red" }} direction={'rtl'}>
                                            {`אורך הודעה מקסימלי 250 תווים`}
                                        </Grid>}


                                        {<Grid container direction={'rtl'} item flexDirection="row-reverse" justifyContent="centert" sx={{ padding: "10px", fontSize: "20px", textAlign: "right", marginTop: "20px", marginBottom: "20px" }}>
                                            <Grid container direction={'rtl'} item flexDirection="row-reverse" alignItems="flex-start" justifyContent="flex-start" sx={{ fontSize: "20px", textAlign: "right" }} flexWrap="nowrap">
                                                <><input style={{ marginTop: "10px" }} onChange={() => {
                                                    setFreeRepack1(true)
                                                }} type="radio" defaultChecked value="FEMALE" name={"" + groupIndex} /> <p style={{ margin: "0", marginRight: "10px" }}>{`איחוד חבילות - בתשלום של 3$ עבור כל חבילה הנכללת באיחוד`}</p></>
                                            </Grid>
                                            <Grid container direction={'rtl'} item flexDirection="row-reverse" alignItems="flex-start" sx={{ fontSize: "20px", textAlign: "right" }} flexWrap="nowrap">
                                                <><input style={{ marginTop: "10px" }} onChange={() => {
                                                    setFreeRepack1(false)

                                                    var ids = [];
                                                    for (var i = 0; i < cParcelGroup.parcels?.length; i++) {
                                                        if (cParcelGroup.parcels[i].selected) {
                                                            ids.push(cParcelGroup.parcels[i].id)
                                                        }
                                                    }
                                                    if (ids?.length > 3) {
                                                        var tCGroup = JSON.parse(JSON.stringify([...consolidationParcelsGroup]))
                                                        var parcels = JSON.parse(JSON.stringify([...tCGroup[groupIndex].parcels]))
                                                        for (var i = 0; i < parcels?.length; i++) {
                                                            parcels[i].selected = false;
                                                        }
                                                        tCGroup[groupIndex].parcels = parcels
                                                        setConsolidationParcelsGroup(tCGroup)
                                                    }
                                                }} type="radio" value="FEMALE" name={"" + groupIndex} /> <p style={{ margin: "0", marginRight: "10px" }}>{`איחוד חבילות שפוצלו על ידי המוכר (חשבונית אחת לכולן) – ללא עלות`}</p></>
                                            </Grid>
                                        </Grid>}

                                        {<Grid container direction={'rtl'} item flexDirection="row-reverse" justifyContent="centert" sx={{ padding: "10px", fontSize: "20px", textAlign: "right", marginTop: "20px", marginBottom: "20px" }}>
                                            <Grid container direction={'rtl'} item flexDirection="row-reverse" alignItems="flex-start" justifyContent="flex-start" sx={{ fontSize: "20px", textAlign: "right" }} flexWrap="nowrap">
                                                :{ `בקשות מצוות המחסן`}
                                            </Grid>
                                            <Grid container direction={'rtl'} item flexDirection="Column" justifyContent="flex-start" sx={{ fontSize: "20px", textAlign: "right" }} flexWrap="nowrap">
                                                {<Grid item container flexDirection="row-reverse" alignItems="flex-start" flexWrap="nowrap"><input style={{ marginTop: "10px" }} onChange={() => {
                                                    var tCGroup = JSON.parse(JSON.stringify([...consolidationParcelsGroup]));
                                                    tCGroup[groupIndex].freeText = 9;
                                                    setConsolidationParcelsGroup(tCGroup);
                                                }} type="radio" value="MALE" defaultChecked name={"1" + groupIndex} /> <p style={{ margin: "0", marginRight: "10px" }}>{ `איחוד + צמצום נפח: הוצאה מקרטון חיצוני לשקית שילוח`}</p></Grid>}
                                                {<Grid item container flexDirection="row-reverse" alignItems="flex-start" flexWrap="nowrap"><input style={{ marginTop: "10px" }} onChange={() => {
                                                    var tCGroup = JSON.parse(JSON.stringify([...consolidationParcelsGroup]));
                                                    tCGroup[groupIndex].freeText = 10;
                                                    setConsolidationParcelsGroup(tCGroup);
                                                }} type="radio" value="MALE" name={"1" + groupIndex} /> <p style={{ margin: "0", marginRight: "10px" }}>{ `איחוד + צמצום נפח: הוצאה מקרטון חיצוני לקרטון קטן יותר`}</p></Grid>}
                                                {<Grid item container flexDirection="row-reverse" alignItems="flex-start" flexWrap="nowrap"><input style={{ marginTop: "10px" }} onChange={() => {
                                                    var tCGroup = JSON.parse(JSON.stringify([...consolidationParcelsGroup]));
                                                    tCGroup[groupIndex].freeText = 11;
                                                    setConsolidationParcelsGroup(tCGroup);
                                                }} type="radio" value="MALE" name={"1" + groupIndex} /> <p style={{ margin: "0", marginRight: "10px" }}>{ `איחוד החבילות בקרטון חדש, ללא הוצאה מקרטון חיצוני (עשוי להגדיל נפח)`}</p></Grid>}
                                            </Grid>
                                        </Grid>}

                                        <Grid container direction={'rtl'} item justifyContent="center" sx={{ fontSize: "20px", textAlign: "right" }}>
                                            { "?"} { `האם לאחד לך את החבילות שבחרת `}
                                        </Grid>

                                        <Grid container item justifyContent="center" sx={{ fontSize: "20px" }}>
                                            <Button variant='contained' sx={{ m: 2, borderRadius: "25px", background: "#FF3452", padding: "3px", paddingLeft: "20px", paddingRight: "20px" }} onClick={() => {
                                                onHandleCancelConsolidateModal();
                                            }}>{`לא`}</Button>
                                            <Button disabled={!isValidForConsolidation(cParcelGroup)} variant='contained' sx={{ m: 2, borderRadius: "25px", background: "#FF3452", padding: "3px", paddingLeft: "20px", paddingRight: "20px" }} onClick={() => {
                                                //if (cParcelGroup.freeText.length < 255){
                                                    //setSelectedConsGroup(cParcelGroup)
                                                    onHandleCancelConsolidateModal();
                                                    //setOpenConsolidateConfirm(true);

                                                    var ids = [];
                                                    for (var i = 0; i < cParcelGroup.parcels?.length; i++) {
                                                        if (cParcelGroup.parcels[i].selected) {
                                                            ids.push(cParcelGroup.parcels[i].id)
                                                        }
                                                    }
                                                    dispatch(setIsShippingLoading(true))
                                                    onHandleCancelConsolidateConfirm()
                                                    onHandleCancelConsolidateModal();
                                                    consolidateParcels(getCookie("SESSION_ID"), ids, cParcelGroup.freeText ? cParcelGroup.freeText : 9 , !freeRepack, function (data) {
                                                        //console.log(data)
                                                        //dispatch(setIsShippingLoading(false))
                                                        //onHandleCancelConsolidateConfirm()
                                                        onHandleCancelConsolidateModal();
                                                        if (data?.misc?.CODE == 1) {
                                                            loadParcels()
                                                            dispatch(snackbarToggle({ type: 'success', message: "בקשתך בטיפול ותענה בהקדם" }));
                                                        } else {
                                                            dispatch(setIsShippingLoading(false))
                                                            dispatch(snackbarToggle({ type: 'error', message: "הערות ללקוח (255 תווים)" }));
                                                        }
                                                        window.location.href = "/accounts?vers=" + (new Date()).getTime();
                                                    })
                                                //}
                                            }}>{` כן`}</Button>
                                        </Grid>
                                        {/*<Grid container item alignItems="center" justifyContent="center" sx={{ fontSize: "20px", mb: 1, mt: 0 }} lg={12}>

                                            <Button disabled={!isValidForConsolidation(cParcelGroup)} variant='contained' sx={{ borderRadius: "25px", background: "#FF3452", padding: "5px 25px" }} onClick={() => {
                                                setSelectedConsGroup(cParcelGroup)
                                                onHandleCancelConsolidateModal();
                                                setOpenConsolidateConfirm(true);
                                            }} >איחוד חבילות</Button>
                                            
                                        </Grid>*/}
                                    </Grid>

                                </Grid>
                            </Grid>))}
                            <Grid container item justifyContent="center" sx={{ fontSize: "20px" }}>
                                <Button variant='contained' sx={{ m: 2, borderRadius: "25px", background: "#FF3452", padding: "3px", paddingLeft: "20px", paddingRight: "20px" }} onClick={() => {
                                    onHandleCancelConsolidateModal();
                                }}>{`סגור`}</Button>
                            </Grid>
                            
                        </Grid>
                        {/*<Grid container item justifyContent="center" sx={{ fontSize: "20px", mt: 3 }} >
                            <Button variant='contained' sx={{ m: 2, borderRadius: "25px", background: "#FF3452", padding: "3px" }} onClick={() => {

                                onHandleCancelConsolidateModal();
                            }} >OK</Button>
                        </Grid>*/}
                    </Dialog>
                )}
                {openBuyMeModal && (
                    <Dialog maxWidth='md' direction={'rtl'} open={openBuyMeModal} title={'Buy-Me'} onHandleCancel={onHandleCancelBuyMeModal}>
                        <Grid container item>
                            The personal property service allows you to shop abroad without leaving home, buy the brands you want at huge discounts abroad and enjoy products that cannot be found in Israel.
                        </Grid>
                        <Grid container md={ 12} sx={{mt:5,mb:5}} justifyContent="center">
                            <Grid container item justifyContent="center">
                                <Grid container item lg={8} justifyContent="flex-end" alignContent="flex-start" sx={{ fontSize: "14px",marginRight:2 }} >
                                    <b>מאיפה תרצה לקנות</b>
                                </Grid>
                                <Grid container item lg={8} justifyContent="flex-end" alignContent="flex-start" sx={{ fontSize: "14px" }} >
                                    <SelectField
                                        required
                                        value={selectedBuyMeShopId}
                                        onChange={event => {
                                            setSelectedBuyMeShopId(event.target.value);                                       
                                        }}
                                        label=''
                                        options={buyMeShops}
                                        islabelAnimate={false}
                                        isPrefix
                                        dir="rtl"
                                        isNumeric={true}
                                        sx={{ m: 0, mr: "10px", height: "30px" }}
                                    />
                                </Grid>
                            </Grid>
                            <Grid container md={12} className='' justifyContent="center" sx={{ mt: 2 }}>
                                <Grid container item sm={8} justifyContent="flex-end" alignContent="flex-start" sx={{ fontSize: "14px", padding: 2 }} >
                                    <b>פרטי המוצר</b>
                                </Grid>
                                <Grid item container  lg={8}  >
                                    <Grid container item lg={12}>
                                    <TextField
                                        className='text-field'
                                        value={buyMeInfo.link}
                                        onChange={event => {
                                            setBuyMeInfo(prev => ({ ...prev, link: event.target.value }))
                                        }}
                                        label='לינק למוצר'
                                        islabelAnimate={false}
                                        isPrefix
                                        parentClassName=''
                                        sx={{width:"100%",  margin: "0 5px 5px 0" }}
                                        />
                                    </Grid>
                                    <Grid container item lg={6}>
                                        <TextField
                                            className='text-field'
                                            required
                                            value={buyMeInfo.size}
                                            onChange={event => {
                                                setBuyMeInfo(prev => ({ ...prev, size: event.target.value }))
                                            }}
                                            label="מידה (אם קיימת )"
                                            islabelAnimate={false}
                                            isPrefix
                                            parentClassName=''
                                            sx={{ margin: "0 5px 5px 0" }}
                                            />
                                    </Grid>
                                    <Grid container item lg={6}>
                                        <TextField
                                            className='text-field'
                                            required
                                            value={buyMeInfo.color}
                                            onChange={event => {
                                                setBuyMeInfo(prev => ({ ...prev, color: event.target.value }))
                                            }}
                                            label="צבע ( אם קיים)"
                                            islabelAnimate={false}
                                            isPrefix
                                            parentClassName=''
                                            sx={{ margin: "0 5px 5px 0" }}
                                        />
                                    </Grid>

                                    <Grid container item lg={12} justifyContent="flex-end" alignContent="center">
                                        <Grid container item lg={6} justifyContent="flex-end" alignContent="center" sx={{ mb: 3 }}>
                                            <SelectField
                                                required
                                                value={selectedCur}
                                                onChange={event => {
                                                    setSelectedCur(event.target.value);
                                                }}
                                                label=''
                                                options={currencies}
                                                islabelAnimate={false}
                                                isPrefix
                                                dir="rtl"
                                                lg={6}
                                                isNumeric={true}
                                                sx={{ m: 0, mr: "10px", height: "30px", width: "100%" }}
                                            />
                                        </Grid>
                                        <Grid container item lg={6}>
                                            <TextField
                                                className='text-field'
                                                required
                                                value={buyMeInfo.price}
                                                onChange={event => {
                                                    setBuyMeInfo(prev => ({ ...prev, price: event.target.value }))
                                                }}
                                                label="מחיר"
                                                islabelAnimate={false}
                                                isPrefix
                                                parentClassName=''
                                                sx={{ margin: "0 5px 5px 0" }}
                                            />
                                        </Grid>
                                    </Grid>
                                    
                                    

                                    
                                   
                                    <Grid container item lg={6}>
                                        <SelectField
                                            required
                                            value={numberOfUnitId}
                                            onChange={event => {
                                                setnumberOfUnitId(event.target.value);
                                            }}
                                            label=''
                                            options={numberOfUnits}
                                            islabelAnimate={false}
                                            isPrefix
                                            dir="rtl"
                                            lg={ 12}
                                            isNumeric={true}
                                            sx={{ m: 0, mr: "10px", height: "30px",width:"100%" }}
                                        />
                                    </Grid>
                                    <Grid container item lg={6} justifyContent="flex-start" alignContent="center">
                                        <b style={{ marginRight: "12px"}}>מספר יחידות</b>
                                    </Grid>

                                </Grid>
                            </Grid>

                            <Grid container item justifyContent="center" sx={{mt:2}}>
                                
                                <Grid container item lg={8} justifyContent="flex-end" alignContent="flex-start" sx={{ fontSize: "14px" }} >
                                    <MultilineField
                                        className='multilineWidth_70 text-field'
                                        lg={12}
                                        rows={2}
                                        value={buyMeInfo.freeText}
                                        onChange={event => {
                                            setBuyMeInfo(prev => ({ ...prev, freeText: event.target.value }))
                                        }}
                                        label="הערות"
                                        dir={'rtl'}
                                    />
                                    <Button onClick={() => {
                                        var cur = currencies?.find(u => u.id === selectedCur)
                                        var wh = buyMeShops?.find(u => u.id === selectedBuyMeShopId)
                                        var numUnit = numberOfUnits?.find(u => u.id === numberOfUnitId)
                                        var object = {
                                            url: buyMeInfo.link,
                                            color: buyMeInfo.color,
                                            size: buyMeInfo.size,
                                            price: buyMeInfo.price,
                                            freeText: buyMeInfo.freeText,
                                            whName: wh?.name,
                                            whId: wh?.id,
                                            numUnits: numUnit?.name,
                                            currency: selectedCur,
                                            otherInfo: {
                                                currencyObj: cur
                                            }
                                            ,
                                        }
                                        addBuyMeRequest(userInfo.session, object, function (resp) {
                                            if (resp.misc.CODE == 1) {
                                                getBuyMeRequestsItems();
                                                dispatch(snackbarToggle({ type: 'success', message: "Buy-Me request added succesfully" }));
                                                onHandleCancelBuyMeModal();
                                            } else {
                                                dispatch(snackbarToggle({ type: 'error', message: resp.message }));

                                            }
                                        })

                                    }}> קבל הצעה</Button>
                                </Grid>
                                
                            </Grid>
                        </Grid>
                        <Grid container item justifyContent="flex-start">
                            <b>Important Information</b>
                            <ul>
                                <li>After sending the request, we will locate the product(s) for you, calculate the tax costs (if applicable) and the shipping costs to Israel</li>
                                <li>The price offer will be sent to you by email or text message, depending on your choice, within 2 business days</li>
                                <li>The quote is valid for 48 hours from the moment it is delivered</li>
                                <li>The shipping time of the product(s) to USSHOPS logistics centers abroad is the responsibility of the store where the order is placed</li>
                                <li>Transactions over NIS 300 can be divided into up to 36 equal payments</li>
                                <li>After placing an order we will purchase the product(s) for you. The products will be delivered to you within about 15 business days</li>
                                <li>The purchase is subject to the terms of use</li>
                            </ul>
                        </Grid>
                    </Dialog>
                )}
                <MetaTags id="metaAccounts">
                    <title>Redbox Accounts </title>
                    <meta http-equiv="Cache-Control" content="no-cache, must-revalidate" />
                    <meta http-equiv="Pragma" content="no-cache" />
                    <meta http-equiv="Expires" content="0" />
                    <meta id="meta-description" name="Accounts" content="איזור אישי" />
                    <meta id="meta-description-title" property="og:title" content="Redbox parcel" />
                </MetaTags>
                <Box component={'section'} className="page-title dark_image_filter" >
                <Box className="title-section">
                    <Box className="container">
                        <Typography component={'h1'} className="page-main-title center_text rtl_text bold_text">איזור אישי</Typography>
                            <Typography component={'h2'} className="page-main-title center_text rtl_text bold_text cursor_pointer" style={{textDecoration:"underline",fontSize:"20px"}} onClick={() => {
                                setIsProfile(true)
                            }}>הגדרות</Typography>
                    </Box>
                </Box>
            </Box>

            <main id="main-content">
                <div className="full_width">
                    <Box className="container">
                        <Grid container className="pad_60_0 popular-section" style={{ justifyContent: "center" }}>
                                {couponList.filter((c) => { if (!c.personal ) { return c} }).map((coupon, index) => (
                                <> {
                                        index < 3 && coupon.banner && <Grid item md={2.8} sm={5.5} xs={12} onClick={() => {
                                        copyToClipboard1(coupon.couponId, function (data) {
                                            dispatch(snackbarToggle({ type: 'success', message: "הקופון הועתק בהצלחה" }));
                                            window.setTimeout(function () { dispatch(snackbarToggle(false)); }, autoCloseSnackbar);
                                        });
                                        }} className="cursor_pointer shadow_box small_container relative_container  show_overflow" style={{ minHeight: "140px", margin: '0 0.8% 20px' }}>
                                            <img alt={coupon.params?.type} src={`data:${coupon.params?.type};base64,${coupon.banner}`} className="absolute_container" style={{ height: "100%", top: 0, left: 0, width: "100%", borderRadius: '20px' }} />
                                        {index == 0 && false && <img src={woman_jumping} className="absolute_container" style={{ borderRadius: '20px', height: "17vw", top: "-1vw", left: "-9vw", width: "auto", zIndex: 1 }} />}

                                    </Grid>
                                }
                                </>
                            ))

                            }
                                <Grid item md={2.8} sm={5.5} xs={12} className=" shadow_box small_container white_container cursor_pointer" style={{ minHeight: "140px", margin: '0 0.8% 20px', flexDirection: 'column' }} onClick={() => { setIsAddAddress(true); }}>
                                <div className="full_width_container row_flex" style={{ justifyContent: "flex-end" }}>
                                    <div className="col_flex">
                                            <div className="rtl_text darkgrey_text bold_text midx_text">הכתובות שלי בארץ</div>
                                            {<div className="row_flex row_space_center col_space_center">
                                                <div style={{ height:"25px" }} />
                                                {/*<img src={flag_tr_small} style={{ width: "23px", height: "15px", margin: "5px" }} />
                                            <img src={flag_po_small} style={{ width: "23px", height: "15px", margin: "5px" }} />
                                            <img src={flag_eu_small} style={{ width: "23px", height: "15px", margin: "5px" }} />
                                            <img src={flag_us_small} style={{ width: "23px", height: "15px", margin: "5px", marginRight: 0 }} />
*/}
                                            </div>}
                                    </div>
                                    <div className="col_flex">
                                        <img src={address1} style={{ width: "60px", height: "60px", margin: "10px" }} />
                                    </div>
                                </div>
                                    <div className="full_width_container smallx_text darkgrey_text rtl_text top_space_20" style={{ marginRight: "10px" }}>הכתובות למשלוח</div>
                                    <div className="full_width_container midx_text red_text rtl_text bold_text" style={{ marginRight: "10px" }}>הצג כתובות {'>'}</div>
                            </Grid>
                            <Grid item md={2.8} sm={5.5} xs={12} className=" shadow_box small_container white_container cursor_pointer" style={{ minHeight: "140px", margin: '0 0.8% 20px', flexDirection: 'column' }} onClick={() => { setActiveScreenInreg('PersonalData'); setIsRegister(true) }}>
                                <div className="full_width_container row_flex" style={{ justifyContent: "flex-end" }}>
                                    <div className="col_flex">
                                            <div className="rtl_text darkgrey_text bold_text midx_text" style={{fontSize:"18px"}}>הכתובות שלי בחו״ל</div>
                                        <div className="row_flex row_space_center col_space_center">
                                            {/*<img src={flag_tr_small} style={{ width: "23px", height: "15px", margin: "5px" }} />
                                            <img src={flag_po_small} style={{ width: "23px", height: "15px", margin: "5px" }} />
                                            */}
                                             {/*<img src={flag_eu_small} style={{ width: "23px", height: "15px", margin: "5px" }} />
                                            <img src={flag_us_small} style={{ width: "23px", height: "15px", margin: "5px", marginRight: 0 }} />*/}
                                        </div>
                                    </div>
                                    <div className="col_flex">
                                        <img src={address} style={{ width: "60px", height: "60px", margin: "10px" }} />
                                    </div>
                                </div>
                                    <div className="full_width_container smallx_text darkgrey_text rtl_text top_space_20" style={{ marginRight: "10px" }}>יצרנו עבורך כתובות לכל היעדים שלנו</div>
                                    <div className="full_width_container midx_text red_text rtl_text bold_text" style={{ marginRight: "10px" }}>הצג כתובות {'>'}</div>
                            </Grid>
                            {false && <div className="col-md-3 small_container white_container" style={{ height: "10vw" }}>
                                <div className="full_width_container row_flex top_space_20" style={{ justifyContent: "flex-end" }}>
                                    <div className="col_flex">
                                        <div className="darkgrey_text bold_text midx_text right_text">Super Shopper</div>
                                        <div className="row_flex white_container" style={{ justifyContent: "flex-start", width: "100%", height: "0.3vw", background: "#f0f0f2", boxShadow: "none !important" }}>
                                            <div className="darkgreen_button" style={{ width: "40%", height: "0.3vw" }}></div>
                                        </div>
                                        <div className="darkgrey_text bold_text rtl_text smallx_text">עוד 218 נק' ל- Mega shopper</div>
                                    </div>
                                    <div className="col_flex">
                                        <img src={trophy} style={{ width: "40px", height: "40px", margin: "10px" }} />
                                    </div>
                                </div>
                                <div className="full_width_container smallx_text darkgrey_text rtl_text top_space_20" style={{ marginRight: "10px" }}>מתקדמים בדרגות ומרוויחים יותר קשבק על כל קנייה</div>
                                <div className="full_width_container smallx_text darkgrey_text rtl_text bold_text" style={{ marginRight: "10px" }}>קראו עוד {'>'}</div>
                            </div>
                            }
                            {false && <div className="col-md-3 small_container white_container" style={{ height: "10vw" }}>
                                <div className="full_width_container row_flex top_space_20" style={{ justifyContent: "flex-end" }}>
                                    <div className="col_flex">
                                        <div className="darkgrey_text bold_text midx_text rtl_text right_text"> ה-Cash Back שלי</div>
                                        <div className="darkgrey_text bold_text midx_text right_text">12$</div>
                                    </div>
                                    <div className="col_flex">
                                        <img src={cashback} style={{ width: "40px", height: "40px", margin: "10px" }} />
                                    </div>
                                </div>
                                <div className="full_width_container smallx_text darkgrey_text rtl_text top_space_20" style={{ marginRight: "10px" }}>צוברים 0.25 $ קשבק על כל משלוח מעל 30 $</div>
                                <div className="full_width_container smallx_text darkgrey_text rtl_text bold_text" style={{ marginRight: "10px" }}>קראו עוד {'>'}</div>
                            </div>}
                        </Grid>
                        </Box>
                        <Grid item container lg={12} justifyContent="center">
                            <Grid item container justifyContent="center" lg={5.5} md={11} sx={11} style={{ textAlign: "center", margin: "10px", padding: "20px", direction: "rtl", color: "#FF3452", fontSize: "20px", fontWeight: "bold", border: "1px solid #FF3452", borderRadius: "5xp" }}>
                                { `לקוחות יקרים,  אנא שימו לב לשינויים הבאים בתנאי השירות:`}<br></br>
                                { `גודל החבילות הניתנות לשילוח: עד 20 ק"ג משקל פיזי/ נפחי ובמידות של עד 60*40*40 ס״מ.`}<br></br>
                                { `במידה וכבר הגיעה למחסן חבילה גדולה יותר אנא פנו לשירות הלקוחות.`}
                            </Grid>
                        </Grid>
                        {!isMobile()&&<div className="full_width top_space_40 row_flex row_space_center col_space_center">
                            {<Grid container item sm={3} justifyContent="flex-start" >
                                {(userInfo?.user?.token == 'RBP00103' || userInfo?.user?.token == 'RBP00102') &&<Button variant='contained' sx={{ m: 2, borderRadius: "25px", background: "#FF3452", paddingLeft: "20px", paddingRight: "20px" }} onClick={() => {
                                    onHandleOpenBuyMeModal()
                                    setBuyMeInfo({})
                                }}>   Buy-Me</Button>}
                                <Button variant='contained' sx={{ m: 2, borderRadius: "25px", background: "#FF3452", paddingLeft: "20px", paddingRight: "20px" }} onClick={() => {
                                    onHandleOpenConsolidateModal()
                                }}>{ `איחוד/צמצום חבילות`}</Button>
                            </Grid>}
                            <span className="rtl_text mid_text  cursor_pointer" onClick={() => {
                                setIsHistory(true)
                                setTabIndex(2)
                            }} style={{ fontWeight: tabIndex == 2 ? 'bold' : '' }}>&nbsp; &nbsp; &nbsp; היסטוריית הזמנות ({getHistoryCount()}) &nbsp;&nbsp;&nbsp;</span>
                            <span onClick={() => {
                                setIsHistory(false)
                                setTabIndex(1)
                            }} className="rtl_text mid_text  cursor_pointer" style={{ fontWeight: tabIndex == 1 ? 'bold' : '' }}>&nbsp;&nbsp;&nbsp;הזמנות פעילות (<span id="shipping_items"> {shipping_list?.length - getHistoryCount()}</span>)&nbsp;&nbsp;&nbsp;</span>
                            {(userInfo?.user?.token == 'RBP00103' || userInfo?.user?.token == 'RBP00102') && <span onClick={() => {
                                setIsHistory(false)
                                setTabIndex(3)
                            }} className="rtl_text mid_text  cursor_pointer" style={{ fontWeight: tabIndex == 3 ? 'bold' : '' }}>&nbsp;&nbsp;&nbsp;Buy-Me (<span id="shipping_items">{buyMeRequestsItems?.length}</span>)&nbsp;&nbsp;&nbsp;</span>
/**/}
                            {
                                <Grid item container justifyContent="center" flexWrap="nowrap" lg={4} style={{ marginLeft: "30px", marginTop: "10px" }}>
                                    <TextField
                                        className='text-field short'
                                        value={parcelSearch}
                                        onChange={event => {
                                            setParcelSearch(event.target.value);
                                        }}
                                        label={`מס' מעקב בחברת ההובלה בחו"ל`}
                                        islabelAnimate={false}
                                        isPrefix
                                        parentClassName=''
                                        sx={{
                                            width: "100%",
                                            margin: "0",
                                            "& input::placeholder": {
                                                color: "black",
                                                opacity: 1
                                            },
                                            '& .MuiTextField-root': {
                                                '& .MuiInputBase-fullWidth': {
                                                    border: '1px solid red',
                                                },
                                            },
                                        }}
                                    />
                                    <span style={{ margin: "7px" }} onClick={() => {
                                        if (parcelSearch?.trim()?.length > 7) {
                                            filter_check_get_parcel(parcelSearch);
                                        }
                                    }}>
                                        <SearchIcon style={{ width: "25px", height: "25px", color: parcelSearch?.trim()?.length > 7 ? "#FF3452" : "#666" }} />
                                    </span>
                                    <span style={{ margin: "7px" }} onClick={() => {
                                        setSearch("");
                                        setParcelSearch("");
                                    }}>
                                        <CloseIcon style={{ width: "25px", height: "25px", color: "#FF3452" }} />
                                    </span>
                                </Grid>
                            }
                        </div>
                        }
                        {isMobile() && <Grid container item lg={12} justifyContent="center" >
                            {<Button variant='contained' sx={{ m: 2, borderRadius: "25px", background: "#FF3452", paddingLeft: "20px", paddingRight: "20px" }} onClick={() => {
                                onHandleOpenConsolidateModal()
                            }}>{`איחוד/צמצום חבילות`}</Button>}
                        </Grid>}
                        {isMobile() && <div className="full_width row_flex row_space_center col_space_center">
                            <Grid item container justifyContent="center" flexWrap="nowrap" style={{ margin: "20px" }}>
                                <TextField
                                    className='text-field short'
                                    value={parcelSearch}
                                    onChange={event => {
                                        setParcelSearch(event.target.value);
                                    }}
                                    label={ `מס' מעקב בחברת ההובלה בחו"ל`}
                                    islabelAnimate={false}
                                    isPrefix
                                    parentClassName=''
                                    sx={{
                                        width: "100%",
                                        margin: "0",
                                        "& input::placeholder": {
                                            color: "black",
                                            opacity: 1
                                        },
                                        '& .MuiTextField-root': {
                                            '& .MuiInputBase-fullWidth': {
                                                border: '1px solid red',
                                            },
                                        },
                                    }}
                                />
                                <span style={{ margin: "7px" }} onClick={() => {
                                    if (parcelSearch?.trim()?.length > 7) {
                                        filter_check_get_parcel(parcelSearch);
                                    }
                                }}>
                                    <SearchIcon style={{ width: "25px", height: "25px", color: parcelSearch?.trim()?.length > 7 ? "#FF3452" : "#666" }} />
                                </span>
                                <span style={{ margin: "7px" }} onClick={() => {
                                    setSearch("");
                                    setParcelSearch("");
                                }}>
                                    <CloseIcon style={{ width: "25px", height: "25px", color: "#FF3452" }} />
                                </span>
                            </Grid>
                        </div>}
                        {/*{isMobile() && (userInfo?.user?.token == 'RBP00103' || userInfo?.user?.token == 'RBP00102') && <Grid container item lg={12} justifyContent="center" >
                            <Button variant='contained' sx={{ m: 2, borderRadius: "25px", background: "#FF3452", paddingLeft: "20px", paddingRight: "20px" }} onClick={() => {
                                onHandleOpenBuyMeModal()
                            }}>   Buy-Me</Button>
                        </Grid>}*/}
                        {isMobile() && <div style={{ flexWrap:"wrap", marginTop: "20px" }} className="full_width row_flex row_space_center col_space_center">
                            
                            <span className="rtl_text mid_text  cursor_pointer" onClick={() => {
                                setIsHistory(false)
                                setTabIndex(2)
                            }} style={{ fontWeight: tabIndex==2 ? 'bold' : '' }}>&nbsp; &nbsp; &nbsp; היסטוריית הזמנות ({getHistoryCount()}) &nbsp;&nbsp;&nbsp;</span>
                            <span onClick={() => {
                                setIsHistory(true)
                                setTabIndex(1)
                            }} className="rtl_text mid_text  cursor_pointer" style={{ fontWeight: tabIndex == 1 ? 'bold' : '' }}>&nbsp;&nbsp;&nbsp;הזמנות פעילות (<span id="shipping_items"> {shipping_list?.length - getHistoryCount()}</span>)&nbsp;&nbsp;&nbsp;</span>
                            {(userInfo?.user?.token == 'RBP00103' || userInfo?.user?.token == 'RBP00102') &&<span onClick={() => {
                                setIsHistory(false)
                                setTabIndex(3)
                            }} className="rtl_text mid_text  cursor_pointer" style={{ fontWeight: tabIndex==3 ? 'bold' : '' }}>&nbsp;&nbsp;&nbsp;Buy-Me(<span id="shipping_items">{buyMeRequestsItems?.length}</span>)&nbsp;&nbsp;&nbsp;</span>
/**/}
                        </div>
                        }
                        
                        
                    <div className="container shipping_transactions top_space_40 bot_space_40 row_flex row_space_center col_space_center">
                        <Box className="width_83 shipping_transaction_table" style={{ alignItems: 'flex-start' }}>
                                {tabIndex==1 &&<table id="shipping_transaction_table" className="shipping_transaction_table">
                                    <tbody>
                                        {isShippingLoading && <tr key={uuidv4()} className="white_container" style={{ padding: "10px" }}>
                                            <td style={{ border: "none" }}>
                                                <Loader isFullDisplay />
                                            </td>
                                        </tr>
                                        }
                                        {shipping_list?.length == 0 && <tr key={uuidv4()} className="white_container" style={{ padding: "10px" }}>
                                            <td colSpan={5} style={{ border: "none", textAlign: "center" }}>

                                                <Grid container lg={12} justifyContent="center" flexDirection="column" alignContent="center" alignItems="center">
                                                    <Grid item lg={9} className="red_text"> התחל את חווית הקניה</Grid>
                                                    <Grid item lg={3}><Box className="store_list_button_account" onClick={() => { navigate('/store', { state: { id: 1, name: 'store_list' } }) }}>{`לרשימת כל החנויות`}</Box></Grid>
                                                </Grid>
                                            </td>
                                        </tr>
                                        }
                                        {shipping_list?.length > 0 && !isHistory &&
                                            shipping_list?.filter(s => filter_check(s)).map((sh, shIndex) => (
                                                <>{sh.shippingStatus != 6 && !sh.status &&
                                                    <tr key={sh.id || uuidv4()} className="white_container" style={{ padding: "10px" }} title={(sh.params && sh.params.shippingStatus?.status_json) ? sh.params?.shippingStatus?.status_json?.STATUS_2 : ''} onClick={(event) => { setShowExtraServices(event, -1); }}>
                                                        <td style={{ border: "none", minWidth: "250px" }} id="account_info_button">
                                                            <Grid item container flexWrap="nowrap" alignItems="center" justifyContent="flex-start">
                                                                {((!sh.consolidationStatus || sh.consolidationStatus==105) && !(sh.repackStatus == 101 || sh.rescanStatus == 101) && !(sh.repackStatus == 104 && sh.rescanStatus == 104) && (sh.shippingStatus == 1 || sh.shippingStatus == 2)) && <Grid container item sm={9}>
                                                                    <div className="dropdown" style={{ position: "relative" }}>
                                                                        <div className="redoutline_button red_text col_flex col_space_center row_space_center cursor_pointer" onClick={(e) => {
                                                                            if (showExtraServices != shIndex)
                                                                                setShowExtraServices(e, shIndex)
                                                                            else
                                                                                setShowExtraServices(e, -1)
                                                                        }} style={{ color: `${((sh.repackStatus == 105 || sh.repackStatus == 101) && (sh.rescanStatus == 101 || sh.rescanStatus == 105)) ? "grey" : ""}`, border: `${((sh.repackStatus == 105 || sh.repackStatus == 101) && (sh.rescanStatus == 101 || sh.rescanStatus == 105)) ? "1px grey solid" : ""}` }}><p>{`שירותים נוספים`}</p></div>
                                                                        {showExtraServices == shIndex && <Grid item container style={{ zIndex: "1000", position: "absolute", background: "white", minWidth: "100px", overflow: "auto", boxShadow: "0px 8px 16px 0px rgba(0,0,0,0.2)" }}>
                                                                            {(sh.repackStatus != 105 && sh.repackStatus != 101 && sh.repackStatus != 104) && <p onClick={() => { onSelectService(1, sh) }} style={{ cursor: "pointer", margin: "0", width: "100%", marginTop: "5px", marginBottom: "5px", textAlign: "center" }}>{`אריזה מחדש`}</p>}
                                                                            {(sh.rescanStatus != 105 && sh.rescanStatus != 101 && sh.rescanStatus != 104) && <p onClick={() => { onSelectService(2, sh) }} style={{ cursor: "pointer", margin: "0", width: "100%", marginTop: "5px", marginBottom: "5px", textAlign: "center" }}>{`צילום תכולה`}</p>}
                                                                        </Grid>}
                                                                    </div>
                                                                </Grid>}
                                                                {((!sh.consolidationStatus || sh.consolidationStatus == 3 || sh.consolidationStatus == 105) && (sh.shippingStatus <= 2 || sh.shippingStatus == 104 || sh.shippingStatus == 202)) ?
                                                                    <Grid item container style={{ marginRight: "10px" }} sm={4}>
                                                                        <div onClick={() => {

                                                                            var wh = allWh?.find(w => w.id == sh.warehouseId);
                                                                            var wtNval = wh.params?.wtNval;
                                                                            var maxWt = Number(wtNval[wtNval.length - 2][0]);
                                                                            var wt = Number(sh.params?.userPaymentData?.weight);
                                                                            if (wt > maxWt && !sh.params?.transportVal_acc) {
                                                                                dispatch(snackbarToggle({
                                                                                    type: 'error', message: "צור קשר עם שרות לקוחות" }));
                                                                                return;
                                                                            }
                                                                            if ((sh.repackStatus == 0 || sh.repackStatus == 104 || sh.repackStatus == 105 || sh.repackStatus == null) && sh.shippingStatus != 201 && sh.shippingStatus != 203 && (sh.rescanStatus == 0 || sh.rescanStatus == null || sh.rescanStatus == 104 || sh.rescanStatus == 105)) {
                                                                                if (!sh.status) {
                                                                                    if (!userInfo?.user?.setting?.profileId && !userInfo?.user?.setting?.companyId) {
                                                                                        onHandleOpenModal()
                                                                                    } else {
                                                                                        checkForServiceAndOnHold(sh, function (status) {
                                                                                            if (!status) {
                                                                                                window.location.href = "/accounts?vers=" + (new Date()).getTime();
                                                                                                return;
                                                                                            }
                                                                                            //dispatch(setSelectedShipping(sh));
                                                                                            setIsPersonal(true);
                                                                                        });
                                                                                    }
                                                                                }
                                                                            }
                                                                            if (sh.shippingStatus == 201) {
                                                                                //onHandleOpenCCDialog();
                                                                            }
                                                                        }} style={{ color: ((sh.repackStatus == 0 || sh.repackStatus == 104 || sh.repackStatus == 105 || sh.repackStatus == null) && (sh.rescanStatus == 0 || sh.rescanStatus == null || sh.rescanStatus == 104 || sh.rescanStatus == 105)) ? "white" : "grey" }} className="red_button white_text col_flex col_space_center row_space_center cursor_pointer">
                                                                            {!sh.status ? <p>{`לתשלום`}</p> : <p>&nbsp;  </p>}
                                                                        </div>
                                                                    </Grid> :
                                                                    (sh.shippingStatus == 302 ? <Grid item container style={{ marginRight: "10px" }} justifyContent="flex-start" sm={12}>
                                                                        <div style={{ color: "white" }} className="red_button white_text col_flex col_space_center row_space_center cursor_pointer" onClick={() => {
                                                                            // desktop open tracking for invoice upload
                                                                            showPersonal(sh);
                                                                        }}><p>{`עדכון חשבונית`}</p> </div>
                                                                    </Grid> : (sh.repayment ? <Grid item container style={{ marginRight: "10px" }} justifyContent="flex-start" sm={4}>
                                                                            <div className="red_button white_text col_flex col_space_center row_space_center cursor_pointer" onClick={() => {
                                                                                // desktop open tracking after payment
                                                                                showRepayment(sh);
                                                                            }}><p>{`לתשלום`}</p> </div>
                                                                        </Grid> : <Grid item container style={{ marginRight: "10px" }} justifyContent="flex-start" sm={4}>
                                                                            <div className="redoutline_button red_text col_flex col_space_center row_space_center cursor_pointer" onClick={() => {
                                                                                // desktop open tracking after payment
                                                                                showPersonal(sh);
                                                                            }}><p>{`למעקב`}</p> </div>
                                                                        </Grid>)
                                                                    )}
                                                            </Grid>
                                                        </td>
                                                        {/*<td style={{ border: "none" }} id="account_service_button">
                                                            {(userInfo?.user?.token == 'RBP00103' || userInfo?.user?.token == 'RBP00102') &&
                                                            <SelectField
                                                                required
                                                                value={repackService}
                                                                onChange={event => {
                                                                    //alert(event.target.value);
                                                                    if (event.target.value == 2) {
                                                                        openRepackageDlg(sh);
                                                                    }
                                                                }}
                                                                label=''
                                                                options={[{ id: 1, name: "Services" }, { id: 2, name: "Repack Service" }]}
                                                                islabelAnimate={false}
                                                                isNumeric={true}
                                                                disabled={isServiceNotAvailable(sh)}
                                                                isPrefix
                                                                dir="rtl"
                                                                sx={{ m: 0, mr: "10px", height: "30px" }}
                                                            />}
                                                        </td>*/}
                                                    
                                                        <td style={{ border: "none" }} id="account_status1_1">
                                                            <Grid container item justifyContent="center" alignItems="center" flexDirection="column">
                                                                <Grid container item justifyContent="flex-end">
                                                                    {(!sh.consolidationStatus && !sh.repackStatus) &&

                                                                        <Grid item container justifyContent="flex-end" style={{ textAlign: "right" }}>
                                                                            {sh.params?.isInsurence && <span className="rtl_text smallx_text">ביטוח מוצר</span>}
                                                                            {sh.params?.isInsurence && <span><img src={correct} style={{ width: "14px", height: "14px", marginLeft: "5px" }} /></span>}
                                                                            {!sh.params?.isInsurence && false && <CloseIcon style={{ width: "15px", height: "15px", border: "1px solid black", borderRadius: '25px' }} />}

                                                                        </Grid>
                                                                    }
                                                                    {(sh.consolidationStatus == 1) &&
                                                                        <Grid item container justifyContent="flex-end" style={{ textAlign: "right" }}>
                                                                            בקשה לאיחוד
                                                                        </Grid>
                                                                    }
                                                                    {(sh.consolidationStatus == 3) &&

                                                                        <Grid item container justifyContent="flex-end" style={{ textAlign: "right" }}>
                                                                            חבילה מאוחדת
                                                                        </Grid>
                                                                    }
                                                                    {(sh.consolidationStatus == 105 && sh.consolidationRejectReason) && <Grid item container justifyContent="flex-end" style={{ textAlign: "right" }}>
                                                                        {`לא ניתן לאחד חבילה`} : {sh.consolidationRejectReason && Number(sh.consolidationRejectReason) ? consolidationRejections[Number(sh.consolidationRejectReason) - 1] : ``}
                                                                    </Grid>}
                                                                    {(sh.repackStatus == 101) &&

                                                                        <Grid item container justifyContent="flex-end" style={{ textAlign: "right" }}>
                                                                            בקשה לאריזה מחדש
                                                                        </Grid>
                                                                    }
                                                                    {/*{(sh.rescanStatus == 105) && <Grid item container justifyContent="flex-end">
                                                                        {`לא ניתן לסרוק`}
                                                                    </Grid>}*/}
                                                                    {(sh.rescanStatus == 105) && <div>
                                                                        {`לא ניתן לסרוק`}
                                                                    </div>}
                                                                    {(sh.repackStatus == 105 && sh.repackRejectReason) && <Grid item container justifyContent="flex-end" style={{ textAlign: "right" }}>
                                                                        {`לא ניתן לצמצם נפח`} : {sh.repackRejectReason && Number(sh.repackRejectReason) ? repackRejections[Number(sh.repackRejectReason) - 1] : ``}
                                                                    </Grid>}
                                                                    {(sh.shippingStatus == 201 && sh.holdReason) && <Grid item justifyContent="flex-end" container>
                                                                        {onHoldReasons[Number(sh.holdReason) -1]}
                                                                    </Grid>}
                                                                    {repackCompleted(sh) &&

                                                                        <Grid item justifyContent="flex-end" container>
                                                                            אריזה מחדש
                                                                        </Grid>
                                                                    }
                                                                    {(sh.rescanStatus == 101) &&

                                                                        <Grid item justifyContent="flex-end" container>
                                                                            {`בקשה לצילום`}
                                                                        </Grid>
                                                                    }
                                                                    {rescanCompleted(sh) &&
                                                                        <Grid item container justifyContent="flex-end" onClick={() => {
                                                                            downloadScanImage(getCookie("SESSION_ID") , sh.hawb, function () { })
                                                                        }}>
                                                                            {`צילום תכולה`} <span><div  style={{ marginLeft: "5px", backgroundImage: `url(${file})`, cursor: 'pointer', backgroundRepeat: "no-repeat", width: '16px', height: '20px', }}></div></span>
                                                                        </Grid>
                                                                    }
                                                                </Grid>
                                                                
                                                            </Grid>
                                                        </td>
                                                    <td style={{ border: "none" }} id="account_hawb">
                                                        <div className="col_flex col_space_center row_space_center">
                                                            <div className="full_width_container bold_text rtl_text smallx_text">מספר מעקב</div>
                                                            <div className="full_width_container row_flex" style={{ justifyContent: "flex-end" }}>
                                                                <span className="smallx_text account_hawb_content" id="account_hawb_content">
                                                                    {sh.hawb}
                                                                </span>
                                                                <span style={{ cursor: "pointer" }} onClick={() => {
                                                                    copyToClipboard1(sh.hawb, function (data) {
                                                                        dispatch(snackbarToggle({ type: 'success', message: data }));
                                                                    });
                                                                }}><img src={copy} style={{ width: "12px", height: "14px", marginLeft: "5px" }} /></span>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td style={{ border: "none" }} id="account_price">
                                                        <div className="col_flex col_space_center row_space_center">
                                                            <div className="full_width_container bold_text rtl_text smallx_text">קטגוריית מכס:</div>
                                                            <div className="full_width_container row_flex" style={{ justifyContent: "flex-end" }}>
                                                                <span className="rtl_text smallx_text account_dev_inst" id="account_dev_inst">
                                                                        {/*{sh.params?.majorCategory || sh.shippingDesc}*/}
                                                                        {sh.params?.majorCategory || "-"}
                                                                </span>
                                                                <span><img src={price_tag} style={{ width: "14px", height: "15px", marginLeft: "5px" }} /></span>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td style={{ border: "none" }} id="account_description">
                                                            <div className="col_flex col_space_center row_space_center">
                                                                <Grid container item sm={6}>
                                                                    <div class="dropdown" style={{ position: "relative" }}>
                                                                        <div style={{border:"2px solid #FF3452", fontWeight:"bold"}} className="redoutline_button red_text col_flex col_space_center row_space_center cursor_pointer" onClick={(e) => {
                                                                            onHandleOpenInfoModal(sh)
                                                                        }}><p>{`לפרטים/תמונה`}</p></div>
                                                                    </div>
                                                                </Grid>
                                                                {/*<div className="full_width_container bold_text rtl_text smallx_text">
                                                                    <span className="cursor_pointer" onClick={() => {
                                                                    onHandleOpenInfoModal(sh);
                                                                    }}>
                                                                        <img src={info_26} style={{ width: "15px", height: "15px", marginLeft: "5px" }} />
                                                                    </span>
                                                                    { `לפרטים/תמונה`} </div>
                                                            <div className="full_width_container row_flex" style={{ justifyContent: "flex-end" }}>
                                                                <span className="rtl_text smallx_text account_description_text" id="account_description_text">
                                                                        {sh.parentId == 0 ? (sh.params?.vParent?.vendorName ? sh.params?.vParent?.vendorName : sh.shippingDesc) : sh.shippingDesc}
                                                                </span>
                                                                <span><img src={packagePng} style={{ width: "15px", height: "15px", marginLeft: "5px" }} /></span>
                                                            </div>*/}
                                                        </div>
                                                    </td>
                                                    { <td style={{ border: "none" }} id="account_package_status_recieved">
                                                        <div className="row_flex" style={{ justifyContent: "flex-end" }}>
                                                            <div className="col_flex" style={{ justifyContent: "flex-end", marginRight: "10px" }}>
                                                                    {/*<div className="rtl_text bold_text smallx_text">{getNewStatus(sh, "החבילה נקלטה")}</div>*/}
                                                                    <div className="rtl_text bold_text smallx_text">{"עדכון אחרון"}</div>
                                                                <div className="right_text">
                                                                        <span className="right_text rtl_text smallx_text">{ "בתאריך "} </span>
                                                                        <span className="smallx_text underscored_text cursor_pointer" id="account_package_recieved_date" onClick={() => showPersonal(sh)}>
                                                                            {getDateFormat(sh.clientStatusDate ? sh.clientStatusDate : sh.date)}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            {/*<img src={package_recieved} style={{ width: "33px", height: "33px" }} />*/}
                                                        </div>
                                                    </td>
                                                    }
                                                    {/*{!sh.shippingStatus && <td style={{ border: "none" }} id="account_package_status_recieved">
                                                        <div className="row_flex" style={{ justifyContent: "flex-end" }}>
                                                            <div className="col_flex" style={{ justifyContent: "flex-end", marginRight: "10px" }}>
                                                                    */}{/*<div className="rtl_text bold_text smallx_text">{getNewStatus(sh, "החבילה נקלטה")}</div>*/}{/*
                                                                    <div className="rtl_text bold_text smallx_text">{"עדכון אחרון"}</div>
                                                                <div className="right_text">
                                                                        <span className="right_text rtl_text smallx_text">{ "בתאריך "} </span>
                                                                        <span className="smallx_text underscored_text cursor_pointer" id="account_package_recieved_date" onClick={() => showPersonal(sh)}>
                                                                            {getDateFormat(sh.clientStatusDate ? sh.clientStatusDate : sh.date)}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            */}{/*<img src={package_recieved} style={{ width: "33px", height: "33px" }} />*/}{/*
                                                        </div>
                                                    </td>
                                                    }

                                                    {(sh.shippingStatus == 1 || sh.shippingStatus == 100 || sh.shippingStatus == 201) && <td style={{ border: "none" }} id="account_package_status_recieved">
                                                        <div className="row_flex" style={{ justifyContent: "flex-end" }}>
                                                            <div className="col_flex" style={{ justifyContent: "flex-end", marginRight: "10px" }}>
                                                                    <div className="rtl_text bold_text smallx_text">{sh.parentId != 0 ? getNewStatus(sh, `החבילה נקלטה`) : `ההזמנה נקלטה`}</div>
                                                                <div className="right_text">
                                                                    <span className="right_text rtl_text smallx_text">תאריך עדכון: </span>
                                                                        <span className="smallx_text underscored_text cursor_pointer" id="account_package_recieved_date" onClick={() => showPersonal(sh)}>
                                                                            {getDateFormat(sh.clientStatusDate ? sh.clientStatusDate : sh.date)}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            */}{/*<img src={package_recieved} style={{ width: "33px", height: "33px" }} />*/}{/*
                                                        </div>
                                                    </td>
                                                    }
                                                    {(sh.shippingStatus == 2 || sh.shippingStatus == 202) && <td style={{ border: "none" }} id="account_package_status_payment_pending">
                                                        <div className="row_flex" style={{ justifyContent: "flex-end" }}>
                                                            <div className="col_flex" style={{ justifyContent: "flex-end", marginRight: "10px" }}>
                                                                    <div className="rtl_text bold_text smallx_text">{sh.parentId != 0 ? getNewStatus(sh, `ממתין לתשלום`) : `החבילה  נקלטה`}</div>
                                                                <div className="right_text">
                                                                    <span className="right_text rtl_text smallx_text">תאריך עדכון: </span>
                                                                        <span className="smallx_text underscored_text cursor_pointer" id="account_package_payment_date" onClick={() => showPersonal(sh)}>
                                                                            {getDateFormat(sh.clientStatusDate ? sh.clientStatusDate : sh.date)}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            */}{/*<img src={payment_pending} style={{ width: "33px", height: "33px" }} />*/}{/*
                                                        </div>
                                                    </td>}
                                                    {sh.shippingStatus == 3 && <td style={{ border: "none" }} id="account_package_status_shipping_started">
                                                        <div className="row_flex" style={{ justifyContent: "flex-end" }}>
                                                            <div className="col_flex" style={{ justifyContent: "flex-end", marginRight: "10px" }}>
                                                                    <div className="rtl_text bold_text smallx_text">{getStatusId(sh) == 2 ? getNewStatus(sh, 'החבילה בטיפול') :'בדרך לארץ'} </div>
                                                                <div className="right_text">
                                                                    <span className="right_text rtl_text smallx_text">תאריך עדכון: </span>
                                                                        <span className="smallx_text underscored_text cursor_pointer" id="account_package_shipping_date" onClick={() => showPersonal(sh)}>
                                                                            {getDateFormat(sh.clientStatusDate ? sh.clientStatusDate : sh.date)}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            */}{/*<img src={getStatusId(sh) == 2 ? package_recieved : shipment_started} style={{ width: "33px", height: "33px" }} />*/}{/*
                                                        </div>
                                                    </td>
                                                    }
                                                    {(sh.shippingStatus == 4 || sh.shippingStatus == 41) && <td style={{ border: "none" }} id="account_package_status_shipping_started">
                                                        <div className="row_flex" style={{ justifyContent: "flex-end" }}>
                                                            <div className="col_flex" style={{ justifyContent: "flex-end", marginRight: "10px" }}>
                                                                    <div className="rtl_text bold_text smallx_text">{getNewStatus(sh, "בדרך לארץ")}</div>
                                                                <div className="right_text">
                                                                    <span className="right_text rtl_text smallx_text">תאריך עדכון: </span>
                                                                        <span className="smallx_text underscored_text cursor_pointer" id="account_package_shipping_date" onClick={() => showPersonal(sh)}>
                                                                            {getDateFormat(sh.clientStatusDate ? sh.clientStatusDate : sh.date)}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            */}{/*<img src={shipment_started} style={{ width: "33px", height: "33px" }} />*/}{/*
                                                        </div>
                                                    </td>
                                                    }
                                                    {sh.shippingStatus == 5 && <td style={{ border: "none" }} id="account_package_status_shipping_started">
                                                        <div className="row_flex" style={{ justifyContent: "flex-end" }}>
                                                                <div className="col_flex" style={{ justifyContent: "flex-end", marginRight: "10px" }}>
                                                                    <div className="rtl_text bold_text smallx_text">{getStatusDescId(sh) ? getNewStatus(sh, getStatusDescId(sh)) : ((sh.params && sh.params.shippingStatus?.status_json) ? sh.params?.shippingStatus?.status_json?.STATUS_2 : 'בדרך לארץ')} </div>
                                                                    */}{/*<div className="rtl_text bold_text smallx_text">{'בדרך לארץ'} </div>*/}{/*
                                                                    */}{/*<div className="rtl_text bold_text smallx_text">{(sh.params && sh.params.shippingStatus?.status_json) ? sh.params?.shippingStatus?.status_json?.STATUS_2 : 'בדרך לארץ'} </div>*/}{/*
                                                                <div className="right_text">
                                                                    <span className="right_text rtl_text smallx_text">תאריך עדכון: </span>
                                                                        <span className="smallx_text underscored_text cursor_pointer" id="account_package_shipping_date" onClick={() => showPersonal(sh)}>
                                                                            {getDateFormat(sh.clientStatusDate ? sh.clientStatusDate : sh.date)}
                                                                    </span>
                                                                </div>
                                                                </div>
                                                                
                                                                */}{/*<img src={getStatusId(sh) == 4 ? package_recieved : delivery_started } style={{ width: "33px", height: "33px" }} />*/}{/*
                                                        </div>
                                                    </td>
                                                        }
                                                        {sh.shippingStatus == 104 && <td style={{ border: "none" }} id="account_package_status_delivery_started">
                                                            <div className="row_flex" style={{ justifyContent: "flex-end" }}>
                                                                <div className="col_flex" style={{ justifyContent: "flex-end", marginRight: "10px" }}>
                                                                    <div className="rtl_text bold_text smallx_text">{(sh.params && sh.params.shippingStatus?.status_json) ? getNewStatus(sh, sh.params?.shippingStatus?.status_json?.STATUS_2) : 'החבילה בטיפול'}  </div>
                                                                    <div className="right_text">
                                                                        <span className="right_text rtl_text smallx_text">תאריך עדכון: </span>
                                                                        <span className="smallx_text underscored_text cursor_pointer" id="account_package_delivery_date" onClick={() => showPersonal(sh)}>
                                                                            {getDateFormat(sh.clientStatusDate ? sh.clientStatusDate : sh.date)}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                                */}{/*<img src={package_recieved} style={{ width: "33px", height: "33px" }} />*/}{/*
                                                            </div>
                                                        </td>}
                                                        {sh.params && sh.shippingStatus != 104 && sh.shippingStatus != 201 && sh.shippingStatus != 202 && sh.shippingStatus != 100 && sh.shippingStatus != 41 && sh.shippingStatus != 1 && sh.shippingStatus != 6 && sh.shippingStatus != 2 && sh.shippingStatus != 3 && sh.shippingStatus != 4 && sh.shippingStatus != 5 && <td style={{ border: "none" }} id="account_package_status_delivery_started">
                                                        <div className="row_flex" style={{ justifyContent: "flex-end" }}>
                                                            <div className="col_flex" style={{ justifyContent: "flex-end", marginRight: "10px" }}>
                                                                    <div className="rtl_text bold_text smallx_text">{(sh.params && sh.params.shippingStatus?.status_json) ? getNewStatus(sh, sh.params?.shippingStatus?.status_json?.STATUS_2) : (sh.shippingStatus == 203 ? getCSOnHoldSatus(sh) : ((sh.shippingStatus == 301 || sh.shippingStatus == 303 || sh.shippingStatus == 304) ? 'החבילה בטיפול' : (sh.shippingStatus == 302 ? "חשבונית לא תקינה" : 'הפצה')))}  </div>
                                                                <div className="right_text">
                                                                    <span className="right_text rtl_text smallx_text">תאריך עדכון: </span>
                                                                        <span className="smallx_text underscored_text cursor_pointer" id="account_package_delivery_date" onClick={() => showPersonal(sh)}>
                                                                            {getDateFormat(sh.clientStatusDate ? sh.clientStatusDate : sh.date)}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            */}{/*<img src={delivery_started} style={{ width: "33px", height: "33px" }} />*/}{/*
                                                        </div>
                                                    </td>}
                                                    {sh.shippingStatus == 6 && <td style={{ border: "none" }} id="account_package_status_shipping_started">
                                                        <div className="row_flex" style={{ justifyContent: "flex-end" }}>
                                                            <div className="col_flex" style={{ justifyContent: "flex-end", marginRight: "10px" }}>
                                                                    <div className="rtl_text bold_text smallx_text">{getNewStatus(sh, "החבילה נמסרה")}</div>
                                                                <div className="right_text">
                                                                    <span className="right_text rtl_text smallx_text">תאריך עדכון: </span>
                                                                        <span className="smallx_text underscored_text cursor_pointer" id="account_package_shipping_date" onClick={() => showPersonal(sh)}>
                                                                            {getDateFormat(sh.clientStatusDate ? sh.clientStatusDate : sh.date)}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            */}{/*<img src={shipment_started} style={{ width: "33px", height: "33px" }} />*/}{/*
                                                        </div>
                                                    </td>
                                                    }*/}
                                                    {/*{sh.params && sh.params.shippingStatus &&sh.shippingStatus != 1 && sh.shippingStatus != 6 && sh.shippingStatus != 2 && sh.shippingStatus != 3 && sh.shippingStatus != 4&& sh.shippingStatus != 5 && <td style={{ border: "none" }} id="account_package_status_delivery_started">
                                                    <div className="row_flex" style={{ justifyContent: "flex-end" }}>
                                                        <div className="col_flex" style={{ justifyContent: "flex-end", marginRight: "10px" }}>
                                                            <div className="rtl_text bold_text smallx_text">{sh.params.shippingStatus.StatusText}</div>
                                                            <div className="right_text">
                                                                <span className="right_text rtl_text smallx_text">תאריך עדכון: </span>
                                                                <span className="smallx_text" id="account_package_delivery_date">
                                                                    {getDateFormat(sh.clientStatusDate ? sh.clientStatusDate : sh.date)}
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <img src={delivery_started} style={{ width: "33px", height: "33px" }} />
                                                    </div>
                                                </td>}*/}
                                                    {<td style={{ border: "none" }} id="account_package_target_1">
                                                        <div className="col_flex col_space_center row_space_center">
                                                            <div className="full_width_container bold_text smallx_text right_text">{`ספק`}</div>
                                                            <div className="full_width_container row_flex" style={{ justifyContent: "flex-end" }}>
                                                                {!sh.params.store && <span className="rtl_text smallx_text">{sh.params?.sender?.senderName}, {sh.params?.sender?.senderCountry}</span>}
                                                                {sh.params.store && <span className="rtl_text smallx_text">{sh.params.store}</span>}
                                                            </div>
                                                        </div>
                                                    </td>}
                                                    {/*<td style={{ border: "none" }} id="account_package_target_2">
                                                    <div className="col_flex col_space_center row_space_center">
                                                        {sh.params?.sender?.senderName}
                                                    </div>
                                                </td>
                                                */}

                                                </tr>}
                                                </>
                                            ))
                                        }
                                    </tbody>
                                </table>}
                                {tabIndex == 2 && <table id="shipping_transaction_table" className="shipping_transaction_table">
                                    <tbody>
                                        {isShippingLoading && <tr key={uuidv4()} className="white_container" style={{ padding: "10px" }}>
                                            <td style={{ border: "none" }}>
                                                <Loader isFullDisplay />
                                            </td>
                                        </tr>
                                        }
                                        {shipping_list?.length == 0 && <tr key={uuidv4()} className="white_container" style={{ padding: "10px" }}>
                                            <td colSpan={5} style={{ border: "none", textAlign: "center" }}>

                                                <Grid container lg={12} justifyContent="center" flexDirection="column" alignContent="center" alignItems="center">
                                                    <Grid item lg={9} className="red_text"> התחל את חווית הקניה</Grid>
                                                    <Grid item lg={3}><Box className="store_list_button_account" onClick={() => { navigate('/store', { state: { id: 1, name: 'store_list' } }) }}>{`לרשימת כל החנויות`}</Box></Grid>
                                                </Grid>
                                            </td>
                                        </tr>
                                        }
                                        {shipping_list?.length > 0 && isHistory &&
                                            shipping_list?.filter(s => filter_check(s)).map(sh => (
                                                <> 
                                                   
                                                    {(sh.shippingStatus == 6 || sh.status) && <tr key={sh.id || uuidv4()} className="white_container" style={{ padding: "10px" }} title={(sh.params && sh.params.shippingStatus?.status_json) ? sh.params?.shippingStatus?.status_json?.STATUS_2 : ''}>



                                                        {sh.shippingStatus > 2 && sh.shippingStatus != 202 ? (<td style={{ border: "none" }} id="account_info_button">
                                                            {!sh.status ?<div className="redoutline_button red_text col_flex col_space_center row_space_center cursor_pointer" onClick={() => {
                                                                // mobile history
                                                                showPersonal(sh);
                                                            }}> {!sh.status ? <p>{ `למעקב`} </p> : <p>&nbsp; </p>} </div> : <>

                                                                
                                                                    {sh.shippingStatus ==104&&<div onClick={() => {
                                                                        var parent = sh.trackListOfConsolidation?.length > 0 ? shipping_list?.find(u => u.id === sh.trackListOfConsolidation[0]) : null;
                                                                        if (parent) {
                                                                            dispatch(setSelectedShipping(parent));
                                                                            setIsPersonal(true);
                                                                        }
                                                                    }} className="redoutline_button red_text col_flex col_space_center row_space_center cursor_pointer"> <p> {sh.trackListOfConsolidation?.length > 0 ? shipping_list?.find(u => u.id === sh.trackListOfConsolidation[0])?.hawb : ""}</p></div>}

                                                            </>}
                                                    </td>)
                                                        :
                                                        (<td style={{ border: "none", padding: "10px" }} id="account_pay_button">
                                                                {!sh.status ? <div onClick={() => {

                                                                    var wh = allWh?.find(w => w.id == sh.warehouseId);
                                                                    var wtNval = wh.params?.wtNval;
                                                                    var maxWt = Number(wtNval[wtNval.length - 2][0]);
                                                                    var wt = Number(sh.params?.userPaymentData?.weight);
                                                                    if (wt > maxWt && !sh.params?.transportVal_acc) {
                                                                        dispatch(snackbarToggle({
                                                                            type: 'error', message: "צור קשר עם שרות לקוחות"
                                                                        }));
                                                                        return;
                                                                    }
                                                                    if ((sh.repackStatus == 0 || sh.repackStatus == 104 || sh.repackStatus == null) && (sh.rescanStatus == 0 || sh.rescanStatus == 104 || sh.rescanStatus == null)) {
                                                                        if (!sh.status) {
                                                                            if (!userInfo?.user?.setting?.profileId) {
                                                                                onHandleOpenModal()
                                                                            } else {
                                                                                dispatch(setSelectedShipping(sh));
                                                                                setIsPersonal(true);
                                                                            }
                                                                        }
                                                                    }
                                                                }} className="red_button white_text col_flex col_space_center row_space_center cursor_pointer">{!sh.status ? <p> { `לתשלום`}</p> : <p>&nbsp;  </p>}</div>:<></>}
                                                        </td>)
                                                    }
                                                    <td style={{ border: "none" }} id="account_status1_1">
                                                            {sh.shippingStatus != 104 && <Grid item container justifyContent="flex-end" className="">

                                                                {sh.params?.isInsurence && <span className="rtl_text smallx_text">ביטוח מוצר</span>}
                                                                {sh.params?.isInsurence && <span><img src={correct} style={{ width: "14px", height: "14px", marginLeft: "5px" }} /></span>}
                                                                {!sh.params?.isInsurence && false && <CloseIcon style={{ width: "15px", height: "15px", border: "1px solid black", borderRadius: '25px' }} />}

                                                            </Grid>}
                                                            {sh.shippingStatus == 104 && <Grid item container justifyContent="flex-end" className="">

                                                                <span className="rtl_text smallx_text">- חבילה מאוחדת ב</span>
                                                               
                                                            </Grid>}

                                                            {rescanCompleted(sh) &&
                                                                <Grid item container justifyContent="flex-end" onClick={() => {
                                                                    downloadScanImage(getCookie("SESSION_ID"), sh.hawb, function () { })
                                                                }}>
                                                                    {`צילום תכולה`} <span><div style={{ marginLeft: "5px", backgroundImage: `url(${file})`, cursor: 'pointer', backgroundRepeat: "no-repeat", width: '16px', height: '20px', }}></div></span>
                                                                </Grid>
                                                            }
                                                    </td>
                                                    <td style={{ border: "none" }} id="account_hawb">
                                                        <div className="col_flex col_space_center row_space_center">
                                                            <div className="full_width_container bold_text rtl_text smallx_text">מספר מעקב</div>
                                                            <div className="full_width_container row_flex" style={{ justifyContent: "flex-end" }}>
                                                                <span className="smallx_text account_hawb_content" id="account_hawb_content">
                                                                    {sh.hawb}
                                                                </span>
                                                                <span style={{ cursor: "pointer" }} onClick={() => {
                                                                    copyToClipboard1(sh.hawb, function (data) {
                                                                        dispatch(snackbarToggle({ type: 'success', message: data }));
                                                                    });
                                                                }}><img src={copy} style={{ width: "12px", height: "14px", marginLeft: "5px" }} /></span>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td style={{ border: "none" }} id="account_price">
                                                        <div className="col_flex col_space_center row_space_center">
                                                            <div className="full_width_container bold_text rtl_text smallx_text">קטגוריית מכס:</div>
                                                            <div className="full_width_container row_flex" style={{ justifyContent: "flex-end" }}>
                                                                <span className="rtl_text smallx_text account_dev_inst" id="account_dev_inst">
                                                                    {sh.params?.majorCategory || "-"}
                                                                </span>
                                                                <span><img src={price_tag} style={{ width: "14px", height: "15px", marginLeft: "5px" }} /></span>
                                                            </div>
                                                        </div>
                                                    </td>
                                                        <td style={{ border: "none" }} id="account_description">
                                                            <div className="col_flex col_space_center row_space_center">
                                                                <Grid container item sm={6}>
                                                                    <div class="dropdown" style={{ position: "relative" }}>
                                                                        <div style={{ border: "2px solid #FF3452", fontWeight: "bold" }} className="redoutline_button red_text col_flex col_space_center row_space_center cursor_pointer" onClick={(e) => {
                                                                            onHandleOpenInfoModal(sh)
                                                                        }}><p>{`לפרטים/תמונה`}</p></div>
                                                                    </div>
                                                                </Grid>
                                                            </div>
                                                        </td>
                                                    {!sh.shippingStatus && <td style={{ border: "none" }} id="account_package_status_recieved">
                                                        <div className="row_flex" style={{ justifyContent: "flex-end" }}>
                                                            <div className="col_flex" style={{ justifyContent: "flex-end", marginRight: "10px" }}>
                                                                    <div className="rtl_text bold_text smallx_text">{getNewHistoryStatus(sh, "החבילה נקלטה")}</div>
                                                                    <div className="right_text  underscored_text cursor_pointer" onClick={() => showPersonal(sh)}>
                                                                    <span className="right_text rtl_text smallx_text">תאריך עדכון: </span>
                                                                        <span className="smallx_text" id="account_package_recieved_date">
                                                                            {getDateFormat(sh.clientStatusDate ? sh.clientStatusDate : sh.date)}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            {/*<img src={package_recieved} style={{ width: "33px", height: "33px" }} />*/}
                                                        </div>
                                                    </td>
                                                    }

                                                        {(sh.shippingStatus == 1 || sh.shippingStatus == 100) && <td style={{ border: "none" }} id="account_package_status_recieved">
                                                        <div className="row_flex" style={{ justifyContent: "flex-end" }}>
                                                            <div className="col_flex" style={{ justifyContent: "flex-end", marginRight: "10px" }}>
                                                                    <div className="rtl_text bold_text smallx_text">{getNewHistoryStatus(sh, "החבילה נקלטה")}</div>
                                                                    <div className="right_text  underscored_text cursor_pointer" onClick={() => showPersonal(sh)}>
                                                                    <span className="right_text rtl_text smallx_text">תאריך עדכון: </span>
                                                                        <span className="smallx_text underscored_text cursor_pointer" id="account_package_recieved_date" onClick={() => showPersonal(sh)}>
                                                                            {getDateFormat(sh.clientStatusDate ? sh.clientStatusDate : sh.date)}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            {/*<img src={package_recieved} style={{ width: "33px", height: "33px" }} />*/}
                                                        </div>
                                                    </td>
                                                    }
                                                    {(sh.shippingStatus == 2 || sh.shippingStatus == 202) && <td style={{ border: "none" }} id="account_package_status_payment_pending">
                                                        <div className="row_flex" style={{ justifyContent: "flex-end" }}>
                                                            <div className="col_flex" style={{ justifyContent: "flex-end", marginRight: "10px" }}>
                                                                    <div className="rtl_text bold_text smallx_text">{getNewHistoryStatus(sh, "ממתין לתשלום")}</div>
                                                                    <div className="right_text  underscored_text cursor_pointer" onClick={() => showPersonal(sh)}>
                                                                    <span className="right_text rtl_text smallx_text">תאריך עדכון: </span>
                                                                        <span className="smallx_text underscored_text cursor_pointer" id="account_package_payment_date" onClick={() => showPersonal(sh)}>
                                                                            {getDateFormat(sh.clientStatusDate ? sh.clientStatusDate : sh.date)}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            {/*<img src={payment_pending} style={{ width: "33px", height: "33px" }} />*/}
                                                        </div>
                                                    </td>}
                                                        {sh.shippingStatus == 3 && <td style={{ border: "none" }} id="account_package_status_shipping_started">
                                                        <div className="row_flex" style={{ justifyContent: "flex-end" }}>
                                                            <div className="col_flex" style={{ justifyContent: "flex-end", marginRight: "10px" }}>
                                                                    {/*<div className="rtl_text bold_text smallx_text">בדרך לארץ</div>*/}
                                                                    <div className="rtl_text bold_text smallx_text">{getNewHistoryStatus(sh, 'החבילה בטיפול')}</div>
                                                                    <div className="right_text  underscored_text cursor_pointer" onClick={() => showPersonal(sh)}>
                                                                    <span className="right_text rtl_text smallx_text">תאריך עדכון: </span>
                                                                        <span className="smallx_text underscored_text cursor_pointer" id="account_package_shipping_date" onClick={() => showPersonal(sh)}>
                                                                            {getDateFormat(sh.clientStatusDate ? sh.clientStatusDate : sh.date)}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            {/*<img src={shipment_started} style={{ width: "33px", height: "33px" }} />*/}
                                                        </div>
                                                    </td>
                                                    }
                                                    {(sh.shippingStatus == 4 || sh.shippingStatus == 41) && <td style={{ border: "none" }} id="account_package_status_shipping_started">
                                                        <div className="row_flex" style={{ justifyContent: "flex-end" }}>
                                                            <div className="col_flex" style={{ justifyContent: "flex-end", marginRight: "10px" }}>
                                                                    <div className="rtl_text bold_text smallx_text">{getNewHistoryStatus(sh, "בדרך לארץ")}</div>
                                                                    {/*<div className="rtl_text bold_text smallx_text">בדרך לארץ</div>*/}
                                                                    <div className="right_text  underscored_text cursor_pointer" onClick={() => showPersonal(sh)}>
                                                                    <span className="right_text rtl_text smallx_text">תאריך עדכון: </span>
                                                                        <span className="smallx_text underscored_text cursor_pointer" id="account_package_shipping_date" onClick={() => showPersonal(sh)}>
                                                                            {getDateFormat(sh.clientStatusDate ? sh.clientStatusDate : sh.date)}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            {/*<img src={shipment_started} style={{ width: "33px", height: "33px" }} />*/}
                                                        </div>
                                                    </td>
                                                    }
                                                    {sh.shippingStatus == 5 && <td style={{ border: "none" }} id="account_package_status_shipping_started">
                                                        <div className="row_flex" style={{ justifyContent: "flex-end" }}>
                                                            <div className="col_flex" style={{ justifyContent: "flex-end", marginRight: "10px" }}>
                                                                    <div className="rtl_text bold_text smallx_text">{(sh.params && sh.params.shippingStatus?.status_json) ? getNewHistoryStatus(sh, sh.params?.shippingStatus?.status_json?.STATUS_2) : getNewHistoryStatus(sh, 'בדרך לארץ')} </div>
                                                                    <div className="right_text  underscored_text cursor_pointer" onClick={() => showPersonal(sh)}>
                                                                    <span className="right_text rtl_text smallx_text">תאריך עדכון: </span>
                                                                        <span className="smallx_text underscored_text cursor_pointer" id="account_package_shipping_date" onClick={() => showPersonal(sh)}>
                                                                            {getDateFormat(sh.clientStatusDate ? sh.clientStatusDate : sh.date)}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            {/*<img src={shipment_started} style={{ width: "33px", height: "33px" }} />*/}
                                                        </div>
                                                    </td>
                                                    }
                                                    {sh.params && sh.shippingStatus != 100 && sh.shippingStatus != 41 && sh.shippingStatus != 1 && sh.shippingStatus != 6 && sh.shippingStatus != 2 && sh.shippingStatus != 3 && sh.shippingStatus != 4 && sh.shippingStatus != 5 && <td style={{ border: "none" }} id="account_package_status_delivery_started">
                                                        <div className="row_flex" style={{ justifyContent: "flex-end" }}>
                                                            <div className="col_flex" style={{ justifyContent: "flex-end", marginRight: "10px" }}>
                                                                    <div className="rtl_text bold_text smallx_text">{(sh.params && sh.params.shippingStatus?.status_json) ? getNewHistoryStatus(sh, sh.params?.shippingStatus?.status_json?.STATUS_2) : (sh.shippingStatus == 203 ? getCSOnHoldSatus(sh) : getNewHistoryStatus(sh, getDescByShStatus(sh)))}  </div>
                                                                    <div className="right_text  underscored_text cursor_pointer" onClick={() => showPersonal(sh)}>
                                                                    <span className="right_text rtl_text smallx_text">תאריך עדכון: </span>
                                                                        <span className="smallx_text underscored_text cursor_pointer" id="account_package_delivery_date" onClick={() => showPersonal(sh)}>
                                                                            {getDateFormat(sh.clientStatusDate ? sh.clientStatusDate : sh.date)}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            {/*<img src={delivery_started} style={{ width: "33px", height: "33px" }} />*/}
                                                        </div>
                                                    </td>}
                                                    {sh.shippingStatus == 6 && <td style={{ border: "none" }} id="account_package_status_shipping_started">
                                                        <div className="row_flex" style={{ justifyContent: "flex-end" }}>
                                                            <div className="col_flex" style={{ justifyContent: "flex-end", marginRight: "10px" }}>
                                                                    <div className="rtl_text bold_text smallx_text">{getNewHistoryStatus(sh, "החבילה נמסרה")}</div>
                                                                    <div className="right_text  underscored_text cursor_pointer" onClick={() => showPersonal(sh)}>
                                                                    <span className="right_text rtl_text smallx_text">תאריך עדכון: </span>
                                                                        <span className="smallx_text underscored_text cursor_pointer" id="account_package_shipping_date" onClick={() => showPersonal(sh)}>
                                                                            {getDateFormat(sh.clientStatusDate ? sh.clientStatusDate : sh.date)}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            {/*<img src={shipment_started} style={{ width: "33px", height: "33px" }} />*/}
                                                        </div>
                                                    </td>
                                                    }
                                                    {/*{sh.params && sh.params.shippingStatus &&sh.shippingStatus != 1 && sh.shippingStatus != 6 && sh.shippingStatus != 2 && sh.shippingStatus != 3 && sh.shippingStatus != 4&& sh.shippingStatus != 5 && <td style={{ border: "none" }} id="account_package_status_delivery_started">
                                                    <div className="row_flex" style={{ justifyContent: "flex-end" }}>
                                                        <div className="col_flex" style={{ justifyContent: "flex-end", marginRight: "10px" }}>
                                                            <div className="rtl_text bold_text smallx_text">{sh.params.shippingStatus.StatusText}</div>
                                                            <div className="right_text">
                                                                <span className="right_text rtl_text smallx_text">תאריך עדכון: </span>
                                                                <span className="smallx_text" id="account_package_delivery_date">
                                                                    {getDateFormat(sh.clientStatusDate ? sh.clientStatusDate : sh.date)}
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <img src={delivery_started} style={{ width: "33px", height: "33px" }} />
                                                    </div>
                                                </td>}*/}
                                                    {<td style={{ border: "none" }} id="account_package_target_1">
                                                        <div className="col_flex col_space_center row_space_center">
                                                            <div className="full_width_container bold_text smallx_text right_text">{`ספק`}</div>
                                                            <div className="full_width_container row_flex" style={{ justifyContent: "flex-end" }}>
                                                                {!sh.params.store && <span className="rtl_text smallx_text">{sh.params?.sender?.senderName}, {sh.params?.sender?.senderCountry}</span>}
                                                                {sh.params.store && <span className="rtl_text smallx_text">{sh.params.store}</span>}
                                                            </div>
                                                        </div>
                                                    </td>}
                                                    {/*<td style={{ border: "none" }} id="account_package_target_2">
                                                    <div className="col_flex col_space_center row_space_center">
                                                        {sh.params?.sender?.senderName}
                                                    </div>
                                                </td>
                                                */}

                                                </tr>
                                                    }</>
                                            ))
                                        }
                                    </tbody>
                                </table>}
                                {((userInfo?.user?.token == 'RBP00103' || userInfo?.user?.token == 'RBP00102') && (tabIndex == 3)) && <>
                                    


                                    <TableContainer sx={{ maxHeight: 800 }}>
                                        <Table className='parcel-table' stickyHeader aria-label="sticky table">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell>
                                                        <Typography variant='h7'>
                                                            <b>Warehouse</b> 
                                                        </Typography>
                                                    </TableCell>
                                                    <TableCell>
                                                        <Typography variant='h7'>
                                                            <b>Link</b>  
                                                        </Typography>
                                                    </TableCell>
                                                    <TableCell>
                                                        <Typography variant='h7'>
                                                            <b>Color</b>   
                                                        </Typography>
                                                    </TableCell>

                                                    <TableCell>
                                                        <Typography variant='h7'>
                                                            <b>Size</b>
                                                        </Typography>
                                                    </TableCell>
                                                    
                                                    <TableCell>
                                                        <Typography variant='h7'>
                                                            <b>Price per product</b>
                                                        </Typography>
                                                    </TableCell>
                                                    <TableCell>
                                                        <Typography variant='h7'>
                                                            <b>Quantity</b>
                                                        </Typography>
                                                    </TableCell>
                                                    <TableCell>
                                                        <Typography variant='h7'>
                                                            <b>Payable</b>
                                                        </Typography>
                                                    </TableCell>



                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {
                                                    buyMeRequestsItems?.map((request, index) => (
                                                        <TableRow style={{ background: (index % 2) == 0 ? '#ebeaea' : 'white' }}>

                                                            <TableCell style={{ padding: "10px" }}>
                                                                <Typography variant='body1' component='span'>
                                                                    {request.whName}
                                                                </Typography>
                                                            </TableCell>
                                                            <TableCell style={{ padding: "10px", overflow: "hidden", textWrap: "nowrap" }}>
                                                                <Typography variant='body1' component='span'>
                                                                    
                                                                    <a href={request.url} target="_blank">{request.url}</a>
                                                                </Typography>
                                                            </TableCell>
                                                            <TableCell style={{ padding: "10px" }}>
                                                                <Typography variant='body1' component='span'>
                                                                    {request.color}
                                                                </Typography>
                                                            </TableCell>
                                                            <TableCell style={{ padding: "10px" }}>
                                                                <Typography variant='body1' component='span'>
                                                                    {request.size}
                                                                </Typography>
                                                            </TableCell>
                                                            <TableCell style={{ padding: "10px" }}>
                                                                <Typography variant='body1' component='span'>
                                                                    {request.price}
                                                                </Typography>
                                                            </TableCell>
                                                            <TableCell style={{ padding: "10px" }}>
                                                                <Typography variant='body1' component='span'>
                                                                    {request.numUnits}
                                                                </Typography>
                                                            </TableCell>
                                                            <TableCell style={{ padding: "10px" }}>
                                                                <Typography variant='body1' component='span'>
                                                                    {request.cost ? request.cost:"-"}
                                                                </Typography>
                                                            </TableCell>
                                                            <TableCell style={{ padding: "10px" }}>
                                                                <Typography variant='body1' component='span'>
                                                                    {request.status==2&& <Button variant='contained' sx={{ borderRadius: "25px", background: "#FF3452", padding: "5px 25px" }} onClick={() => {
                                                                        dispatch(setSelectedShipping(request));
                                                                        setIsBuyMePayment(true)
                                                                        
                                                                    }}>תשלום</Button>}
                                                                </Typography>
                                                            </TableCell>

                                                        </TableRow>
                                                    ))
                                                }
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
</> }
                        </Box>
                        {isShippingLoading ?
                        <Loader  isFullDisplay /> :
                        <Grid container item sm={12} className='shipping_transaction_responsive'>
                                    
                                    {shipping_list?.length > 0 &&
                                        shipping_list?.filter(s => filter_check(s)).map((sh, shIndex) => (
                                    <>{isHistory && (sh.shippingStatus != 6 && !sh.status) &&<Grid key={sh.id} container item sm={5.8} className='transaction-card'>
                                        <Grid container item xs={12} className='card-content dir-rtl'>
                                            <Grid container item xs={5} className="right-col">
                                                {/*<img src={packagePng} style={{ width: "32px", height: "32px" }} />*/}
                                                <Grid container item xs={12} style={{ alignItems: 'center', justifyContent: 'center' }}>
                                                    <Typography className='text_bold'> {sh.hawb}</Typography>
                                                </Grid>
                                                <Grid container item xs={12} style={{ alignItems: 'center', justifyContent: 'center' }}>
                                                            <Typography className='text_bold' style={{textAlign:"center"}}> {sh.params?.majorCategory || sh.shippingDesc}</Typography>
                                                </Grid>
                                                <Grid container item xs={12} style={{ alignItems: 'center', justifyContent: 'center' }}>
                                                    {!sh.params.store && <Typography>{sh.params?.sender?.senderName}</Typography>}
                                                    {sh.params.store && <Typography>{sh.params.store}</Typography>}
                                                </Grid>
                                                <Grid container className='loc'>
                                                    
                                                    <img src={LocMarker} className='marker-icon' alt="" style={{ width: "12px", height: "15px", marginLeft: "5px" }} />
                                                    <Typography >{sh.params?.sender?.senderCountry}</Typography>
                                                </Grid>
                                            </Grid>
                                            <Grid container item xs={7}>
                                                <Grid container item xs={12} className='upper-row'>
                                                    <Grid container className='flex-row' >
                                                                {/*<Typography className='text_bold'>{getNewStatus(sh, getDescByShStatus(sh))}</Typography>*/}
                                                                <Typography className='text_bold'>{"עדכון אחרון"}</Typography>
                                                        <img src={payment_pending} style={{ width: "14px", height: "14px", marginRight: '5px' }} />

                                                       
                                                    </Grid>
                                                            <Typography className="right_text  underscored_text cursor_pointer" onClick={() => showPersonal(sh)}>{ "בתאריך "} {getDateFormat(sh.clientStatusDate ? sh.clientStatusDate : sh.date)}</Typography>
                                                </Grid>
                                                <Grid container item xs={12} className='lower-row'>
                                                    <Typography className='text_bold'>
                                                                <span style={{ color:"#FF3452"}} className="cursor_pointer" onClick={() => {
                                                        onHandleOpenInfoModal(sh);
                                                                }}>
                                                                    { `פרטי משלוח>`}
                                                        {/*<img src={info_26} style={{ width: "20px", height: "20px", marginLeft: "5px" }} />*/}
                                                        </span> {/*{sh.hawb}*/}</Typography>
                                                    <Grid container className='flex-row' onClick={() => {
                                                        copyToClipboard1(sh.hawb, function (data) {
                                                            dispatch(snackbarToggle({ type: 'success', message: data }));
                                                            window.setTimeout(function () { dispatch(snackbarToggle(false)); }, autoCloseSnackbar);
                                                        });
                                                    }}>
                                                        <img src={copy} style={{ width: "12px", height: "14px", marginLeft: "5px" }} />
                                                        <Typography >מספר מעקב</Typography>
                                                    </Grid>
                                                </Grid>
                                                <Grid container item xs={12} className='lower-row'>
                                                    {(sh.consolidationStatus == 1) && <Typography className='text_bold'>בקשה לאיחוד</Typography>}
                                                    {(sh.consolidationStatus == 3) && <Typography className='text_bold'>חבילה מאוחדת</Typography>}
                                                   
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        <Grid container item xs={12} flexDirection="column" style={{ textAlign: 'center', justifyContent: 'center', marginTop: '20px' }}>
                                            
                                            {(sh.consolidationStatus == 105) && <div className="">
                                                {`לא ניתן לאחד חבילה`} : {sh.consolidationRejectReason && Number(sh.consolidationRejectReason) ? consolidationRejections[Number(sh.consolidationRejectReason) - 1] : ''}
                                                    </div>}
                                                    {(sh.repackStatus == 101) &&

                                                <div className="">
                                                            בקשה לאריזה מחדש
                                                </div>
                                            }
                                            {repackCompleted(sh) &&

                                                <div className="">
                                                            אריזה מחדש
                                                </div>
                                            }
                                            {(sh.rescanStatus == 101) && <div className="">
                                                {`בקשה לצילום`}
                                            </div> }
                                            {(sh.rescanStatus == 105) && <div className="">
                                                { `לא ניתן לסרוק`}
                                            </div>}

                                            {rescanCompleted(sh) &&
                                                <Grid item container justifyContent="flex-end" onClick={() => {
                                                    downloadScanImage(getCookie("SESSION_ID"), sh.hawb, function () { })
                                                }}>
                                                    {`צילום תכולה`} <span><div style={{ marginLeft: "5px", backgroundImage: `url(${file})`, cursor: 'pointer', backgroundRepeat: "no-repeat", width: '16px', height: '20px', }}></div></span>
                                                </Grid>
                                            }

                                            {(sh.repackStatus == 105) && <div className="">
                                                {`לא ניתן לצמצם נפח`} : {sh.repackRejectReason && Number(sh.repackRejectReason) ? repackRejections[Number(sh.repackRejectReason) - 1] : ''}
                                            </div>}

                                            {(sh.shippingStatus == 201 && sh.holdReason) && <div className="">
                                                {onHoldReasons[Number(sh.holdReason) - 1]} <br/>
                                            </div>}
                                        </Grid>
                                        <Grid container item xs={12} style={{ textAlign: 'center', justifyContent: 'center', marginTop: '20px' }}>
                                                    {(!sh.consolidationStatus && !(sh.repackStatus == 101 || sh.rescanStatus == 101) && !(sh.repackStatus == 105 || sh.rescanStatus == 105) && (sh.shippingStatus == 1 || sh.shippingStatus == 2)) && <Grid container item sm={6}>
                                                <div class="dropdown" style={{ position: "relative", width: "100%", minHeight:"40px" }}>
                                                    <div style={{minHeight:"40px"}} className="redoutline_button red_text col_flex col_space_center row_space_center cursor_pointer" onClick={(e) => {
                                                        if (showExtraServices != shIndex)
                                                            setShowExtraServices(e, shIndex)
                                                        else
                                                            setShowExtraServices(e, -1)
                                                    }}><p>{`שירותים נוספים`}</p></div>
                                                    {showExtraServices == shIndex && <Grid item container style={{ zIndex: "1000", position: "absolute", background: "white", minWidth: "100px", width:"70%", left:"13%", overflow: "auto", boxShadow: "0px 8px 16px 0px rgba(0,0,0,0.2)" }}>
                                                                {(sh.repackStatus != 105 && sh.repackStatus != 101 && sh.repackStatus != 104) && <p onClick={() => { onSelectService(1, sh) }} style={{ cursor: "pointer", margin: "0", width: "100%", marginTop: "5px", marginBottom: "5px", textAlign: "center" }}>{`אריזה מחדש`}</p>}
                                                                {(sh.rescanStatus != 105 && sh.rescanStatus != 101 && sh.rescanStatus != 104) && <p onClick={() => { onSelectService(2, sh) }} style={{ cursor: "pointer", margin: "0", width: "100%", marginTop: "5px", marginBottom: "5px", textAlign: "center" }}>{ `צילום תכולה`}</p>}
                                                    </Grid>}
                                                </div>
                                            </Grid>}

                                                    {sh.shippingStatus > 2 && sh.shippingStatus != 302 ? (sh.repayment ?  <ActionButton onClick={() => {
                                                        // desktop mobile
                                                        showRepayment(sh);
                                            }} textLabel="לתשלום" className='underline-btn fullwidth-btn' /> : <ActionButton onClick={() => {
                                                        // desktop mobile
                                                        showPersonal1(sh);
                                                    }} textLabel="למעקב" className='underline-btn fullwidth-btn' />)
                                                        : (sh.shippingStatus == 302 ? <ActionButton onClick={() => {
                                                            showPersonal1(sh);
                                                        }} textLabel="עדכון חשבונית" className='fullwidth-btn' /> : 
                                                            <ActionButton onClick={() => {
                                                                if ((sh.repackStatus == 0 || sh.repackStatus == 104 || sh.repackStatus == 105 || sh.repackStatus == null) &&
                                                                    (sh.rescanStatus == 0 || sh.rescanStatus == 104 || sh.rescanStatus == 105 || sh.rescanStatus == null)) {
                                                                    if (!userInfo?.user?.setting?.profileId) {
                                                                        onHandleOpenModal()
                                                                    } else {
                                                                        checkForServiceAndOnHold(sh, function (status) {
                                                                            if (!status) {
                                                                                window.location.href = "/accounts?vers=" + (new Date()).getTime();
                                                                                return;
                                                                            }
                                                                            //dispatch(setSelectedShipping(sh));
                                                                            setIsPersonal(true);
                                                                        });
                                                                    }
                                                                }
                                                            }} textLabel="לתשלום" className='fullwidth-btn' />)}
                                        </Grid>
                                    </Grid>}

                                        {!isHistory && (sh.shippingStatus == 6 || sh.status)  && <Grid key={sh.id} container item sm={5.8} className='transaction-card'>
                                            <Grid container item xs={12} className='card-content dir-rtl'>
                                                <Grid container item xs={5} className="right-col">
                                                    <Typography className='text_bold'>{sh.hawb} </Typography>
                                                    <Grid container item xs={12} style={{ alignItems: 'center', justifyContent: 'center' }}>
                                                        <Typography className='text_bold'> {sh.shippingDesc}</Typography>
                                                            </Grid>
                                                            <Grid container item xs={12} style={{ alignItems: 'center', justifyContent: 'center' }}>
                                                                {!sh.params.store && <Typography>{sh.params?.sender?.senderName}</Typography>}
                                                                {sh.params.store && <Typography>{sh.params.store}</Typography>}
                                                            </Grid>
                                                    <Grid container className='loc'>
                                                        <img src={LocMarker} className='marker-icon' alt="" style={{ width: "12px", height: "15px", marginLeft: "5px" }} />
                                                        <Typography >{sh.params?.sender?.senderCountry}</Typography>
                                                    </Grid>
                                                </Grid>
                                                <Grid container item xs={7}>
                                                    <Grid container item xs={12} className='upper-row'>
                                                        <Grid container className='flex-row' >
                                                                    <Typography className='text_bold'>{getNewStatus(sh, getDescByShStatus(sh))}</Typography>
                                                            <img src={payment_pending} style={{ width: "14px", height: "14px", marginRight: '5px' }} />
                                                        </Grid>
                                                                <Typography className="right_text  underscored_text cursor_pointer" onClick={() => showPersonal(sh)}>תאריך עדכון: {getDateFormat(sh.clientStatusDate ? sh.clientStatusDate : sh.date)}</Typography>
                                                    </Grid>
                                                    <Grid container item xs={12} className='lower-row'>
                                                                <Typography className='text_bold'>
                                                                    <span style={{ color: "#FF3452" }} className="cursor_pointer" onClick={() => {
                                                                        onHandleOpenInfoModal(sh);
                                                                    }}>
                                                                        {`פרטי משלוח>`}
                                                                        {/*<img src={info_26} style={{ width: "20px", height: "20px", marginLeft: "5px" }} />*/}
                                                                    </span> {/*{sh.hawb}*/}</Typography>
                                                        <Grid container className='flex-row' onClick={() => {
                                                            copyToClipboard1(sh.hawb, function (data) {
                                                                dispatch(snackbarToggle({ type: 'success', message: data }));
                                                                window.setTimeout(function () { dispatch(snackbarToggle(false)); }, autoCloseSnackbar);
                                                            });
                                                        }}>
                                                            <img src={copy} style={{ width: "12px", height: "14px", marginLeft: "5px" }} />
                                                            <Typography>מספר מעקב</Typography>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                                <Grid container item xs={12} style={{ textAlign: 'center', justifyContent: 'center', marginTop: '20px' }}>
                                                        {sh.shippingStatus > 2 ? <ActionButton onClick={() => {
                                                            showPersonal1(sh);
                                                        }} textLabel="למעקב" className='underline-btn fullwidth-btn' />
                                                    : (!sh.status ? <>{<ActionButton onClick={() => {
                                                        //console.log("check");
                                                        //console.log(sh);
                                                        if ((sh.repackStatus == 0 || sh.repackStatus == 104 || sh.repackStatus == 105 || sh.repackStatus == null) && sh.shippingStatus != 201 && (sh.rescanStatus == 0 || sh.rescanStatus == null || sh.rescanStatus == 104 || sh.rescanStatus == 105)) {
                                                            if (!sh.status) {
                                                                if (!userInfo?.user?.setting?.profileId) {
                                                                    onHandleOpenModal()
                                                                } else {
                                                                    dispatch(setSelectedShipping(sh));
                                                                    setIsPersonal(true);
                                                                }
                                                            }
                                                        }
                                                            }} textLabel="לתשלום" className='fullwidth-btn' />}</> : <></>)}
                                            </Grid>
                                        </Grid>}

                                    </>))}
                            
                        </Grid>}
                    </div>
                    {false && <div className="full_width top_space_80">
                        <div className="width_83 margin_left_833 rtl_text">
                            <div className="full_width_container relative_container" style={{ height: "15.2vw" }}>
                                <div className="absolute_container white_container" style={{ top: 0, left: 0, width: "55vw", height: "11vw" }}>
                                    <div className="margin_right_10 bold_text midx_text bold_text right_text top_space_40">Red Box נותנים לכם כסף!</div>
                                    <div className="margin_right_10 bold_text small_text right_text top_space_10">הזמינו חבר להרשם לשירות של Red Box ושניכם תקבלו 5$ מאיתנו למשלוח הבא!</div>
                                    <div className="margin_right_10 redoutline_button red_text bold_text center_text top_space_20" style={{ padding: "0.5vw", width: "6vw" }}>למידע נוסף</div>
                                </div>
                                <div className="absolute_container" style={{ bottom: 0, right: 0, width: "35vw", height: "10vw" }}>
                                    <img src={woman_bg} style={{ width: "100%", height: "100%", position: "absolute", top: 0, left: "0" }} />
                                    <img src={woman_with_money} style={{ width: "auto", height: "20vw", position: "absolute", bottom: "-0.6vw", left: "27%" }} />
                                </div>
                            </div>
                        </div>
                    </div>}
                    {false && <div className="full_width top_space_40">
                        <div className="width_83 margin_left_833">
                            <div className="full_width_container relative_container" style={{ height: "15.2vw" }} >
                                <div className="absolute_container" style={{ width: "26vw", height: "11vw", bottom: 0, left: 0, zIndex: "2" }} >
                                    <img src={chrome_bg} className="absolute_container" style={{ width: "100%", height: "100%" }} />
                                    <img src={googleChromeIcon} className="absolute_container" style={{ right: "-2vw", bottom: "-0.5vw", width: "17vw", height: "17vw" }} />
                                </div>
                                <div className="absolute_container white_container" style={{ width: "64vw", height: "12vw", top: 0, right: 0, zIndex: 1 }} >
                                    <div className="rtl_text margin_right_10 mid_text top_space_20 bold_text">עדיין אין לכם את התוסף ל-Google Chrome?</div>
                                    <div className="rtl_text margin_right_10 small_text bold_text top_space_10 bot_space_10">בלעדי ל-RedboxParcel,  התוסף החכם שלנו מאפשר מילוי פרטים אוטומטי ותשלום בשקלים ללא עמלת המרה!</div>
                                    <div className="redoutline_button center_text rtl_text red_text float_right margin_right_10 bold_text top_space_10" style={{ width: "15vw" }}><p>להתקנה מחנות האפליקציות</p></div>
                                </div>
                            </div>
                        </div>
                    </div>}
                    {/*<div className="full_width">
                        <h1 className="full_width_container center_text red_text bold_text">החנויות הכי מומלצות</h1>
                        <div className="width_83 margin_left_833">
                            <div className="col-md-3 small_container">
                                <p className="top-right-corner-text">קוסמטיקה</p>
                                <div className="account_outlets_image_container_left bot_space_40">
                                    <img src={prevArrow} className="account_outlets_prev_arrow" />
                                    <img src={sephora} className="account_outlets_image_left" />
                                </div>
                            </div>
                            <div className="col-md-3 small_container">
                                <p className="top-right-corner-text">אלקטרוניקה</p>
                                <div className="account_outlets_image_container_center bot_space_40">
                                    <img src={media_markt} className="account_outlets_image_center" />
                                </div>
                            </div>
                            <div className="col-md-3 small_container">
                                <p className="top-right-corner-text">מרקט פלייס</p>
                                <div className="account_outlets_image_container_center bot_space_40">
                                    <img src={amazon} className="account_outlets_image_center" style={{ marginTop: "30px" }} />
                                </div>
                            </div>
                            <div className="col-md-3 small_container">
                                <p className="top-right-corner-text">מרקט פלייס</p>
                                <div className="account_outlets_image_container_right bot_space_40">
                                    <img src={target} className="account_outlets_image_right" />
                                    <img src={nextArrow} className="account_outlets_next_arrow" />
                                </div>
                            </div>
                        </div>
                    </div>*/}
                        {false&&<Box component={'section'} className="popular-section" style={{ paddingTop: 0 }}>
                        <Box className="container">
                            <Typography component={'h1'} className='section-title'>החנויות הפופולאריות</Typography>
                            <Grid container sx={{ justifyContent: { sm: 'space-between', xs: 'center' } }}>
                                {storeList.map((st, ind) => (<Grid container key={ind} item md={1.9} sm={3.8} xs={5.8} className="shadow_box">
                                    {/* <Grid container className='head' sx={{ flexWrap: "nowrap" }}>
                                        <Box>{st.category}</Box>
                                        <Box><img src={LocMarker} className='marker-icon' alt="" /><span>{st.country}</span></Box>
                                    </Grid> */}
                                    <Grid container className='content'>
                                        <img onClick={() => {
                                            window.open(st.link, "_blank");
                                        }} style={{ maxHeight: "50px" }} src={`/images/shops/${st.id}_logo${getExt(st.params?.fileName_logo)}`} alt='' />
                                    </Grid>
                                    <Grid container className='action'>
                                        <Button className='action-btn underline-btn' onClick={() => {
                                            setSelectedStore(st);
                                            setIsDialog(true);
                                        }}>מעבר לחנות</Button>
                                    </Grid>
                                </Grid>
                                ))}


                            </Grid>
                            <Box className="row set_mid">
                                    <Box className="store_list_button_account" onClick={() => { navigate('/store', { state: { id: 1, name: 'store_list' } }) }}>{`לרשימת כל החנויות`}</Box>
                            </Box>
                        </Box>
                    </Box>}
                    </div>
                    
            </main>
        </Paper>
        <DialogWithSideBar
                open={isDialog}
                isOutClose={true}
                onClose={() => { setIsDialog(false); setBSideWindow(false) }}
            >
                <Box container className="reg_popup_data">
                    <Box item lg={12} className="popup_tittle lg">
                        לפני שאתם עוברים לאתר
                    </Box>
                    <Box item lg={12} className="popup_tittle">
                        <img style={{ height: "30px" }} src={`/images/shops/${selectedStore.id}_logo${getExt(selectedStore.params?.fileName_logo)}`} alt='' />
                    </Box>
                    <Box item lg={12} className="popup_tittle sm">
                        טיפים להזמנה באתר
                    </Box>
                    <Grid container item lg={12} justifyContent="flex-end">
                        <ul className="store_tips">
                            {allWh?.find(u => u.id === selectedStore.params?.wId)?.params?.rightTextList?.map((t, index) => (<>{t && <li key={index}>
                                {t}
                            </li>}</>))}
                        </ul>
                    </Grid>
                   {/* <Box item lg={12} className="popup_tittle" onClick={() => {
                        setBSideWindow(true);
                    }}>

                        <img className="cursor_pointer" style={{ maxWidth: "none", height: "280px" }} src={`data:${selectedStore.params?.right_type};base64,${selectedStore.rightInfo}`} alt='' />
                    </Box>*/}
                   {/* { <Box item lg={12} className="popup_tittle" >
                        <ActionButton type={'submit'} textLabel={`איך למלא את פרטי המשלוח`} onClick={() => {
                            setBSideWindow(true);
                        }} sx={{ height: "50px !important", fontSize:"16px !important" }} />
                    </Box>} */}
                    
                    <Box item lg={12} className="popup_tittle sm anchor" 
                        style={{ position: 'relative', cursor: 'pointer'}} 
                        onClick={() => setBSideWindow(true)}>
                        <img src={store_middle_button} style={{ maxWidth: '110%', marginLeft: '-9%' }} alt={'טיפים להזמנה באתר'} />
                        <label className='btton_label'>{`טיפים להזמנה באתר`}</label>
                    </Box>

                   
                    <Grid justifyContent="center" alignItems="center" style={{ background: "#f6f6f6", borderRadius: "20px", border: "1px solid #e9e9e9", padding: '10px' }}>
                        <div style={{ fontSize: "16px !important", lineHeight: 1.13, padding: "10px" }} className="top_space_20 bot_space_10 redoutline_button red_text col_flex col_space_center row_space_center cursor_pointer bold_text" onClick={() => {

                            if (userInfo.session) {
                                setActiveScreenInreg('PersonalData'); setIsRegister(true);
                            } else {
                                setIsLogin(true)
                            }

                        }} variant={'outlined'}>
                            התחברו וקבלו את הכתובת שלכם
                        </div>
                        <Box className="bot_space_20 center_text cursor_pointer" onClick={() => {
                            if (userInfo.session) {
                                setActiveScreenInreg('PersonalData'); setIsRegister(true);
                            } else {
                                setActiveScreenInreg('Registeration'); setIsRegister(true);
                            }
                        }}>
                            <span className="">
                                עדיין לא נרשמתם? <span style={{ fontWeight: "bold" }}>הירשמו בחינם וקבלו כתובת לקניות בחו"ל &gt;</span>
                            </span>
                        </Box>
                    </Grid>
                    <Box className='form-action'>
                        <ActionButton type={'submit'} className={'submit-action'} textLabel={`${selectedStore.name} המשך לאתר`} onClick={() => {
                            window.open(selectedStore.link, "_blank")
                        }} />
                    </Box>
                </Box>
                {bSideWindow && <Box className="reg_popup_data left-side">
                    <Grid container item lg={1} justifyContent="flex-start" alignContent="flex-end" sx={{ mt: '2vh !important', fontSize: "24px", fontWeight: "bold", color: "#FF3452", cursor: "pointer" }} onClick={() => { setBSideWindow(false) }}>
                        <img src={top_back} className="flag_img" style={{ width: "40px" }} />
                    </Grid>

                    <Box item lg={12} className="popup_tittle lg">
                        טיפים לרישום וקנייה באתר זה
                    </Box>
                    <Grid container item lg={12} justifyContent="flex-end" sx={{padding:"3rem !important", paddingBottom:"0 !important"}}>
                        <ul className="store_tips">
                            {selectedStore.params?.textList?.map((t, index) => (<>{t && <li key={index}>
                                {t}
                            </li>}</>))}
                        </ul>
                    </Grid>
                    <Grid container item lg={11} justifyContent="center" alignContent="center" sx={{ color: '#FF3452', fontSize: "14px", fontWeight: "bold" }}>
                        <img src={`/images/shops/${selectedStore.id}_left${getExt(selectedStore.params?.fileName_left)}`} alt='' />
                    </Grid>

                </Box>}
            </DialogWithSideBar>
        </>
    );
}

export default Accounts;